import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Upload: any;
};

export type AccessRight = {
  __typename?: 'accessRight';
  role: Array<RoleAccessRight>;
  user: Array<UserAccessRight>;
};

export type AccessRightInput = {
  role: Array<RoleAccessRightInput>;
  user: Array<UserAccessRightInput>;
};

export type AccessTokenInterface = {
  __typename?: 'AccessTokenInterface';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type AccountSpecEntity = {
  __typename?: 'accountSpecEntity';
  accountCode?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  axIntegrationAccessToken?: Maybe<Scalars['String']>;
  axIntegrationSecretKey?: Maybe<Scalars['String']>;
  defaultChequeExpiryInterval?: Maybe<Scalars['Float']>;
  einvConsolidationRowLimit?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  integrationAutoCapitalize: Scalars['Boolean'];
  is2FA: Scalars['Boolean'];
  isPriceRounding: Scalars['Boolean'];
  leadAssignmentActivated: Scalars['Boolean'];
  loanPlusInfo: Scalars['JSONObject'];
  loanPlusProjectId?: Maybe<Scalars['Float']>;
  metaSetting?: Maybe<Scalars['JSONObject']>;
  openLeadEmailRequired: Scalars['Boolean'];
  projectIntegration?: Maybe<Array<ProjectIntegrationEntity>>;
  purchaserAccountRef?: Maybe<PurchaserAccountReferenceEntity>;
  purchaserAppCss?: Maybe<PurchaserAppCssOutput>;
  smptInfo?: Maybe<SmtpInfoOutput>;
  unitColorTheme?: Maybe<UnitColorThemeOutput>;
};

export type ActiveLoanStatusOutput = {
  __typename?: 'ActiveLoanStatusOutput';
  assignedCount: Scalars['Float'];
  count: Scalars['Float'];
  docsSubmittedCount: Scalars['Float'];
  loanAppealedCount: Scalars['Float'];
  loanDocSignedCount: Scalars['Float'];
  loanIssuedCount: Scalars['Float'];
  loanSignedCount: Scalars['Float'];
  openCount: Scalars['Float'];
  pendingDocsCount: Scalars['Float'];
  unassignedCount: Scalars['Float'];
  unreachableCount: Scalars['Float'];
};

/** JsonType */
export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  AddressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  postCodeName?: InputMaybe<Scalars['String']>;
  siteName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type AddressJson = {
  __typename?: 'AddressJson';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  AddressType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AddressJsonInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  AddressType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  postCode?: InputMaybe<Scalars['String']>;
  postCodeName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  Delivery = 'DELIVERY',
  Primary = 'PRIMARY',
  Site = 'SITE'
}

export type AddStaffInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type AgencyAppointedCount = {
  __typename?: 'agencyAppointedCount';
  lastAppointedDate?: Maybe<Scalars['DateTime']>;
  totalAppointed?: Maybe<Scalars['Float']>;
};

export type AgencyAppointedEntity = AuditEntity & {
  __typename?: 'agencyAppointedEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  agencyContract: Array<AgencyContractEntity>;
  agencyContractProjectCount?: Maybe<Scalars['Float']>;
  agencyId?: Maybe<Scalars['String']>;
  agencyUnitCounts?: Maybe<AgentUnitCounts>;
  agentNegotiator: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhoneNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  invitationLink: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel: Scalars['String'];
  pictureBlockUrl?: Maybe<Scalars['String']>;
  projectAgencyDiscounts?: Maybe<Array<ProjectAgencyDiscountEntity>>;
  projectAgencyPackages?: Maybe<Array<ProjectAgencyPackageEntity>>;
  projectAgencyRebates?: Maybe<Array<ProjectAgencyRebateEntity>>;
  sales?: Maybe<Array<SaleEntity>>;
};


export type AgencyAppointedEntityAgencyUnitCountsArgs = {
  projectId: Scalars['String'];
};


export type AgencyAppointedEntityPictureBlockUrlArgs = {
  block: Scalars['String'];
};

export type AgencyContactEntity = AuditEntity & {
  __typename?: 'agencyContactEntity';
  agencyAppointed: AgencyAppointedEntity;
  agencyUserRole: AgencyUserRoleEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  getLangMasterData: Array<LanguageNamesOutput>;
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  languageSet: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  reportingTo?: Maybe<Scalars['String']>;
  reportingToUserId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user: AgencyUserEntity;
  userId: Scalars['String'];
  userLanguageChoose: LanguageOutput;
};

export type AgencyContractEntity = AuditEntity & {
  __typename?: 'agencyContractEntity';
  accountId: Scalars['String'];
  agency: AgencyAppointedEntity;
  agencyId: Scalars['String'];
  allocatedUnitId: Array<Scalars['String']>;
  allowPreBooking: Scalars['Boolean'];
  allowUpdateLoanStatus: Scalars['Boolean'];
  allowWaitinglist: Scalars['Boolean'];
  attachment?: Maybe<Array<AttachmentEntity>>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isDiscountAllocated: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  isPackageAllocated: Scalars['Boolean'];
  isRebateAllocated: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  specialDiscountEnabled: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
};

export type AgencyEntity = AuditEntity & {
  __typename?: 'agencyEntity';
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
};

export type AgencyLeadNotificationInput = {
  loanAssignment?: InputMaybe<LoanAssignmentInput>;
};

export type AgencyLeadNotificationOutput = {
  __typename?: 'AgencyLeadNotificationOutput';
  loanAssignment?: Maybe<LoanAssignmentOutput>;
};

export type AgencyNotificationEntity = {
  __typename?: 'agencyNotificationEntity';
  accountId: Scalars['String'];
  agencyNotificationRecipient: Array<AgencyNotificationRecipientEntity>;
  body: Scalars['String'];
  id: Scalars['String'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
};

export type AgencyNotificationPolicyEntity = {
  __typename?: 'agencyNotificationPolicyEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notificationDuration: Scalars['Float'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type AgencyNotificationRecipientEntity = AuditEntity & {
  __typename?: 'agencyNotificationRecipientEntity';
  accountId: Scalars['String'];
  agencyNotification: AgencyNotificationEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
};

export type AgencySalesChartOutput = {
  __typename?: 'agencySalesChartOutput';
  coordinates: Scalars['String'];
  price: Scalars['Float'];
  status?: Maybe<Scalars['String']>;
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_status: Scalars['String'];
  unit_type: Scalars['String'];
};

export type AgencyUnitAllocationEntity = AuditEntity & {
  __typename?: 'agencyUnitAllocationEntity';
  accountId: Scalars['String'];
  agency: AgencyEntity;
  agencyId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type AgencyUserEntity = AuditEntity & {
  __typename?: 'agencyUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  passwordHash?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type AgencyUserRoleEntity = AuditEntity & {
  __typename?: 'agencyUserRoleEntity';
  agency: AgencyEntity;
  agencyId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  reportPerson: AgencyUserEntity;
  reportPersonId?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  user: AgencyUserEntity;
  userId: Scalars['String'];
};

export type AgentPermissionEntity = AuditEntity & {
  __typename?: 'agentPermissionEntity';
  agency: AgencyEntity;
  agencyContact?: Maybe<AgencyContactEntity>;
  agencyId: Scalars['String'];
  agencyUser: AgencyUserEntity;
  agencyUserId: Scalars['String'];
  allowBook: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type AgentUnitCounts = {
  __typename?: 'agentUnitCounts';
  allocatedunit?: Maybe<Scalars['Float']>;
  bookedunit?: Maybe<Scalars['Float']>;
  spasignedunit?: Maybe<Scalars['Float']>;
};

export type AllocationEntity = {
  __typename?: 'allocationEntity';
  accountId: Scalars['String'];
  allocateAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  contra?: Maybe<ContraEntity>;
  creditId: Scalars['String'];
  creditNote?: Maybe<CreditNoteEntity>;
  creditRefTable: Scalars['String'];
  debitId: Scalars['String'];
  debitNote?: Maybe<DebitNoteEntity>;
  debitRefTable: Scalars['String'];
  financialBillingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interest?: Maybe<InterestBillingEntity>;
  miscBilling?: Maybe<MiscBillingEntity>;
  progressBilling?: Maybe<ProgressBillingEntity>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  rebate?: Maybe<RebateEntity>;
  receipt?: Maybe<ReceiptEntity>;
  refund?: Maybe<RefundEntity>;
  refundReversal?: Maybe<RefundReversalEntity>;
};

export type AllStandardCoreBaseEntity = StandardAuditEntity & {
  __typename?: 'AllStandardCoreBaseEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type Amenities = {
  __typename?: 'Amenities';
  category: Scalars['String'];
  items: Array<Scalars['String']>;
};

export type AmenitiesInput = {
  category: Scalars['String'];
  items: Array<Scalars['String']>;
};

export type AppointmentEntity = {
  __typename?: 'AppointmentEntity';
  accountId: Scalars['String'];
  appointmentDate: Scalars['DateTime'];
  appointmentPurpose: AppointmentTypeEntity;
  appointmentTypeId: Scalars['String'];
  commonStatus: Scalars['String'];
  contactId: Scalars['String'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  lead: LeadContactEntity;
  leadId: Scalars['String'];
  leadSourceFromLead?: Maybe<LeadEntity>;
  needManagerAssistant: Scalars['Boolean'];
  participantLimit: Scalars['Float'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  remarks: Scalars['String'];
  salePerson: SUserEntity;
  salesPersonId: Scalars['String'];
  salesPersonOrigin: Scalars['String'];
  saleTeam: SaleTeamEntity;
  startTime: Scalars['String'];
  teamId: Scalars['String'];
};

export type AppointmentSchedulingEntity = {
  __typename?: 'appointmentSchedulingEntity';
  accountId: Scalars['String'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  participantLimit: Scalars['Float'];
  projectId: Scalars['String'];
  salesGalleryCloseDate: Array<SalesGalleryCloseDateEntity>;
  startTime: Scalars['String'];
};

export type AppointmentTypeEntity = {
  __typename?: 'AppointmentTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo: Scalars['Float'];
  systemUse: Scalars['Boolean'];
};

/** JsonType */
export type ApprovalListJson = {
  __typename?: 'ApprovalListJson';
  predicate?: Maybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleName?: Maybe<Scalars['String']>;
  stepNo: Scalars['Float'];
};

export type ApprovalListJsonInput = {
  predicate?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleName?: InputMaybe<Scalars['String']>;
  stepNo: Scalars['Float'];
};

export type ApprovalPolicyAssignmentEntity = {
  __typename?: 'approvalPolicyAssignmentEntity';
  accountId: Scalars['String'];
  approvalList: Array<ApprovalListJson>;
  category: Scalars['String'];
  commonStatus: Scalars['String'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
};

export type ApprovalPolicyEntity = {
  __typename?: 'approvalPolicyEntity';
  accountId: Scalars['String'];
  approvalList: Array<ApprovalListJson>;
  category: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
};

export type ArchitectCertEntity = {
  __typename?: 'architectCertEntity';
  accountId: Scalars['String'];
  architectCertUnit?: Maybe<Array<ArchitectCertUnitEntity>>;
  architectCertWorkProgress?: Maybe<Array<ArchitectCertWorkProgressEntity>>;
  certificateDate: Scalars['DateTime'];
  certificateNo: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
};

export type ArchitectCertUnitEntity = {
  __typename?: 'architectCertUnitEntity';
  accountId: Scalars['String'];
  architectCert: ArchitectCertEntity;
  architectCertId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  status: Scalars['String'];
  unitId: Scalars['String'];
  units?: Maybe<UnitEntity>;
};

export type ArchitectCertWorkProgressEntity = {
  __typename?: 'architectCertWorkProgressEntity';
  accountId: Scalars['String'];
  architectCertId: Scalars['String'];
  architectCerts: ArchitectCertEntity;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  paymentPlanDetail?: Maybe<Array<PaymentPlanDetailEntity>>;
  progress: Array<WorkProgressEntity>;
  projectId: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type AreaVarianceEntity = AuditEntity & {
  __typename?: 'areaVarianceEntity';
  accountId: Scalars['String'];
  actualBuiltUp: Scalars['Float'];
  actualLandArea?: Maybe<Scalars['Float']>;
  areaVarianceThreshold?: Maybe<Scalars['Float']>;
  billItemId?: Maybe<Scalars['String']>;
  builtUp: Scalars['Float'];
  commonStatus: Scalars['String'];
  compensateAmount: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  formula: Scalars['String'];
  id: Scalars['String'];
  isEinvoice: Scalars['Boolean'];
  landArea?: Maybe<Scalars['Float']>;
  miscBilling?: Maybe<MiscBillingEntity>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  rebate?: Maybe<RebateEntity>;
  refId?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type AssignedBatchDetails = {
  __typename?: 'AssignedBatchDetails';
  batch_id: Scalars['String'];
  batch_title: Scalars['String'];
  countLeadSource?: Maybe<LeadBatchCountLeadSourceOutput>;
  createdTs?: Maybe<Scalars['DateTime']>;
  isRoundRobinUser?: Maybe<Scalars['Boolean']>;
  projects?: Maybe<Array<AssignedProjectDetails>>;
  record_count: Scalars['Float'];
};

export type AssignedProjectDetails = {
  __typename?: 'AssignedProjectDetails';
  assigned_date: Scalars['DateTime'];
  batch_id: Scalars['String'];
  lead_count: Scalars['Float'];
  project_name: Scalars['String'];
};

export type AttachmentEntity = AuditEntity & {
  __typename?: 'attachmentEntity';
  accountId: Scalars['String'];
  allowDelete?: Maybe<Scalars['Boolean']>;
  bucketFileName: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  mediaType: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refColumn: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  refType: Scalars['String'];
  resourceUrl: Scalars['String'];
  saleId?: Maybe<Scalars['String']>;
  seqNo: Scalars['Float'];
  signedResourceUrl: Scalars['String'];
  softwareCode: Scalars['String'];
};

export type AttachmentOutput = {
  __typename?: 'AttachmentOutput';
  brochureUrl?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type AuditEntity = {
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type AutoReleaseNotificationReminderInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  reminderDay?: InputMaybe<Scalars['Float']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type AutoReleaseNotificationReminderOutput = {
  __typename?: 'autoReleaseNotificationReminderOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  reminderDay?: Maybe<Scalars['Float']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type BankAccountEntity = {
  __typename?: 'bankAccountEntity';
  accountHolder?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  accountNo: Scalars['String'];
  bankClearance?: Maybe<Scalars['String']>;
  bankProfile: BankProfileEntity;
  bankProfileId?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  collection?: Maybe<Array<ReceiptEntity>>;
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  companyId: Scalars['String'];
  currency?: Maybe<CurrencyEntity>;
  currencyId?: Maybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  glAccountCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCash?: Maybe<Scalars['Boolean']>;
  isKeyCardCash?: Maybe<Scalars['Boolean']>;
  isSecurityCash?: Maybe<Scalars['Boolean']>;
  masterCoaId?: Maybe<Scalars['String']>;
  projectExt: Array<ProjectExtEntity>;
  q3RevenueMapping?: Maybe<Scalars['String']>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  swiftCode?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type BankEntity = {
  __typename?: 'bankEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  financier: Array<FinancierEntity>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BankProfileEntity = {
  __typename?: 'bankProfileEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  bankAccount: Array<BankAccountEntity>;
  commonStatus: Scalars['String'];
  contactNo?: Maybe<Scalars['String']>;
  contactPerson: Array<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  projectExt: Array<ProjectExtEntity>;
};

export type BaseInput = {
  commonStatus?: InputMaybe<CommonStatus>;
  createdBy?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
};

export type BillItemEntity = {
  __typename?: 'billItemEntity';
  accountId: Scalars['String'];
  billItemType: Scalars['String'];
  classificationId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  creditTerm?: Maybe<Scalars['Float']>;
  einvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  msicId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
  taxScheme?: Maybe<TaxSchemeEntity>;
  taxSchemeId?: Maybe<Scalars['String']>;
};

export type BiSummaryOutput = {
  __typename?: 'BISummaryOutput';
  bookingListBISummary: BookingListBiSummaryOutput;
  campaignBISummary: Scalars['Float'];
  leadSourceBISummary: Scalars['Float'];
  loanBISummary: LoanBiSummaryOutput;
  paymentMethodBISummary: PaymentMethodBiSummaryOutput;
  projectSalesPerformanceBISummary: ProjectSalesPerformanceBiSummaryOutput;
  salesLeadPerformanceBISummary: SalesLeadPerformanceBiOutput;
  salesMovementBISummary: Array<SalesMovementBiSummaryOutput>;
  salesTeamPerformanceBISummary: SalesTeamPerformanceBiSummaryOutput;
  waitingListBISummary: WaitingListBiSummaryOutput;
};

export type BlockCountByStatusOutput = {
  __typename?: 'BlockCountByStatusOutput';
  availableUnitCount: Scalars['Float'];
  block?: Maybe<Scalars['String']>;
  bookUnitCount: Scalars['Float'];
  reservationUnitCount?: Maybe<Scalars['Float']>;
  signUnitCount: Scalars['Float'];
  totalUnitCount: Scalars['Float'];
  unavailableUnitCount: Scalars['Float'];
};

export type BookingAnalysisBiOutput = {
  __typename?: 'BookingAnalysisBIOutput';
  cancelCount?: Maybe<Scalars['Float']>;
  cancelRate?: Maybe<Scalars['Float']>;
  leadSources?: Maybe<Array<BookingAnalysisSourceListBiOutput>>;
  signCount?: Maybe<Scalars['Float']>;
  signRate?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BookingAnalysisSourceListBiOutput = {
  __typename?: 'BookingAnalysisSourceListBIOutput';
  leadSourceCount?: Maybe<Scalars['Float']>;
  leadSourceName: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type BookingAttachmentsOutput = {
  __typename?: 'bookingAttachmentsOutput';
  bookingCcrAttachments?: Maybe<Array<AttachmentEntity>>;
  bookingFeeAttachments?: Maybe<Array<AttachmentEntity>>;
  bookingNricAttachments?: Maybe<Array<AttachmentEntity>>;
  bookingPdpaAttachments: Array<AttachmentEntity>;
  projectLetterAttachments: Array<ESignProjectLetterListingOutput>;
  solicitorAgreementAttachments: Array<AttachmentEntity>;
  solicitorOthersAttachments: Array<AttachmentEntity>;
};

export type BookingBiOutput = {
  __typename?: 'BookingBIOutput';
  agency: BookingListDetailBiOutput;
  cancelCount?: Maybe<Scalars['Float']>;
  cancelRate?: Maybe<Scalars['Float']>;
  direct: BookingListDetailBiOutput;
  lead: BookingListDetailBiOutput;
  signCount?: Maybe<Scalars['Float']>;
  signRate?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BookingCancellationNotificationInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  purchaserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type BookingCancellationNotificationOutput = {
  __typename?: 'BookingCancellationNotificationOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type BookingConfirmationStatusOutput = {
  __typename?: 'BookingConfirmationStatusOutput';
  cancelledCount: Scalars['Float'];
  eLaunchAppCount: Scalars['Float'];
  integrationCount: Scalars['Float'];
  pendingCount?: Maybe<Scalars['Float']>;
  purchaserAppCount: Scalars['Float'];
  reservationCount: Scalars['Float'];
  total: Scalars['Float'];
};

export type BookingLeadsOutput = {
  __typename?: 'BookingLeadsOutput';
  contact_id: Scalars['String'];
  email: Scalars['String'];
  full_name: Scalars['String'];
  ic_no?: Maybe<Scalars['String']>;
  lead_id?: Maybe<Scalars['String']>;
  lead_source_id?: Maybe<Scalars['String']>;
  military_ic?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
};

export type BookingListBiSummaryOutput = {
  __typename?: 'BookingListBISummaryOutput';
  signed_count?: Maybe<Scalars['Float']>;
  signed_rate?: Maybe<Scalars['Float']>;
  total_booking_count?: Maybe<Scalars['Float']>;
};

export type BookingListDataOutput = {
  __typename?: 'BookingListDataOutput';
  agentPersonName?: Maybe<Scalars['String']>;
  bookingRemark?: Maybe<Scalars['String']>;
  builtUp: Scalars['String'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerCompanyRegNo?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  buyerNric: Scalars['String'];
  buyerPhoneNo?: Maybe<Scalars['String']>;
  cancelledByName?: Maybe<Scalars['String']>;
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledReason?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  listPrice: Scalars['String'];
  paidAmount?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleDate: Scalars['DateTime'];
  salePaymentId?: Maybe<Scalars['String']>;
  salePaymentStatus?: Maybe<Scalars['String']>;
  salePersonName?: Maybe<Scalars['String']>;
  salesId: Scalars['String'];
  salesNo: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['String'];
  unitId: Scalars['String'];
  unitLayout?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
};

export type BookingListDetailBiOutput = {
  __typename?: 'BookingListDetailBIOutput';
  existingAmount?: Maybe<Scalars['Float']>;
  existingCount?: Maybe<Scalars['Float']>;
  newAmount?: Maybe<Scalars['Float']>;
  newCount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BookingListLoanScreeningOutput = {
  __typename?: 'BookingListLoanScreeningOutput';
  caseCode: Scalars['String'];
  CCRIS?: Maybe<Scalars['String']>;
  CTOS?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type BookingNotificationInput = {
  assignmentAgencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  assignmentPurchaserReceive?: InputMaybe<Scalars['Boolean']>;
  assignmentSalesUserReceive?: InputMaybe<Scalars['Boolean']>;
  attachBookingAttachment?: InputMaybe<Scalars['Boolean']>;
  attachTr?: InputMaybe<Scalars['Boolean']>;
};

export type BookingNotificationOutput = {
  __typename?: 'BookingNotificationOutput';
  assignmentAgencyUserReceive?: Maybe<Scalars['Boolean']>;
  assignmentPurchaserReceive?: Maybe<Scalars['Boolean']>;
  assignmentSalesUserReceive?: Maybe<Scalars['Boolean']>;
  attachBookingAttachment?: Maybe<Scalars['Boolean']>;
  attachTr?: Maybe<Scalars['Boolean']>;
};

export type BookingWaitlistEntity = {
  __typename?: 'bookingWaitlistEntity';
  accountId: Scalars['String'];
  agency?: Maybe<UserEntity>;
  agencyAcctId?: Maybe<Scalars['String']>;
  agentPersonId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
  leaveTime?: Maybe<Scalars['DateTime']>;
  project: ProjectEntity;
  queueTime: Scalars['DateTime'];
  reason?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  salesPerson?: Maybe<UserEntity>;
  salesPersonId: Scalars['String'];
  seqno: Scalars['Float'];
  team: SaleTeamEntity;
  teamId: Scalars['String'];
  unit: UnitEntity;
};

export type BookStatusOutput = {
  __typename?: 'BookStatusOutput';
  bookedCount?: Maybe<Scalars['Float']>;
  cancelledCount?: Maybe<Scalars['Float']>;
  reserveCount?: Maybe<Scalars['Float']>;
  signedCount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalSellingPrice?: Maybe<Scalars['Float']>;
};

export type BridgingFinancierEntity = {
  __typename?: 'bridgingFinancierEntity';
  accountId: Scalars['String'];
  bridgingFinancierUnit: Array<BridgingFinancierUnitEntity>;
  chargeExecutionType: Scalars['String'];
  chargeExecutionValue: Scalars['Float'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectBridgingFinancier: Array<ProjectBridgingFinancierEntity>;
  projectBridgingFinancierId: Scalars['String'];
  projectId: Scalars['String'];
};

export type BridgingFinancierUnitEntity = {
  __typename?: 'bridgingFinancierUnitEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  bridgingFinancier: BridgingFinancierEntity;
  bridgingFinancierId: Scalars['String'];
  commonStatus: Scalars['String'];
  finalRedemptionDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type BudgetRevenueEntity = {
  __typename?: 'BudgetRevenueEntity';
  accountId: Scalars['String'];
  budgetAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  glAccountPeriodId: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  unsoldGDV: Scalars['Float'];
};

export type CampaignEntity = {
  __typename?: 'campaignEntity';
  accountId: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  events: Array<EventsEntity>;
  id: Scalars['String'];
  name: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  saleRebatePackage: SaleRebatePackageEntity;
  startDate: Scalars['DateTime'];
};

export type CityMasterDataOutput = {
  __typename?: 'CityMasterDataOutput';
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
};

export type CloudStorageOutput = {
  __typename?: 'CloudStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  MediaType: Scalars['String'];
  PrivateUrl?: Maybe<Scalars['String']>;
  Url: Scalars['String'];
};

export type CollectionActivityEntity = {
  __typename?: 'collectionActivityEntity';
  accountId: Scalars['String'];
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  activityStatus: Scalars['String'];
  commonStatus: Scalars['String'];
  completedDate: Scalars['DateTime'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export enum CommonStatus {
  Active = 'ACTIVE',
  Block = 'BLOCK',
  Inactive = 'INACTIVE'
}

export type CompanyArAgingPolicyEntity = {
  __typename?: 'companyArAgingPolicyEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  companyId: Scalars['String'];
  id: Scalars['String'];
  period1: Scalars['Float'];
  period2: Scalars['Float'];
  period3: Scalars['Float'];
  period4: Scalars['Float'];
  period5: Scalars['Float'];
  period6: Scalars['Float'];
};

export type CompanyEntity = {
  __typename?: 'companyEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  bankAccount: Array<BankAccountEntity>;
  baseCurrencyId: Scalars['String'];
  code: Scalars['String'];
  companyArAgingPolicy?: Maybe<CompanyArAgingPolicyEntity>;
  companyRegNo?: Maybe<Scalars['String']>;
  companyTax?: Maybe<CompanyTax>;
  consolidatedLimitDetail?: Maybe<Array<ConsolidatedLimitDetailJson>>;
  contactNo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  development: ProjectEntity;
  eInvClientId?: Maybe<Scalars['String']>;
  eInvClientSecret?: Maybe<Scalars['String']>;
  eInvClientSecret2?: Maybe<Scalars['String']>;
  eInvEndDate?: Maybe<Scalars['DateTime']>;
  eInvStartDate?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  groupGstRegNo?: Maybe<Scalars['String']>;
  gstExpiryDate?: Maybe<Scalars['DateTime']>;
  gstNo?: Maybe<Scalars['String']>;
  holding: ProjectEntity;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  imageBucketFile?: Maybe<Scalars['String']>;
  imageLogoPosition?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isEinvIntegrated: Scalars['Boolean'];
  isoImplementation?: Maybe<Scalars['Boolean']>;
  isoLogoPosition?: Maybe<Scalars['String']>;
  isPaymentRounding: Scalars['Boolean'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  sstNo?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  tourismTaxNo?: Maybe<Scalars['String']>;
  township: Array<TownshipEntity>;
  watermarkImplementation?: Maybe<Scalars['Boolean']>;
  watermarkWording?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type CompanyMsicAssignmentEntity = AuditEntity & {
  __typename?: 'CompanyMsicAssignmentEntity';
  accountID: Scalars['String'];
  companyID: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eInvoiceMsicCode: EInvoiceMsicEntity;
  eInvoiceMsicCodeID: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CompanyNumberSetupEntity = {
  __typename?: 'companyNumberSetupEntity';
  accountId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  id: Scalars['String'];
  nextNumber: Scalars['Float'];
  numberFormat: NumberFormatEntity;
  numberFormatId: Scalars['String'];
};

export enum CompanyTax {
  GstNo = 'GST_NO',
  NoTax = 'NO_TAX',
  SstNo = 'SST_NO'
}

export type ConsolidatedLimitDetailInput = {
  Amount?: InputMaybe<Scalars['Float']>;
  EffectiveDate?: InputMaybe<Scalars['String']>;
};

export type ConsolidatedLimitDetailJson = {
  __typename?: 'ConsolidatedLimitDetailJson';
  Amount?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['String']>;
};

export type Contact = {
  __typename?: 'Contact';
  contactId: Scalars['String'];
  contactInfo?: Maybe<FinancierContactEntity>;
  date?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  link: Scalars['String'];
};

export type ContactAddressEntity = {
  __typename?: 'contactAddressEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  contact: ContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
};

export type ContactEntity = {
  __typename?: 'contactEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<ContactAddressEntity>>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  commonStatus: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  contactAddress?: Maybe<Array<AddressJson>>;
  contactExt?: Maybe<ContactExtensionEntity>;
  designation?: Maybe<ParameterEntity>;
  dob?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  isPurchaserRegisted?: Maybe<Scalars['Boolean']>;
  jointBuyer?: Maybe<JointBuyerEntity>;
  jointBuyers: Array<JointBuyerEntity>;
  jointBuyerSignature?: Maybe<Scalars['String']>;
  leads?: Maybe<Array<LeadEntity>>;
  maritalStatus?: Maybe<MaritalStatusEntity>;
  militaryIc?: Maybe<Scalars['String']>;
  nationality?: Maybe<SNationalityEntity>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  race?: Maybe<RaceEntity>;
  sales: Array<SaleEntity>;
  salutation?: Maybe<SalutationEntity>;
  signatureUrl?: Maybe<Scalars['String']>;
  spouse?: Maybe<ContactEntity>;
  subsales: Array<SubsaleEntity>;
};


export type ContactEntityLeadsArgs = {
  project_id?: InputMaybe<Scalars['String']>;
};

export type ContactExtensionEntity = AuditEntity & {
  __typename?: 'contactExtensionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact?: Maybe<ContactEntity>;
  contactId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  customerOrigin: Scalars['String'];
  einvoiceRequired: Scalars['Boolean'];
  id: Scalars['String'];
  identityType: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isForeignPurchase: Scalars['Boolean'];
  isVip: Scalars['Boolean'];
  mailingMethod: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  sstNo?: Maybe<Scalars['String']>;
  subscribeMaterialEmail: Scalars['Boolean'];
  subscribeMaterialPaNews: Scalars['Boolean'];
  subscribeMaterialSms: Scalars['Boolean'];
  subscribeMaterialWhatsapp: Scalars['Boolean'];
  tin?: Maybe<Scalars['String']>;
};

/** JsonType */
export type ContactPerson = {
  __typename?: 'ContactPerson';
  associateID?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  docRefTable?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  associateID?: InputMaybe<Scalars['String']>;
  contactNo?: InputMaybe<Scalars['String']>;
  designation?: InputMaybe<Scalars['String']>;
  docRefTable?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ContactsListByProjectOutput = {
  __typename?: 'ContactsListByProjectOutput';
  contactId: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  isPbqIncomplete?: Maybe<Scalars['Boolean']>;
  leaveDate?: Maybe<Scalars['DateTime']>;
  leavereason?: Maybe<Scalars['String']>;
  leftSalesPerson?: Maybe<Scalars['String']>;
  leftTeamName?: Maybe<Scalars['String']>;
  queueDate: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  seqno: Scalars['Float'];
  staffName?: Maybe<Scalars['String']>;
  teamName?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type ContactsListOutput = {
  __typename?: 'ContactsListOutput';
  fullName: Scalars['String'];
  id: Scalars['String'];
  seqNo: Scalars['Float'];
  staffName?: Maybe<Scalars['String']>;
};

export type ContraEntity = {
  __typename?: 'contraEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  requestedBy?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type CoreBaseEntity = AuditEntity & {
  __typename?: 'CoreBaseEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CountryMasterDataOutput = {
  __typename?: 'CountryMasterDataOutput';
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type CountWaitingUnitOutput = {
  __typename?: 'CountWaitingUnitOutput';
  activeUnits?: Maybe<Scalars['Float']>;
  leaveQueue?: Maybe<Scalars['Float']>;
  waitList?: Maybe<Scalars['Float']>;
};

export type CreateAuditInput = {
  createdBy?: InputMaybe<Scalars['String']>;
};

export type CreditCardTypeEntity = {
  __typename?: 'creditCardTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
  sequence: Scalars['Float'];
};

export type CreditNoteDocRefEntity = {
  __typename?: 'creditNoteDocRefEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  creditNoteId: Scalars['String'];
  creditNoteTable: Scalars['String'];
  docRefId: Scalars['String'];
  docRefTable: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreditNoteEntity = {
  __typename?: 'creditNoteEntity';
  accountId: Scalars['String'];
  adjustDocumentReference?: Maybe<Scalars['String']>;
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  isReversal: Scalars['Boolean'];
  isWorkFlow: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type CurrencyEntity = {
  __typename?: 'currencyEntity';
  bankAccount: Array<BankAccountEntity>;
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  format: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type CurrencyExchangeRateEntity = {
  __typename?: 'currencyExchangeRateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  currencyLog?: Maybe<Array<CurrencyLogObject>>;
  exchangeRate: Scalars['Float'];
  fromAmt: Scalars['Float'];
  fromCurrencyCode: Scalars['String'];
  id: Scalars['String'];
  toAmt: Scalars['Float'];
  toCurrencyCode: Scalars['String'];
};

export type CurrencyLogInput = {
  exchange_rate: Scalars['Float'];
  from_amt: Scalars['Float'];
  modifiedBy: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
  modifiedName: Scalars['String'];
  to_amt: Scalars['Float'];
};

/** JsonType */
export type CurrencyLogObject = {
  __typename?: 'currencyLogObject';
  exchange_rate: Scalars['Float'];
  from_amt: Scalars['Float'];
  modifiedBy: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
  modifiedName: Scalars['String'];
  to_amt: Scalars['Float'];
};

export type DataSource = {
  __typename?: 'DataSource';
  Columns?: Maybe<Array<Scalars['String']>>;
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  DynamicFilterColumn?: Maybe<Scalars['String']>;
  IsMainQuery?: Maybe<Scalars['Boolean']>;
  IsStoreProcedure?: Maybe<Scalars['Boolean']>;
};

export type DataSourceInput = {
  Columns?: InputMaybe<Array<Scalars['String']>>;
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  DynamicFilterColumn?: InputMaybe<Scalars['String']>;
  IsMainQuery?: InputMaybe<Scalars['Boolean']>;
  IsStoreProcedure?: InputMaybe<Scalars['Boolean']>;
};

export type DebitNoteDocRefEntity = {
  __typename?: 'debitNoteDocRefEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  debitNoteId: Scalars['String'];
  debitNoteTable: Scalars['String'];
  docRefId: Scalars['String'];
  docRefTable: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
};

export type DebitNoteEntity = {
  __typename?: 'debitNoteEntity';
  accountId: Scalars['String'];
  adjustDocumentReference?: Maybe<Scalars['String']>;
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  isIncludeHoliday: Scalars['Boolean'];
  isReversal: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type DeemCollectionDetailEntity = {
  __typename?: 'deemCollectionDetailEntity';
  accountId: Scalars['String'];
  collectionDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  deemCollection: DeemCollectionEntity;
  deemCollectionId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentNo: Scalars['String'];
  dueDate: Scalars['DateTime'];
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  isVoid: Scalars['Boolean'];
  projectId: Scalars['String'];
  refVoidId?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  stakeholderProcess: StakeholderProcessEntity;
  stakeholderProcessId: Scalars['String'];
  stakeholderProcessReleaseDetail: Array<StakeholderProcessReleaseDetailEntity>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type DeemCollectionEntity = {
  __typename?: 'deemCollectionEntity';
  accountId: Scalars['String'];
  collectionReferenceNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  deemCollectionDetail: Array<DeemCollectionDetailEntity>;
  durationFlag?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  status: Scalars['String'];
};

export type DirectionEntity = {
  __typename?: 'directionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
};

export type DiscountEntity = {
  __typename?: 'discountEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountIntegration?: Maybe<Array<IntegrationDiscountEntity>>;
  discountType?: Maybe<DiscountTypeEntity>;
  discountTypeId?: Maybe<Scalars['String']>;
  discountVal?: Maybe<Scalars['Float']>;
  formula?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDiscountRebate: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  prefix?: Maybe<Scalars['String']>;
  projectAgencyDiscount: ProjectAgencyDiscountEntity;
  projectAgencyRebate: ProjectAgencyRebateEntity;
  projectDiscounts: Array<ProjectDiscountEntity>;
  saleRebatePackage?: Maybe<Array<SaleRebatePackageEntity>>;
  salesDiscount: Array<SaleDiscountEntity>;
  saleSubProduct?: Maybe<SaleSubproductEntity>;
  title: Scalars['String'];
};

/** JsonType */
export type DiscountListingObject = {
  __typename?: 'discountListingObject';
  amount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  seqNo: Scalars['Float'];
  title: Scalars['String'];
};

export type DiscountListingUnitTransferInput = {
  amount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  seqNo: Scalars['Float'];
  title: Scalars['String'];
};

/** JsonType */
export type DiscountObject = {
  __typename?: 'discountObject';
  discardBumi: Scalars['Boolean'];
  discounts?: Maybe<Array<DiscountListingObject>>;
};

export type DiscountParamaterValueOutput = {
  __typename?: 'DiscountParamaterValueOutput';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  discountValue: Scalars['Float'];
  prefix: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type DiscountTypeEntity = AuditEntity & {
  __typename?: 'discountTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount?: Maybe<DiscountEntity>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
};

export type DiscountUnitTransferInput = {
  discardBumi: Scalars['Boolean'];
  discounts?: InputMaybe<Array<DiscountListingUnitTransferInput>>;
};

export type DistrictMasterDataOutput = {
  __typename?: 'DistrictMasterDataOutput';
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
};

export type DocumentNumberDetailEntity = {
  __typename?: 'documentNumberDetailEntity';
  accountId: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  documentNumberHeader: DocumentNumberHeaderEntity;
  documentNumberHeaderId: Scalars['String'];
  formatType: Scalars['String'];
  formatValue: Scalars['String'];
  id: Scalars['String'];
  nextNumber?: Maybe<Scalars['Float']>;
  resetBy?: Maybe<Scalars['String']>;
  sequence: Scalars['Float'];
  startFrom?: Maybe<Scalars['Float']>;
  submittedBy: Scalars['String'];
  submittedTs?: Maybe<Scalars['DateTime']>;
};

export type DocumentNumberHeaderEntity = {
  __typename?: 'documentNumberHeaderEntity';
  accountId: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  docNumGenerated?: Maybe<Scalars['Boolean']>;
  documentNumberDetails?: Maybe<Array<DocumentNumberDetailEntity>>;
  documentNumberResetBy?: Maybe<Array<DocumentNumberResetByEntity>>;
  id: Scalars['String'];
  isAutoDocNo?: Maybe<Scalars['Boolean']>;
  refRecordId: Scalars['String'];
  refTable: Scalars['String'];
  sampleOutput: Scalars['String'];
  submittedBy: Scalars['String'];
  submittedTs?: Maybe<Scalars['DateTime']>;
  type: DocumentNumberHeaderTypeEnum;
};

export enum DocumentNumberHeaderTypeEnum {
  AreaVariance = 'AREA_VARIANCE',
  Contra = 'CONTRA',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  DeemCollectionCredit = 'DEEM_COLLECTION_CREDIT',
  DeemCollectionDebit = 'DEEM_COLLECTION_DEBIT',
  DescriptionList = 'DescriptionList',
  EinvoiceConsolidation = 'EINVOICE_CONSOLIDATION',
  GetDescription = 'GetDescription',
  Interest = 'INTEREST',
  InterestAdvice = 'INTEREST_ADVICE',
  Invoice = 'INVOICE',
  Lad = 'LAD',
  Misc = 'MISC',
  Rebate = 'REBATE',
  Receipt = 'RECEIPT',
  Redemption = 'REDEMPTION',
  Refund = 'REFUND',
  RevenueRecognition = 'REVENUE_RECOGNITION',
  StakeholderFund = 'STAKEHOLDER_FUND',
  StakeholderFundReversal = 'STAKEHOLDER_FUND_REVERSAL',
  StakeholderRelease = 'STAKEHOLDER_RELEASE'
}

export type DocumentNumberResetByEntity = {
  __typename?: 'documentNumberResetByEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  documentNumberHeader: DocumentNumberHeaderEntity;
  documentNumberHeaderId: Scalars['String'];
  id: Scalars['String'];
  month?: Maybe<Scalars['Float']>;
  nextNumber?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type DownloadLogEntity = {
  __typename?: 'downloadLogEntity';
  accountId: Scalars['String'];
  downloadDate: Scalars['DateTime'];
  id: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  reportType: Scalars['String'];
  userId: Scalars['String'];
  userType: Scalars['String'];
};

export type DownpaymentReminderEntity = AuditEntity & {
  __typename?: 'downpaymentReminderEntity';
  accountId: Scalars['String'];
  balanceAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
};

export type DropDownDataSource = {
  __typename?: 'DropDownDataSource';
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  parameters: Array<DropDownParamterInterface>;
};

export type DropDownDataSourceInput = {
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  parameters: Array<DropDownDataSourceParameterInput>;
};

export type DropDownDataSourceParameterInput = {
  Name: Scalars['String'];
  ParameterName: Scalars['String'];
};

export type DropDownMember = {
  __typename?: 'DropDownMember';
  DynamicSource?: Maybe<DynamicSource>;
  StaticData?: Maybe<Array<StaticData>>;
  ValueSource: Scalars['String'];
};

export type DropDownMemberInput = {
  DynamicSource?: InputMaybe<DynamicSourceInput>;
  StaticData?: InputMaybe<Array<StaticDataInput>>;
  ValueSource: Scalars['String'];
};

export type DropDownParamterInterface = {
  __typename?: 'DropDownParamterInterface';
  Name: Scalars['String'];
  ParameterName: Scalars['String'];
};

export type DynamicSource = {
  __typename?: 'DynamicSource';
  DataSource: DropDownDataSource;
  DisplayMember: Scalars['String'];
  ValueMember: Scalars['String'];
};

export type DynamicSourceInput = {
  DataSource: DropDownDataSourceInput;
  DisplayMember: Scalars['String'];
  ValueMember: Scalars['String'];
};

export type EditStaffInput = {
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type EInvoiceClassificationEntity = {
  __typename?: 'eInvoiceClassificationEntity';
  classificationCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type EinvoiceConsolidationDetailEntity = {
  __typename?: 'einvoiceConsolidationDetailEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  commonStatus?: Maybe<Scalars['String']>;
  consolidation?: Maybe<EinvoiceConsolidationEntity>;
  consolidationId: Scalars['String'];
  documentAmount: Scalars['Float'];
  id: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  taxAmount?: Maybe<Scalars['Float']>;
};

export type EinvoiceConsolidationEntity = {
  __typename?: 'einvoiceConsolidationEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  consolidationDetails?: Maybe<Array<EinvoiceConsolidationDetailEntity>>;
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  einvoiceDirectsend?: Maybe<Scalars['Boolean']>;
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  einvoiceMsicCodeId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceTrxType?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  taxAmount: Scalars['Float'];
};

export type EInvoiceDetailsInput = {
  __typename?: 'EInvoiceDetailsInput';
  countryCode?: Maybe<Scalars['String']>;
  debtorEinvClass?: Maybe<Scalars['String']>;
  isEinvRequired?: Maybe<Scalars['String']>;
  isForeignBuyer?: Maybe<Scalars['String']>;
  isGovOrAuth?: Maybe<Scalars['String']>;
  sstTaxRegNo?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  tinNo?: Maybe<Scalars['String']>;
};

export type EInvoiceGeneralTinEntity = {
  __typename?: 'eInvoiceGeneralTinEntity';
  displaySeq?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  tin?: Maybe<Scalars['String']>;
  tinParty?: Maybe<Scalars['String']>;
};

export type EInvoiceMsicEntity = {
  __typename?: 'eInvoiceMsicEntity';
  categoryReference?: Maybe<Scalars['String']>;
  companyMsicAssignment: Array<CompanyMsicAssignmentEntity>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  msicCode?: Maybe<Scalars['String']>;
};

export type EInvoiceUomEntity = {
  __typename?: 'eInvoiceUomEntity';
  code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type ELaunchAllocationEntity = AuditEntity & {
  __typename?: 'eLaunchAllocationEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type ELaunchContactEntity = AuditEntity & {
  __typename?: 'eLaunchContactEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  elaunchUser: ELaunchUserEntity;
  email?: Maybe<Scalars['String']>;
  getLangMasterData: Array<LanguageNamesOutput>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  pictureUrl?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userLanguageChoose: LanguageOutput;
};

export type ELaunchEntity = AuditEntity & {
  __typename?: 'eLaunchEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunchAllocation?: Maybe<Array<ELaunchAllocationEntity>>;
  eLaunchLeadBatch?: Maybe<Array<ELaunchLeadBatchEntity>>;
  endDate: Scalars['DateTime'];
  hasEnded?: Maybe<Scalars['Boolean']>;
  hasPublished?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  publishDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  terminationDate: Scalars['DateTime'];
};

export type ELaunchFavouriteUnitEntity = AuditEntity & {
  __typename?: 'eLaunchFavouriteUnitEntity';
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunchId: Scalars['String'];
  eLaunchUser: ELaunchUserEntity;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  unitId: Scalars['String'];
  userId: Scalars['String'];
};

export type ELaunchInvitationTemplateEntity = AuditEntity & {
  __typename?: 'eLaunchInvitationTemplateEntity';
  accountId: Scalars['String'];
  accountSpec: AccountSpecEntity;
  commonStatus: Scalars['String'];
  content: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  salesDoc?: Maybe<SalesDocEntity>;
  salesDocId?: Maybe<Array<Scalars['String']>>;
  subject?: Maybe<Scalars['String']>;
};

export type ELaunchLeadBatchEntity = AuditEntity & {
  __typename?: 'eLaunchLeadBatchEntity';
  accountId: Scalars['String'];
  batchTitle: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  lastEmailSend?: Maybe<Array<LastEmailSendOutput>>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  recordCount: Scalars['Float'];
};

export type ELaunchLeadEntity = AuditEntity & {
  __typename?: 'eLaunchLeadEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunchBatchId: Scalars['String'];
  eLaunchLeadBatch: ELaunchLeadBatchEntity;
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type ELaunchLogEntity = AuditEntity & {
  __typename?: 'eLaunchLogEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  log: Scalars['JSONObject'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type ELaunchOtpEntity = AuditEntity & {
  __typename?: 'eLaunchOtpEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  otpCode: Scalars['String'];
  otpExpiry: Scalars['DateTime'];
  otpType: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type ELaunchRegisterEntity = AuditEntity & {
  __typename?: 'eLaunchRegisterEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  eLaunchUser: ELaunchUserEntity;
  id: Scalars['String'];
  invitedBy?: Maybe<Scalars['String']>;
  invitedById?: Maybe<Scalars['String']>;
  leadId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type ELaunchUserEntity = AuditEntity & {
  __typename?: 'eLaunchUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  languageSet: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refreshToken?: Maybe<Scalars['String']>;
};

export type ELetterOutput = {
  __typename?: 'ELetterOutput';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type EmailLetterEntity = {
  __typename?: 'emailLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  emailLetterParameter: Array<EmailLetterParameterEntity>;
  emailLetterTemplate: Array<EmailLetterTemplateEntity>;
  emailType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type EmailLetterParameterEntity = {
  __typename?: 'emailLetterParameterEntity';
  accountId: Scalars['String'];
  columnName: Scalars['String'];
  commonStatus: Scalars['String'];
  displayName: Scalars['String'];
  emailLetter: EmailLetterEntity;
  emailLetterId: Scalars['String'];
  id: Scalars['String'];
};

export type EmailLetterTemplateEntity = AuditEntity & {
  __typename?: 'emailLetterTemplateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  emailLetter: EmailLetterEntity;
  emailLetterId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectEmailLetter: ProjectEmailLetterEntity;
  systemUse: Scalars['Boolean'];
  templateBody?: Maybe<Scalars['String']>;
};

export type EmailLogEntity = {
  __typename?: 'emailLogEntity';
  accountId: Scalars['String'];
  bccEmails: Scalars['String'];
  ccEmails: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEmailSent: Scalars['Boolean'];
  recipientEmail: Scalars['String'];
  refColumn?: Maybe<Scalars['String']>;
  refId: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  refType: Scalars['String'];
  subject: Scalars['String'];
};

export type EmailProviderAssignmentEntity = {
  __typename?: 'EmailProviderAssignmentEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  emailProviderId: Scalars['String'];
  id: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
};

export type EmailProviderEntity = {
  __typename?: 'EmailProviderEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  emailProviderType: Scalars['String'];
  enableSSL?: Maybe<Scalars['Boolean']>;
  hostName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationInfo?: Maybe<IntegrationInfoOutput>;
  name: Scalars['String'];
  portNumber?: Maybe<Scalars['Float']>;
  subjectPrefix?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type EndFinancingLimitStatusOutput = {
  __typename?: 'EndFinancingLimitStatusOutput';
  approvalAmount: Scalars['Float'];
  financialLimit: Scalars['Float'];
  name: Scalars['String'];
};

export type EndfinContactEntity = {
  __typename?: 'endfinContactEntity';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: EndfinUserEntity;
  userId: Scalars['String'];
};

export type EndfinFinancierEntity = {
  __typename?: 'endfinFinancierEntity';
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  endfinUserRoles: Array<EndfinUserRoleEntity>;
  financier?: Maybe<FinancierEntity>;
  financiers: Array<FinancierEntity>;
  id: Scalars['String'];
  name: Scalars['String'];
  staffCount?: Maybe<Scalars['Float']>;
};

export type EndfinLoanAppActivityEntity = {
  __typename?: 'endfinLoanAppActivityEntity';
  activityType: Scalars['String'];
  activityTypeDesc: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  loanApp: EndfinLoanAppEntity;
  loanAppId: Scalars['String'];
  loanAppStatus: EndfinLoanAppStatusEntity;
  loanAppStatusId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
};

export type EndfinLoanAppEntity = {
  __typename?: 'endfinLoanAppEntity';
  accountId: Scalars['String'];
  activityData?: Maybe<Array<EndfinLoanAppActivityEntity>>;
  agingDate?: Maybe<Scalars['DateTime']>;
  applyAmount: Scalars['Float'];
  applyDate: Scalars['DateTime'];
  approvalAmount?: Maybe<Scalars['Float']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  documentData?: Maybe<Array<AttachmentEntity>>;
  eLetteringExistenceType?: Maybe<Array<Scalars['String']>>;
  endfinLoanAppActivities: Array<EndfinLoanAppActivityEntity>;
  financier: FinancierEntity;
  financierId: Scalars['String'];
  id: Scalars['String'];
  lastActivity?: Maybe<EndfinLoanAppActivityEntity>;
  loanAppStatus: EndfinLoanAppStatusEntity;
  loanAppStatusId: Scalars['String'];
  loanType: Scalars['String'];
  sale: SaleEntity;
  saleId: Scalars['String'];
  staff?: Maybe<EndfinUserEntity>;
  tenure?: Maybe<Scalars['Float']>;
  user?: Maybe<EndfinUserEntity>;
  userId: Scalars['String'];
};

export type EndfinLoanAppStatusEntity = {
  __typename?: 'endfinLoanAppStatusEntity';
  endfinLoanAppActivities: Array<EndfinLoanAppActivityEntity>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  id: Scalars['String'];
  seqNo: Scalars['Float'];
  stages: Scalars['Float'];
  statusCode: Scalars['String'];
  statusName: Scalars['String'];
};

export type EndfinNotificationEntity = AuditEntity & {
  __typename?: 'endfinNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinNotificationRecipient: Array<EndfinNotificationRecipientEntity>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
};

export type EndfinNotificationPolicyEntity = {
  __typename?: 'endfinNotificationPolicyEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notificationDuration: Scalars['Float'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type EndfinNotificationRecipientEntity = AuditEntity & {
  __typename?: 'endfinNotificationRecipientEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinNotification: EndfinNotificationEntity;
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
};

export type EndfinProjectFinancierEntity = {
  __typename?: 'endfinProjectFinancierEntity';
  accountId: Scalars['String'];
  assignedDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  financialLimit: Scalars['Float'];
  financier: FinancierEntity;
  financierId: Scalars['String'];
  financierInfo: FinancierEntity;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  isPanel: Scalars['Boolean'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type EndfinUserEntity = {
  __typename?: 'endfinUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  assignedLoanCount?: Maybe<LoanAssignedCountOutput>;
  commonStatus: Scalars['String'];
  contact?: Maybe<EndfinContactEntity>;
  endfinContacts: EndfinContactEntity;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinUserRoles: EndfinUserRoleEntity;
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  passwordHash?: Maybe<Scalars['String']>;
  projectLoanCount?: Maybe<Array<LoanProjectCountOutput>>;
  refreshToken?: Maybe<Scalars['String']>;
  userRole?: Maybe<EndfinUserRoleEntity>;
};

export type EndfinUserRoleEntity = {
  __typename?: 'endfinUserRoleEntity';
  commonStatus: Scalars['String'];
  financier: EndfinFinancierEntity;
  financierId: Scalars['String'];
  id: Scalars['String'];
  role: Scalars['String'];
  user: EndfinUserEntity;
  userId: Scalars['String'];
};

export type EntityRoleUserAssignmentEntity = AuditEntity & {
  __typename?: 'entityRoleUserAssignmentEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

export type ESignProjectLetterListingOutput = {
  __typename?: 'ESignProjectLetterListingOutput';
  defaulted?: Maybe<Scalars['Boolean']>;
  letterTemplateId?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EventsEntity = {
  __typename?: 'eventsEntity';
  accountId: Scalars['String'];
  budget: Scalars['Float'];
  campaign: CampaignEntity;
  campaignId: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  website: Scalars['String'];
};

export type ExchangeLog = {
  __typename?: 'ExchangeLog';
  exchangeRate?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
};

export type ExchangeLogInput = {
  exchangeRate?: InputMaybe<Scalars['Float']>;
  modBy?: InputMaybe<Scalars['String']>;
  modTs?: InputMaybe<Scalars['DateTime']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type FinancialBillingEntity = {
  __typename?: 'financialBillingEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  documentAmount?: Maybe<Scalars['Float']>;
  financierId: Scalars['String'];
  id: Scalars['String'];
  principalAmt: Scalars['Float'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  saleLoan?: Maybe<SaleLoanEntity>;
  saleLoanId: Scalars['String'];
  taxAmount?: Maybe<Scalars['Float']>;
};

export type FinancierContactEntity = {
  __typename?: 'financierContactEntity';
  accountId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  financier: FinancierEntity;
  financierId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type FinancierEntity = {
  __typename?: 'financierEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  assignedProjectCount: Scalars['Float'];
  bank?: Maybe<BankEntity>;
  bankId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  collection?: Maybe<Array<SaleLoanEntity>>;
  commonStatus: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  disbursementFinancierId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinProjectFinanciers: Array<EndfinProjectFinancierEntity>;
  financialLimit?: Maybe<Scalars['Float']>;
  financier: EndfinFinancierEntity;
  financierCode?: Maybe<Scalars['String']>;
  financierContact: Array<FinancierContactEntity>;
  financierId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loanCount: Scalars['Float'];
  loanType: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  projectInvitation?: Maybe<Array<FinancierProject>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  refinancing?: Maybe<Array<SaleLoanEntity>>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  state?: Maybe<Scalars['String']>;
  subsaleLoan?: Maybe<Array<SaleLoanEntity>>;
};

export type FinancierProject = {
  __typename?: 'FinancierProject';
  invitation: Array<Contact>;
  projectId: Scalars['String'];
};

export type FinancierUnitMortgage = {
  __typename?: 'financierUnitMortgage';
  financierName?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
};

export type FloorOutput = {
  __typename?: 'FloorOutput';
  ActiveUnit?: Maybe<Array<UnitEntity>>;
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorlabel: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  projectid: Scalars['String'];
  Unit?: Maybe<Array<UnitEntity>>;
};


export type FloorOutputActiveUnitArgs = {
  phase?: InputMaybe<Scalars['String']>;
};

export type GetLeadsSalesTeamByStatusOutput = {
  __typename?: 'GetLeadsSalesTeamByStatusOutput';
  salesStaff?: Maybe<Array<SalesPersonLeadsDataOutput>>;
  salesTeamName?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type GlAccountEntity = {
  __typename?: 'glAccountEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  glAccountCode: Scalars['String'];
  glType: Scalars['String'];
  id: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
};

export type GlAccountPeriodEntity = {
  __typename?: 'glAccountPeriodEntity';
  accountId: Scalars['String'];
  accountPeriodId: Scalars['String'];
  companyId: Scalars['String'];
  endDate: Scalars['DateTime'];
  financialPeriod: Scalars['Float'];
  financialYear: Scalars['Float'];
  monthEndClose: Scalars['Boolean'];
  recordStatus: Scalars['String'];
  startDate: Scalars['DateTime'];
  yearEndClose: Scalars['Boolean'];
};

export type GlExportDetailEntity = {
  __typename?: 'glExportDetailEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  bankAccountNo?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  creditAmount: Scalars['Float'];
  debitAmount: Scalars['Float'];
  debtorName?: Maybe<Scalars['String']>;
  departmentCode?: Maybe<Scalars['String']>;
  errorRemark?: Maybe<Scalars['String']>;
  generatedBy?: Maybe<Scalars['String']>;
  generatedDate?: Maybe<Scalars['DateTime']>;
  glAccountCode?: Maybe<Scalars['String']>;
  glExportId?: Maybe<Scalars['String']>;
  glTransactionType: Scalars['String'];
  glType: Scalars['String'];
  id: Scalars['String'];
  journalType?: Maybe<Scalars['String']>;
  payeeReceiverName?: Maybe<Scalars['String']>;
  postedBy?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['DateTime']>;
  refDescription?: Maybe<Scalars['String']>;
  refDocumentDate: Scalars['DateTime'];
  refDocumentNo: Scalars['String'];
  refId: Scalars['String'];
  refReferenceNo: Scalars['String'];
  refTable: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxRate: Scalars['Float'];
  taxSchemeName?: Maybe<Scalars['String']>;
  trxDate: Scalars['DateTime'];
};

export type GlExportEntity = {
  __typename?: 'glExportEntity';
  accountId: Scalars['String'];
  cbPosted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  generateEndDate: Scalars['DateTime'];
  generateStartDate: Scalars['DateTime'];
  id: Scalars['String'];
  posted: Scalars['Boolean'];
  postedBy?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['DateTime']>;
};

export type GlInterfacePolicyEntity = {
  __typename?: 'glInterfacePolicyEntity';
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  glIntegration: Scalars['String'];
  glTransactionGeneration: Scalars['String'];
  id: Scalars['String'];
};

export type GlRevenueMapping = {
  __typename?: 'GLRevenueMapping';
  ExpenseCredit?: Maybe<Scalars['String']>;
  ExpenseDebit?: Maybe<Scalars['String']>;
  ExpenseDept?: Maybe<Scalars['String']>;
  ExpenseDiv?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  RevenueCredit?: Maybe<Scalars['String']>;
  RevenueDebit?: Maybe<Scalars['String']>;
  RevenueDept?: Maybe<Scalars['String']>;
  RevenueDiv?: Maybe<Scalars['String']>;
  ReverseCredit?: Maybe<Scalars['String']>;
  ReverseDebit?: Maybe<Scalars['String']>;
  ReverseDept?: Maybe<Scalars['String']>;
  ReverseDiv?: Maybe<Scalars['String']>;
};

export type GlRevenueMappingInput = {
  ExpenseCredit?: InputMaybe<Scalars['String']>;
  ExpenseDebit?: InputMaybe<Scalars['String']>;
  ExpenseDept?: InputMaybe<Scalars['String']>;
  ExpenseDiv?: InputMaybe<Scalars['String']>;
  modBy?: InputMaybe<Scalars['String']>;
  modTs?: InputMaybe<Scalars['DateTime']>;
  RevenueCredit?: InputMaybe<Scalars['String']>;
  RevenueDebit?: InputMaybe<Scalars['String']>;
  RevenueDept?: InputMaybe<Scalars['String']>;
  RevenueDiv?: InputMaybe<Scalars['String']>;
  ReverseCredit?: InputMaybe<Scalars['String']>;
  ReverseDebit?: InputMaybe<Scalars['String']>;
  ReverseDept?: InputMaybe<Scalars['String']>;
  ReverseDiv?: InputMaybe<Scalars['String']>;
};

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  MediaType: Scalars['String'];
  PrivateUrl?: Maybe<Scalars['String']>;
  Url: Scalars['String'];
};

export type ImportLeadDetails = {
  __typename?: 'ImportLeadDetails';
  address?: Maybe<Scalars['String']>;
  annual_income?: Maybe<Scalars['String']>;
  assign_status?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  event_id?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  gender_id?: Maybe<Scalars['String']>;
  isContactExisted: Scalars['Boolean'];
  lead_remark?: Maybe<Scalars['String']>;
  lead_source_id: Scalars['String'];
  lead_status?: Maybe<Scalars['String']>;
  marital_id?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  prefer_location?: Maybe<Scalars['String']>;
  prefer_property?: Maybe<Scalars['String']>;
  race_id?: Maybe<Scalars['String']>;
  sales_person_assigned_id?: Maybe<Scalars['String']>;
  salutation_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  utm_campaign?: Maybe<Scalars['String']>;
  utm_content?: Maybe<Scalars['String']>;
  utm_id?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
  utm_term?: Maybe<Scalars['String']>;
};

export type IncomeRangeEntity = {
  __typename?: 'incomeRangeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  leadContact: Array<LeadContactEntity>;
  range: Scalars['String'];
  sales: Array<SaleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
};

export type IncomingIntegrationUpdateLogEntity = {
  __typename?: 'incomingIntegrationUpdateLogEntity';
  body: Scalars['JSONObject'];
  completeDate: Scalars['DateTime'];
  endpoint?: Maybe<Scalars['String']>;
  errorMsg?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idType?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  isManualSuccess: Scalars['Boolean'];
  isSuccess: Scalars['Boolean'];
  primId?: Maybe<Scalars['String']>;
  PXProjectId?: Maybe<Scalars['String']>;
  receiveDate: Scalars['DateTime'];
};

export type IntegrationDiscountEntity = {
  __typename?: 'integrationDiscountEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  effectiveDate?: Maybe<Scalars['DateTime']>;
  expiredDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  ifcaDiscountId: Scalars['Float'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  projectIntegration: ProjectIntegrationEntity;
};

export type IntegrationInfoOutput = {
  __typename?: 'integrationInfoOutput';
  apiKey?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

export type IntegrationPackageEntity = {
  __typename?: 'integrationPackageEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ifcaPackageId: Scalars['Float'];
  package: PackageEntity;
  packageId: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type IntegrationSolicitorEntity = {
  __typename?: 'integrationSolicitorEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ifcaSolicitorId: Scalars['Float'];
  project: ProjectEntity;
  projectIntegration: ProjectIntegrationEntity;
  solicitor: SolicitorAppointedEntity;
  solicitorId: Scalars['String'];
};

export type InterestBillingEntity = {
  __typename?: 'interestBillingEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  creditTerm?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  interestAdviceDocumentNo: Scalars['String'];
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  lateInterest: Array<LateInterestEntity>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type InterestEntity = {
  __typename?: 'interestEntity';
  account_id: Scalars['String'];
  batchId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  interestAmount: Scalars['String'];
  interestDate: Scalars['DateTime'];
  interestRate: Scalars['String'];
  invoice: LedgerEntity;
  invoiceId: Scalars['String'];
  isWaive: Scalars['Boolean'];
  ledger: LedgerEntity;
  overdueAmount: Scalars['String'];
  overdueDay: Scalars['Float'];
  postedDate?: Maybe<Scalars['DateTime']>;
  project: ProjectEntity;
  sale: SaleEntity;
  trxStatus: Scalars['String'];
};

export type JointBuyerEntity = {
  __typename?: 'jointBuyerEntity';
  accountId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  contact: ContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  ifcaContactId: Scalars['String'];
  ifcaSaleId: Scalars['Float'];
  isEInvoiceRequired: Scalars['Boolean'];
  isGovAuth: Scalars['Boolean'];
  jointBuyerIdentityNo?: Maybe<Scalars['String']>;
  jointBuyerIdentityType?: Maybe<Scalars['String']>;
  jointBuyerName?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  seq_no?: Maybe<Scalars['Float']>;
};

export type JointBuyerInfoForBookingListing = {
  __typename?: 'JointBuyerInfoForBookingListing';
  isJointBuyerInfoRequired?: Maybe<Scalars['Boolean']>;
  saleId?: Maybe<Scalars['String']>;
  totalJointBuyer?: Maybe<Scalars['Float']>;
};

export type JointBuyerParamaterValueOutput = {
  __typename?: 'JointBuyerParamaterValueOutput';
  contact: Scalars['String'];
  incomeRange: Scalars['String'];
  nationality: Scalars['String'];
  race: Scalars['String'];
  salutation: Scalars['String'];
};

export type KeyCollectionAppointmentEntity = {
  __typename?: 'keyCollectionAppointmentEntity';
  accountId: Scalars['String'];
  alarmVendorId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  electricalDate?: Maybe<Scalars['DateTime']>;
  electricalRemark?: Maybe<Scalars['String']>;
  electricianId?: Maybe<Scalars['String']>;
  handOverDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  keyCollectionTimeslot?: Maybe<ProjectKeyCollectionTimeSlotEntity>;
  keyCollectionTimeslotId: Scalars['String'];
  keysCollected?: Maybe<Scalars['Float']>;
  plumberId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  sanitaryDate?: Maybe<Scalars['DateTime']>;
  sanitaryRemark?: Maybe<Scalars['String']>;
  siteSupervisorId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type KeyCollectionAppointmentRescheduleInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: InputMaybe<Scalars['Boolean']>;
  purchaserUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type LadEntity = {
  __typename?: 'ladEntity';
  accountId: Scalars['String'];
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  byFacilityDate?: Maybe<Scalars['DateTime']>;
  byUnitDate: Scalars['DateTime'];
  commonFacility: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  facilityDueDays?: Maybe<Scalars['Float']>;
  facilityLadAmount?: Maybe<Scalars['Float']>;
  facilityLadDuration?: Maybe<Scalars['Float']>;
  facilityLadPercent?: Maybe<Scalars['Float']>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  isSimulate: Scalars['Boolean'];
  payoutPercent: Scalars['Float'];
  projectId: Scalars['String'];
  sale?: Maybe<SaleEntity>;
  saleId: Scalars['String'];
  spaPercent: Scalars['Float'];
  startWith: Scalars['String'];
  status: Scalars['String'];
  unitDueDays?: Maybe<Scalars['Float']>;
  unitDuration: Scalars['Float'];
  unitLadAmount: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type LanguageNamesOutput = {
  __typename?: 'LanguageNamesOutput';
  langCode?: Maybe<Scalars['String']>;
  langName?: Maybe<Scalars['String']>;
};

export type LanguageOutput = {
  __typename?: 'LanguageOutput';
  fileNames?: Maybe<Array<Scalars['String']>>;
  obj?: Maybe<Scalars['String']>;
};

export type LastEmailSendInput = {
  SendBy: Scalars['String'];
  SendDate: Scalars['DateTime'];
};

export type LastEmailSendOutput = {
  __typename?: 'LastEmailSendOutput';
  SendBy: Scalars['String'];
  SendDate: Scalars['DateTime'];
};

export type LateInterestEntity = {
  __typename?: 'lateInterestEntity';
  accountId: Scalars['String'];
  calculateAmt: Scalars['Float'];
  calculateRate: Scalars['Float'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  interestAmount: Scalars['Float'];
  interestBilling: InterestBillingEntity;
  interestBillingId?: Maybe<Scalars['String']>;
  interestEndDate: Scalars['DateTime'];
  interestStartDate: Scalars['DateTime'];
  isIncludeHoliday: Scalars['Boolean'];
  lateInterestGeneration: LateInterestGenerationEntity;
  lateInterestGenerationId: Scalars['String'];
  overdueDay: Scalars['Float'];
  projectId: Scalars['String'];
  refDocDate?: Maybe<Scalars['DateTime']>;
  refDocDesc?: Maybe<Scalars['String']>;
  refDocNo: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  waiveAmount?: Maybe<Scalars['Float']>;
};

export type LateInterestGenerationEntity = {
  __typename?: 'lateInterestGenerationEntity';
  accountId: Scalars['String'];
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  interestGenerationDate?: Maybe<Scalars['DateTime']>;
  isEinvoice: Scalars['Boolean'];
  lateInterest: LateInterestEntity;
  projectId: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type Lead3rdpartyIntegrationEntity = {
  __typename?: 'lead3rdpartyIntegrationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  integrationType: Scalars['String'];
  integrationUrl?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  loginId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type Lead3rdPartyIntegrationPostLogEntity = {
  __typename?: 'lead3rdPartyIntegrationPostLogEntity';
  accountId: Scalars['String'];
  body: Scalars['JSONObject'];
  header: Scalars['JSONObject'];
  id: Scalars['String'];
  integrationType: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectId?: Maybe<Scalars['String']>;
  receiveDate: Scalars['DateTime'];
  response?: Maybe<Scalars['String']>;
};

export type LeadActivityDetails = {
  __typename?: 'LeadActivityDetails';
  actiontakenname?: Maybe<Scalars['String']>;
  activityAudio?: Maybe<Scalars['String']>;
  activitydate: Scalars['DateTime'];
  activitydesc?: Maybe<Scalars['String']>;
  activitytype?: Maybe<Scalars['String']>;
  agencyname?: Maybe<Scalars['String']>;
  followupdate?: Maybe<Scalars['DateTime']>;
  followupremark?: Maybe<Scalars['String']>;
  lead_id?: Maybe<Scalars['String']>;
  leadStatus: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
};

export type LeadActivityEntity = {
  __typename?: 'leadActivityEntity';
  accountId: Scalars['String'];
  actionBy?: Maybe<Scalars['String']>;
  activityAudio?: Maybe<Scalars['String']>;
  activityDate: Scalars['DateTime'];
  activityDesc?: Maybe<Scalars['String']>;
  activityType: Scalars['String'];
  followUpDate?: Maybe<Scalars['DateTime']>;
  followUpRemark?: Maybe<Scalars['String']>;
  fromPersonId?: Maybe<Scalars['String']>;
  fromProject: ProjectEntity;
  fromTeam: SaleTeamEntity;
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
  leadStatus: Scalars['String'];
  personId?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  remark?: Maybe<Scalars['String']>;
  team: SaleTeamEntity;
};

export type LeadAddressEntity = {
  __typename?: 'leadAddressEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  contactId: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  leadContact: LeadContactEntity;
};

export type LeadAssignmentSettingEntity = {
  __typename?: 'leadAssignmentSettingEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  lastAssign: Scalars['DateTime'];
  leadCount: Scalars['Float'];
  projectId: Scalars['String'];
  seq: Scalars['Float'];
  userId: Scalars['String'];
  weight: Scalars['Float'];
};

export type LeadBatchCountLeadSourceOutput = {
  __typename?: 'LeadBatchCountLeadSourceOutput';
  id: Scalars['String'];
  others: Array<LeadBatchCountLeadSourceValuesOutput>;
  top1: Array<LeadBatchCountLeadSourceValuesOutput>;
  top2: Array<LeadBatchCountLeadSourceValuesOutput>;
  top3: Array<LeadBatchCountLeadSourceValuesOutput>;
};

export type LeadBatchCountLeadSourceValuesOutput = {
  __typename?: 'LeadBatchCountLeadSourceValuesOutput';
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type LeadBatchEntity = AuditEntity & {
  __typename?: 'leadBatchEntity';
  accountId: Scalars['String'];
  assignedToProjectLeadCount: Scalars['Float'];
  batchTitle: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  lastAssignedToProject: LeadActivityEntity;
  leads: Array<LeadEntity>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  recordCount: Scalars['Float'];
};

export type LeadByBatch = {
  __typename?: 'LeadByBatch';
  contact_id: Scalars['String'];
  email: Scalars['String'];
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isRegistered?: Maybe<Scalars['Boolean']>;
  lead_id: Scalars['String'];
  lead_source?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
  project_count: Scalars['Float'];
  project_id?: Maybe<Scalars['String']>;
};

export type LeadByBatchIds = {
  __typename?: 'LeadByBatchIds';
  assignedProjectDetails?: Maybe<Array<AssignedProjectDetails>>;
  batchTitle?: Maybe<Scalars['String']>;
  coldTotal?: Maybe<Scalars['Float']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  dropTotal?: Maybe<Scalars['Float']>;
  hotTotal?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  isRoundRobinUser?: Maybe<Scalars['Boolean']>;
  leadData?: Maybe<Array<LeadDataOutput>>;
  openTotal?: Maybe<Scalars['Float']>;
  recordCount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  warmTotal?: Maybe<Scalars['Float']>;
};

export type LeadContactEntity = {
  __typename?: 'leadContactEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<LeadAddressEntity>>;
  altEmail?: Maybe<Array<Scalars['String']>>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  commonStatus: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  designation?: Maybe<ParameterEntity>;
  distance: Scalars['Float'];
  dob?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  jointBuyers: Array<JointBuyerEntity>;
  jointBuyerSignature?: Maybe<Scalars['String']>;
  leadAddress?: Maybe<Array<AddressJson>>;
  leadJointBuyers: Array<LeadJointBuyerEntity>;
  leads?: Maybe<Array<LeadEntity>>;
  maritalStatus?: Maybe<MaritalStatusEntity>;
  militaryIc?: Maybe<Scalars['String']>;
  nationality?: Maybe<SNationalityEntity>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  preBookingQueue: Array<PreBookingQueueEntity>;
  preBookingQueueJointBuyers?: Maybe<Array<PreBookingQueueJointBuyerEntity>>;
  race?: Maybe<RaceEntity>;
  sales: Array<SaleEntity>;
  salutation?: Maybe<SalutationEntity>;
  signatureUrl?: Maybe<Scalars['String']>;
  subscribeMaterialEmail: Scalars['Boolean'];
  subscribeMaterialWhatsapp: Scalars['Boolean'];
  tin?: Maybe<Scalars['String']>;
};

export type LeadConversionRateOutput = {
  __typename?: 'LeadConversionRateOutput';
  rate?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
};

export type LeadDashboardOutput = {
  __typename?: 'LeadDashboardOutput';
  data: Array<LeadDashboardRowOutput>;
  total: Scalars['Float'];
};

export type LeadDashboardProjectOutput = {
  __typename?: 'LeadDashboardProjectOutput';
  assigned_on?: Maybe<Scalars['DateTime']>;
  last_activity_date?: Maybe<Scalars['DateTime']>;
  lead_id: Scalars['String'];
  lead_source?: Maybe<Scalars['String']>;
  lead_status?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  project_name: Scalars['String'];
  sales_person_name?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['String']>;
  team_name?: Maybe<Scalars['String']>;
};

export type LeadDashboardRowOutput = {
  __typename?: 'LeadDashboardRowOutput';
  contact_id: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  last_activity_date?: Maybe<Scalars['DateTime']>;
  no_of_projects: Scalars['Float'];
  phone_no?: Maybe<Scalars['String']>;
  projects: Array<LeadDashboardProjectOutput>;
};

export type LeadDashboardSalesPersonOutput = {
  __typename?: 'LeadDashboardSalesPersonOutput';
  userId: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
};

export type LeadDataOutput = {
  __typename?: 'LeadDataOutput';
  activity_date?: Maybe<Scalars['DateTime']>;
  activity_desc?: Maybe<Scalars['String']>;
  contact_id: Scalars['String'];
  converted_to_booking: Scalars['Boolean'];
  createdTs?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  event_name?: Maybe<Scalars['String']>;
  existing_purchaser: Scalars['Boolean'];
  follow_up_date?: Maybe<Scalars['DateTime']>;
  follow_up_remark?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isRegistered?: Maybe<Scalars['Boolean']>;
  lead_id: Scalars['String'];
  lead_source: Scalars['String'];
  lead_status: Scalars['String'];
  phone_no: Scalars['String'];
  project_count: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  sales_person_id?: Maybe<Scalars['String']>;
  sales_person_name?: Maybe<Scalars['String']>;
};

export type LeadDropRateOutput = {
  __typename?: 'LeadDropRateOutput';
  rate?: Maybe<Scalars['Float']>;
  totalDropLead?: Maybe<Scalars['Float']>;
};

export type LeadEntity = {
  __typename?: 'leadEntity';
  accountId: Scalars['String'];
  agencyAcctId?: Maybe<Scalars['String']>;
  assignStatus?: Maybe<Scalars['String']>;
  batch: LeadBatchEntity;
  batchId?: Maybe<Scalars['String']>;
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  designation?: Maybe<ParameterEntity>;
  eventId?: Maybe<Scalars['String']>;
  events?: Maybe<EventsEntity>;
  id: Scalars['String'];
  idleLeadNotifiedCount: Scalars['Float'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  incomeRangeId?: Maybe<Scalars['String']>;
  isAiLead: Scalars['Boolean'];
  lastLeadActId?: Maybe<Scalars['String']>;
  leadActivities: Array<LeadActivityEntity>;
  LeadActivity: Scalars['JSONObject'];
  leadAddress?: Maybe<Array<AddressJson>>;
  leadDetailsActivity?: Maybe<Array<LeadActivityDetails>>;
  leadJointBuyers: Array<LeadJointBuyerEntity>;
  leadSource: LeadSourceEntity;
  leadSourceId: Scalars['String'];
  leadSourceType?: Maybe<Scalars['String']>;
  leadStatus: Scalars['String'];
  LeadStatus: Scalars['JSONObject'];
  loanScreening?: Maybe<LoanScreenStatusOutput>;
  pbqFieldRequired?: Maybe<Scalars['JSONObject']>;
  preferLocation?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  projectId?: Maybe<Scalars['String']>;
  propertyType?: Maybe<PropertyTypeEntity>;
  propertyTypeId?: Maybe<Scalars['String']>;
  referralContactNo?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  sales: Array<SaleEntity>;
  salesPerson?: Maybe<UserEntity>;
  salesPersonId?: Maybe<Scalars['String']>;
  team?: Maybe<SaleTeamEntity>;
  teamId?: Maybe<Scalars['String']>;
  unit: UnitEntity;
  utm_campaign?: Maybe<Scalars['String']>;
  utm_content?: Maybe<Scalars['String']>;
  utm_id?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
  utm_term?: Maybe<Scalars['String']>;
  waitingList: Array<BookingWaitlistEntity>;
};

export type LeadHandleByWhichUserOutput = {
  __typename?: 'LeadHandleByWhichUserOutput';
  assignStatus: Scalars['String'];
  eLaunchId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leadSourceId?: Maybe<Scalars['String']>;
  leadStatus: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  salesPersonId?: Maybe<Scalars['String']>;
};

export type LeadJointBuyerEntity = {
  __typename?: 'leadJointBuyerEntity';
  accountId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
};

export type LeadSourceEntity = {
  __typename?: 'leadSourceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  leads: Array<LeadEntity>;
  name: Scalars['String'];
  sales: Array<SaleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
};

export type LeadStatusCountOutput = {
  __typename?: 'LeadStatusCountOutput';
  bookedCount?: Maybe<Scalars['Float']>;
  coldCount?: Maybe<Scalars['Float']>;
  conversionRate?: Maybe<LeadConversionRateOutput>;
  dropCount?: Maybe<Scalars['Float']>;
  droppedRate: LeadDropRateOutput;
  hotCount?: Maybe<Scalars['Float']>;
  openCount?: Maybe<Scalars['Float']>;
  projectId?: Maybe<Scalars['String']>;
  reservationCount?: Maybe<Scalars['Float']>;
  signedCount?: Maybe<Scalars['Float']>;
  totalConvertedAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
  waitingCount?: Maybe<Scalars['Float']>;
  warmCount?: Maybe<Scalars['Float']>;
};


export type LeadStatusCountOutputConversionRateArgs = {
  lead_source_id?: InputMaybe<Scalars['String']>;
};

export type LeadTemplateReturnOutput = {
  __typename?: 'LeadTemplateReturnOutput';
  file?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  leadIds?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

export type LedgerEntity = {
  __typename?: 'ledgerEntity';
  account_id: Scalars['String'];
  adjustmentType?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  debtorClass?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  docAmount: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  interestInvoice: Array<InterestEntity>;
  interestLegder: Array<InterestEntity>;
  invoice: LedgerEntity;
  ledgers: Array<LedgerEntity>;
  mode: Scalars['String'];
  paymentInclude?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['DateTime']>;
  project: ProjectEntity;
  referenceNo?: Maybe<Scalars['String']>;
  reminders: Array<ReminderEntity>;
  sale: SaleEntity;
  schedule: ScheduleEntity;
  tax_id: Scalars['String'];
  taxAmount?: Maybe<Scalars['String']>;
  trxClass?: Maybe<Scalars['String']>;
  trxDate: Scalars['DateTime'];
  trxStatus: Scalars['String'];
  voidDate?: Maybe<Scalars['DateTime']>;
  voidReason?: Maybe<Scalars['String']>;
};

export type LegalFeesManagementEntity = {
  __typename?: 'legalFeesManagementEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  status: Scalars['String'];
  totalAmount: Scalars['Float'];
  totalDocumentAmount: Scalars['Float'];
};

export type LetterSignDetailsEntity = {
  __typename?: 'letterSignDetailsEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  letterTemplateId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type LetterSignEntity = AuditEntity & {
  __typename?: 'letterSignEntity';
  contactId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  sale: SaleEntity;
};

export type LetterTemplateEntity = AuditEntity & {
  __typename?: 'letterTemplateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectLetter: Array<ProjectLetterEntity>;
  standardLetter: StandardLetterEntity;
  standardLetterDataSourceVersion?: Maybe<Scalars['Float']>;
  standardLetterId: Scalars['String'];
  systemUse: Scalars['Boolean'];
  templateBody?: Maybe<Scalars['String']>;
};

export type LhdnEinvoiceSettingsEntity = {
  __typename?: 'lhdnEinvoiceSettingsEntity';
  eInvAccessToken?: Maybe<Scalars['String']>;
  eInvApiUrl?: Maybe<Scalars['String']>;
  eInvClientId: Scalars['String'];
  eInvClientSecret?: Maybe<Scalars['String']>;
  eInvClientSecret2?: Maybe<Scalars['String']>;
};

export type ListOfSalesStaffByTeam = {
  __typename?: 'ListOfSalesStaffByTeam';
  teamId: Scalars['String'];
  teamName: Scalars['String'];
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type LoanAcceptanceRateOutput = {
  __typename?: 'LoanAcceptanceRateOutput';
  accepted: Scalars['Float'];
  name: Scalars['String'];
  pending: Scalars['Float'];
  rejected: Scalars['Float'];
  total: Scalars['Float'];
};

export type LoanAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMajorLoanAlertAging: Scalars['Float'];
  maxMinorLoanAlertAging: Scalars['Float'];
};

export type LoanAlertAgingOutput = {
  __typename?: 'LoanAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMajorLoanAlertAging: Scalars['Float'];
  maxMinorLoanAlertAging: Scalars['Float'];
};

export type LoanAssignedCountOutput = {
  __typename?: 'LoanAssignedCountOutput';
  active_count: Scalars['Float'];
  total_count: Scalars['Float'];
  withdrawn_count: Scalars['Float'];
};

export type LoanAssignmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  endFinUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type LoanAssignmentOutput = {
  __typename?: 'loanAssignmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  endFinUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type LoanBiOutput = {
  __typename?: 'LoanBIOutput';
  endFinancingLimitStatus?: Maybe<Array<EndFinancingLimitStatusOutput>>;
  loanAcceptanceRate?: Maybe<Array<LoanAcceptanceRateOutput>>;
  name: Scalars['String'];
};

export type LoanBiSummaryOutput = {
  __typename?: 'loanBISummaryOutput';
  total_loan_application?: Maybe<Scalars['Float']>;
  total_loan_pending?: Maybe<Scalars['Float']>;
  total_loan_signed?: Maybe<Scalars['Float']>;
  total_loan_withdrawn?: Maybe<Scalars['Float']>;
};

export type LoanLeadNotificationInput = {
  leadAssignment?: InputMaybe<Scalars['Boolean']>;
};

export type LoanLeadNotificationOutput = {
  __typename?: 'LoanLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type LoanProjectCountOutput = {
  __typename?: 'LoanProjectCountOutput';
  active_count: Scalars['Float'];
  project_id: Scalars['String'];
  project_name: Scalars['String'];
  total_count: Scalars['Float'];
  withdrawn_count: Scalars['Float'];
};

export type LoanScreenEntity = {
  __typename?: 'loanScreenEntity';
  accountId: Scalars['String'];
  caseCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  payload: Scalars['JSONObject'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  refCode?: Maybe<Scalars['String']>;
  refId: Scalars['String'];
  refTable: Scalars['String'];
  reportType: Scalars['String'];
  reportUrl?: Maybe<Scalars['String']>;
  serviceProvider: Scalars['String'];
  status: Scalars['String'];
};

export type LoanScreenReportOutput = {
  __typename?: 'LoanScreenReportOutput';
  fileName: Scalars['String'];
  mediaType: Scalars['String'];
  refType: Scalars['String'];
  resourceUrl: Scalars['String'];
};

export type LoanScreenStatusOutput = {
  __typename?: 'LoanScreenStatusOutput';
  caseCode: Scalars['String'];
  CCRIS?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  CTOS?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['DateTime'];
  status: Scalars['String'];
};

export type LoanStatusOutput = {
  __typename?: 'LoanStatusOutput';
  acceptedCount: Scalars['Float'];
  approvedCount: Scalars['Float'];
  count: Scalars['Float'];
  pendingConsentCount: Scalars['Float'];
  rejectedCount: Scalars['Float'];
  signedCount: Scalars['Float'];
  withdrawnCount: Scalars['Float'];
};

export type LocalBankEntity = AuditEntity & {
  __typename?: 'LocalBankEntity';
  address: Address;
  code: Scalars['String'];
  commonStatus: CommonStatus;
  contactNo: Scalars['String'];
  countryID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  faxNo?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserResponse;
};

export type MaritalStatusEntity = {
  __typename?: 'maritalStatusEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
};

export type MasterDataOutput = {
  __typename?: 'MasterDataOutput';
  AddressType: Scalars['JSONObject'];
  City: Array<SCityEntity>;
  CommercialPurposes: Scalars['JSONObject'];
  Countries: Array<CountryMasterDataOutput>;
  CurrencyCode: Array<Array<Scalars['String']>>;
  Designations: Array<ParameterEntity>;
  DiscountPrefix: Scalars['JSONObject'];
  DiscountType: Array<DiscountTypeEntity>;
  ELettering: Scalars['JSONObject'];
  Events: Array<EventsEntity>;
  Genders: Scalars['JSONObject'];
  IncomeRanges: Array<IncomeRangeEntity>;
  IntegrationTypes: Scalars['JSONObject'];
  LandType: Scalars['JSONObject'];
  Language: Scalars['JSONObject'];
  LeadSources: Array<LeadSourceEntity>;
  LoanType: Scalars['JSONObject'];
  MaritalStatus: Array<MaritalStatusEntity>;
  Nationalities: Array<SNationalityEntity>;
  NewUserPermission: Array<Scalars['JSONObject']>;
  Parameters: Array<ParameterEntity>;
  PaymentMethods: Array<Scalars['JSONObject']>;
  PaymentStatus: Scalars['JSONObject'];
  PayMethod: Scalars['JSONObject'];
  ProjectTypes: Array<ProjectTypeEntity>;
  PropertyTypes: Array<PropertyTypeEntity>;
  PurchaserAppSetting: Scalars['JSONObject'];
  Races: Array<RaceEntity>;
  ReasonCode: Array<ReasonCodeEntity>;
  Region: Array<RegionEntity>;
  Salutations: Array<SalutationEntity>;
  Tenures: Scalars['JSONObject'];
  UnitLayoutbyProject: Array<UnitLayoutEntity>;
  UnitTypes: Array<UnitTypeEntity>;
  UOM: Scalars['JSONObject'];
  UserPermission: Array<Scalars['Float']>;
};


export type MasterDataOutputNewUserPermissionArgs = {
  projectId: Scalars['String'];
};


export type MasterDataOutputParametersArgs = {
  parameterType: Scalars['String'];
};


export type MasterDataOutputPaymentMethodsArgs = {
  projectId?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
};


export type MasterDataOutputPaymentStatusArgs = {
  projectId?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
};


export type MasterDataOutputUnitLayoutbyProjectArgs = {
  project_id: Scalars['String'];
};


export type MasterDataOutputUserPermissionArgs = {
  projectId: Scalars['String'];
};

export type MasterDetailRelation = {
  __typename?: 'MasterDetailRelation';
  detailQueryName?: Maybe<Scalars['String']>;
  masterQueryName?: Maybe<Scalars['String']>;
  relationColumn?: Maybe<Array<RelationColumn>>;
};

export type MasterDetailRelationInput = {
  detailQueryName?: InputMaybe<Scalars['String']>;
  masterQueryName?: InputMaybe<Scalars['String']>;
  relationColumn?: InputMaybe<Array<RelationColumnInput>>;
};

export type MediaSource = {
  __typename?: 'MediaSource';
  caption?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  videoType?: Maybe<Scalars['String']>;
};

export type MediaSourceInput = {
  caption?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  videoType?: InputMaybe<Scalars['String']>;
};

export type MicrositeNewLeadOutput = {
  __typename?: 'MicrositeNewLeadOutput';
  accountId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  incomeRange?: Maybe<Scalars['String']>;
  isAiLead?: Maybe<Scalars['Boolean']>;
  leadSourceId?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  militaryIc?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  preferLocation?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  race?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  salesPersonId?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
};

export type MiscBillingEntity = {
  __typename?: 'miscBillingEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  isIncludeHoliday: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type MotTrackingEntity = {
  __typename?: 'motTrackingEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  confirmationPresentationReceipt?: Maybe<Scalars['DateTime']>;
  forwardMotComSec?: Maybe<Scalars['DateTime']>;
  forwardMotDirector?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  instructionToSolicitor?: Maybe<Scalars['DateTime']>;
  motIn?: Maybe<Scalars['DateTime']>;
  motMortgageDate?: Maybe<Scalars['DateTime']>;
  motMortgageNo?: Maybe<Scalars['String']>;
  motOut?: Maybe<Scalars['DateTime']>;
  motReceiptNo?: Maybe<Scalars['String']>;
  motSolicitorId?: Maybe<Scalars['String']>;
  motSolicitorReferenceNo?: Maybe<Scalars['String']>;
  motSubmissionDate?: Maybe<Scalars['DateTime']>;
  motSubmissionNo?: Maybe<Scalars['String']>;
  motTransferDate?: Maybe<Scalars['DateTime']>;
  projectId: Scalars['String'];
  receivedFrom?: Maybe<Scalars['String']>;
  receivedTitleDulyTransferred?: Maybe<Scalars['DateTime']>;
  receiveLawyerAcknowledgement?: Maybe<Scalars['DateTime']>;
  receiveMotCancellation?: Maybe<Scalars['DateTime']>;
  receiveMotComSec?: Maybe<Scalars['DateTime']>;
  receiveMotDirector?: Maybe<Scalars['DateTime']>;
  releaseForTitle?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  requestForTitle?: Maybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  stampDutyPayment?: Maybe<Scalars['Float']>;
  stampDutyPaymentDate?: Maybe<Scalars['DateTime']>;
  titleExecutionDate?: Maybe<Scalars['DateTime']>;
  titleForward?: Maybe<Scalars['DateTime']>;
  titleNotificationDate?: Maybe<Scalars['DateTime']>;
};

export type MultipleEsignProjectLetterListingOutput = {
  __typename?: 'MultipleEsignProjectLetterListingOutput';
  letter?: Maybe<Array<ESignProjectLetterListingOutput>>;
  letterTypeName?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAttachments: Array<AttachmentEntity>;
  addStaff: Scalars['Boolean'];
  alterStaffAccess: Scalars['Boolean'];
  changePassword: Scalars['Boolean'];
  deleteAttachment: Scalars['Boolean'];
  downloadAttachment: AttachmentOutput;
  editStaff: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  markAsRead: Scalars['Boolean'];
  newPassword: Scalars['Boolean'];
  newPasswordCheck: Scalars['Boolean'];
  registerSolicitor: Scalars['Boolean'];
  resendInvitationEmail: Scalars['Boolean'];
  saveNotificationPermission: Scalars['Boolean'];
  updateLoanAgreementStatus: Scalars['Boolean'];
  updateProfile: Scalars['Boolean'];
  updateStatus: Scalars['Boolean'];
};


export type MutationAddAttachmentsArgs = {
  input: SalesAddAttachmentsInput;
};


export type MutationAddStaffArgs = {
  input: AddStaffInput;
};


export type MutationAlterStaffAccessArgs = {
  contactId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  input: SolicitorChangePasswordInput;
};


export type MutationDeleteAttachmentArgs = {
  attachmentId: Scalars['String'];
};


export type MutationDownloadAttachmentArgs = {
  input: SalesDownloadAttachmentInput;
};


export type MutationEditStaffArgs = {
  input: EditStaffInput;
};


export type MutationForgotPasswordArgs = {
  Email: Scalars['String'];
};


export type MutationMarkAsReadArgs = {
  notificationIds: Array<Scalars['String']>;
};


export type MutationNewPasswordArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationRegisterSolicitorArgs = {
  input: SolicitorInput;
};


export type MutationResendInvitationEmailArgs = {
  contactID: Scalars['String'];
};


export type MutationSaveNotificationPermissionArgs = {
  input: NotificationInput;
};


export type MutationUpdateLoanAgreementStatusArgs = {
  input: UpdateLoanAgreementStatusInput;
};


export type MutationUpdateProfileArgs = {
  input: UserContactInput;
};


export type MutationUpdateStatusArgs = {
  input: SalesUpdateStatusInput;
};

export type NewPermissionDetail = {
  __typename?: 'NewPermissionDetail';
  action?: Maybe<Scalars['String']>;
  child?: Maybe<Array<NewPermissionDetail>>;
  code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  module?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  package_code: Scalars['String'];
  parent_id?: Maybe<Scalars['String']>;
  permission_key: Scalars['String'];
  permissionId?: Maybe<Scalars['Float']>;
  permissionType?: Maybe<PermissionType>;
  seq_no?: Maybe<Scalars['Float']>;
  submodule?: Maybe<Scalars['String']>;
};

export type NewsAnnouncementEntity = AuditEntity & {
  __typename?: 'newsAnnouncementEntity';
  accountId: Scalars['String'];
  attachment?: Maybe<Array<AttachmentEntity>>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isExpired?: Maybe<Scalars['Boolean']>;
  isPublish: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  newsProjects: Array<NewsProjectEntity>;
  startDate: Scalars['DateTime'];
  title: Scalars['String'];
};


export type NewsAnnouncementEntityAttachmentArgs = {
  limit?: InputMaybe<Scalars['Float']>;
};

export type NewsProjectEntity = AuditEntity & {
  __typename?: 'newsProjectEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  newsAnnouncement: NewsAnnouncementEntity;
  newsId: Scalars['String'];
  projectId: Scalars['String'];
};

export type NotificationInput = {
  day?: InputMaybe<Scalars['Float']>;
  notificationList?: InputMaybe<Array<Scalars['String']>>;
};

export type NumberFormatEntity = {
  __typename?: 'numberFormatEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyNumberSetups: Array<CompanyNumberSetupEntity>;
  id: Scalars['String'];
  numberFormat: Scalars['String'];
  numberType: Scalars['String'];
};

/** JsonType */
export type OldSaleDetail = {
  __typename?: 'oldSaleDetail';
  discounts?: Maybe<Array<DiscountListingObject>>;
};

export type OldSaleDetailInput = {
  discounts?: InputMaybe<Array<DiscountListingUnitTransferInput>>;
};

export type OnlineUserEntity = AuditEntity & {
  __typename?: 'OnlineUserEntity';
  accountId: Scalars['String'];
  accountName?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  socketId?: Maybe<Scalars['String']>;
  softwareCode?: Maybe<Scalars['String']>;
  softwarePackage?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OpenLeadAssignmentSettingEntity = {
  __typename?: 'openLeadAssignmentSettingEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  lastAssign: Scalars['DateTime'];
  leadCount: Scalars['Float'];
  seq: Scalars['Float'];
  userId: Scalars['String'];
  weight: Scalars['Float'];
};

export type OpenLeadSummary = {
  __typename?: 'OpenLeadSummary';
  lastAssignedLeadCount?: Maybe<Scalars['Float']>;
  lastAssignedLeadDate?: Maybe<Scalars['String']>;
  lastImportedDate?: Maybe<Scalars['DateTime']>;
  lastImportedLeadCount?: Maybe<Scalars['Float']>;
  totalBatchImported?: Maybe<Scalars['Float']>;
};

export type PackageEntity = {
  __typename?: 'packageEntity';
  accountId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  defaultPaymentPlan?: Maybe<ProjectPaymentPlanEntity>;
  desc?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  integrationPackage: Array<IntegrationPackageEntity>;
  isDeletable: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  name: Scalars['String'];
  packageExt?: Maybe<PackageExtEntity>;
  project: ProjectEntity;
  projectAgencyPackage: ProjectAgencyPackageEntity;
  projectId: Scalars['String'];
  salesContractPackage?: Maybe<SalePackageEntity>;
  salesPackage: Array<SaleEntity>;
  startDate: Scalars['DateTime'];
  unitCount: Scalars['Float'];
  unitPackageAssignment: Array<UnitPackageAssignmentEntity>;
};

export type PackageExtEntity = {
  __typename?: 'packageExtEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  package: PackageEntity;
  packageId: Scalars['String'];
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type PanelListDto = {
  __typename?: 'PanelListDto';
  bank_name: Scalars['String'];
  financier_name: Scalars['String'];
  finproject_id: Scalars['String'];
  logo_url: Scalars['String'];
  office_tel?: Maybe<Scalars['Float']>;
  total_staff: Scalars['Float'];
};

export type ParamaterValueOutput = {
  __typename?: 'ParamaterValueOutput';
  address?: Maybe<AddressJson>;
  bank?: Maybe<LocalBankEntity>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  company: CompanyEntity;
  contactExt?: Maybe<ContactExtensionEntity>;
  developerSolicitor?: Maybe<SolicitorAppointedEntity>;
  developmentCompany: CompanyEntity;
  discount?: Maybe<Array<DiscountParamaterValueOutput>>;
  holdingCompany: CompanyEntity;
  jointBuyerDetails?: Maybe<Array<ContactEntity>>;
  jointBuyers?: Maybe<Array<JointBuyerEntity>>;
  jointBuyerSignRequired: Scalars['Boolean'];
  lead?: Maybe<LeadEntity>;
  mainBuyerDetails?: Maybe<ContactEntity>;
  payment?: Maybe<SalePaymentValueOutput>;
  project: ProjectEntity;
  sale?: Maybe<SaleEntity>;
  saleContacts?: Maybe<Array<SaleContactEntity>>;
  salePackage?: Maybe<Array<PackageEntity>>;
  saleRebate?: Maybe<Array<SaleRebatePackageEntity>>;
  spouse?: Maybe<ContactEntity>;
  unit: UnitEntity;
};

export type ParameterEntity = {
  __typename?: 'parameterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: ContactEntity;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  lead: LeadEntity;
  leadContact: LeadContactEntity;
  name: Scalars['String'];
  parameterType: Scalars['String'];
  sale: SaleEntity;
  saleBuyerPurpose: Array<SaleEntity>;
  saleBuyerReason: Array<SaleEntity>;
  saleContact: SaleContactEntity;
  seqNo?: Maybe<Scalars['Float']>;
};

export type PassswordErrorMsgOuput = {
  __typename?: 'PassswordErrorMsgOuput';
  RequireDigit: Scalars['String'];
  RequiredLength: Scalars['String'];
  RequiredUniqueChars: Scalars['String'];
  RequireLowercase: Scalars['String'];
  RequireNonAlphanumeric: Scalars['String'];
  RequireUppercase: Scalars['String'];
};

export type PassswordPolicyOuput = {
  __typename?: 'PassswordPolicyOuput';
  ErrorMsg: PassswordErrorMsgOuput;
  RequireDigit: Scalars['Boolean'];
  RequiredLength: Scalars['Float'];
  RequiredUniqueChars: Scalars['Float'];
  RequireLowercase: Scalars['Boolean'];
  RequireNonAlphanumeric: Scalars['Boolean'];
  RequireUppercase: Scalars['Boolean'];
};

export type PasswordPolicyEntity = {
  __typename?: 'passwordPolicyEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  notAllowReusePasswordForLast?: Maybe<Scalars['Float']>;
  passwordResetByDay?: Maybe<Scalars['Float']>;
  requiredDigit: Scalars['Boolean'];
  requiredMinNoCharacter?: Maybe<Scalars['Float']>;
  requiredSpecialCharacter: Scalars['Boolean'];
  requiredUpperLowerCase: Scalars['Boolean'];
};

export type PAuditEntity = {
  created_by: Scalars['String'];
  created_date: Scalars['DateTime'];
  created_ref_table: Scalars['String'];
  modified_by: Scalars['String'];
  modified_date: Scalars['DateTime'];
  modified_ref_table: Scalars['String'];
};

export type PaymentGatewayEntity = {
  __typename?: 'paymentGatewayEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  gatewayInfo: Scalars['JSONObject'];
  gatewayType: Scalars['String'];
  id: Scalars['String'];
  projectSpecs: Array<ProjectSpecEntity>;
  title: Scalars['String'];
};

export type PaymentMethodBiOutput = {
  __typename?: 'PaymentMethodBIOutput';
  cashAmount?: Maybe<Scalars['Float']>;
  cashCount?: Maybe<Scalars['Float']>;
  chequeAmount?: Maybe<Scalars['Float']>;
  chequeCount?: Maybe<Scalars['Float']>;
  creditCardAmount?: Maybe<Scalars['Float']>;
  creditCardCount?: Maybe<Scalars['Float']>;
  onlinePaymentAmount?: Maybe<Scalars['Float']>;
  onlinePaymentCount?: Maybe<Scalars['Float']>;
  onlineTransferAmount?: Maybe<Scalars['Float']>;
  onlineTransferCount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type PaymentMethodBiSummaryOutput = {
  __typename?: 'PaymentMethodBISummaryOutput';
  cashCount?: Maybe<Scalars['Float']>;
  chequeCount?: Maybe<Scalars['Float']>;
  creditCardCount?: Maybe<Scalars['Float']>;
  onlinePaymentCount?: Maybe<Scalars['Float']>;
  onlineTransferCount?: Maybe<Scalars['Float']>;
};

export type PaymentMethodEntity = {
  __typename?: 'paymentMethodEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isEft: Scalars['Boolean'];
  isPaymentRounding: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  isUse: Scalars['Boolean'];
  name: Scalars['String'];
  sequence: Scalars['Float'];
};

export type PaymentPlanDetailEntity = {
  __typename?: 'paymentPlanDetailEntity';
  accountId: Scalars['String'];
  amountType: Scalars['String'];
  amountValue: Scalars['Float'];
  architectCertWorkProgress?: Maybe<ArchitectCertWorkProgressEntity>;
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  includeInDetailId?: Maybe<Scalars['String']>;
  includeInPaymentPlanDetail: PaymentPlanDetailEntity;
  installmentBillingDay?: Maybe<Scalars['Float']>;
  installmentBillingInterval?: Maybe<Scalars['Float']>;
  isDownpayment: Scalars['Boolean'];
  isStakeholder: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  numberOfPayment?: Maybe<Scalars['Float']>;
  payment: PaymentPlanEntity;
  paymentPlanId: Scalars['String'];
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  roundingStage: Scalars['Boolean'];
  stageSeqNo: Scalars['Float'];
  stakeholderDuration?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  workProgress?: Maybe<WorkProgressEntity>;
  workProgressId: Scalars['String'];
};

export type PaymentPlanEntity = {
  __typename?: 'paymentPlanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  details?: Maybe<Array<PaymentPlanDetailEntity>>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  payMethod?: Maybe<Scalars['String']>;
  projectPaymentPlan?: Maybe<Array<ProjectPaymentPlanEntity>>;
  saleExt?: Maybe<SaleExtensionEntity>;
  unitExt?: Maybe<UnitExtensionEntity>;
};

export type PaymentReminderEntity = {
  __typename?: 'paymentReminderEntity';
  accountId: Scalars['String'];
  balanceAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  generationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
};

export type PdpaDetailByProject = {
  __typename?: 'PDPADetailByProject';
  id?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  standardLetterId?: Maybe<Scalars['String']>;
  templateBody?: Maybe<Scalars['String']>;
};

export type PerformanceByInternalAndAgency = {
  __typename?: 'PerformanceByInternalAndAgency';
  agencyName?: Maybe<Scalars['String']>;
  staff?: Maybe<Array<SalesPersonSalesAvgOutput>>;
  teamId: Scalars['String'];
  teamName: Scalars['String'];
  totalTeamCount?: Maybe<Scalars['Float']>;
  totalTeamPrice?: Maybe<Scalars['Float']>;
};

export type PerformanceObligationItemEntity = {
  __typename?: 'PerformanceObligationItemEntity';
  accountId: Scalars['String'];
  balanceSheetCode: Scalars['String'];
  commonStatus: Scalars['String'];
  discount?: Maybe<DiscountEntity>;
  id: Scalars['String'];
  package?: Maybe<PackageEntity>;
  pnlCode: Scalars['String'];
  recognitionMethod: RecognitionMethodEnum;
  refId: Scalars['String'];
  refTable: Scalars['String'];
  trxPriceMethod: TrxPriceMethodEnum;
  trxPriceValue: Scalars['Float'];
  type: PerformanceObligationItemTypeEnum;
};

export enum PerformanceObligationItemTypeEnum {
  AddedSalesValue = 'ADDED_SALES_VALUE',
  DeductSalesValue = 'DEDUCT_SALES_VALUE',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type PermissionDetail = {
  __typename?: 'PermissionDetail';
  child?: Maybe<Array<PermissionDetail>>;
  code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  permissionId?: Maybe<Scalars['Float']>;
  permissionType?: Maybe<PermissionType>;
  title: Scalars['String'];
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  accountId?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  module: Scalars['String'];
  name: Scalars['String'];
  packageCode: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  permissionOldId?: Maybe<Scalars['Float']>;
  seqNo?: Maybe<Scalars['Float']>;
  softwareCode: Scalars['String'];
  submodule?: Maybe<Scalars['String']>;
};

export type PermissionRoleAssignmentEntity = AuditEntity & {
  __typename?: 'permissionRoleAssignmentEntity';
  accountId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permission_uuid: Scalars['String'];
  permissionId: Scalars['Float'];
  roleId: Scalars['String'];
};

export enum PermissionType {
  Report = 'REPORT',
  SalesAdmin = 'SALES_ADMIN'
}

export type PictureBlockEntity = {
  __typename?: 'pictureBlockEntity';
  accountId?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  id: Scalars['String'];
  phase?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
};

export type PictureFloorEntity = {
  __typename?: 'pictureFloorEntity';
  accountId?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  floor: Scalars['Float'];
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
};

export type PictureGalleryEntity = {
  __typename?: 'pictureGalleryEntity';
  accountId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
};

export type PictureUnitlayoutEntity = {
  __typename?: 'pictureUnitlayoutEntity';
  accountId?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  id: Scalars['String'];
  noOfBathroom: Scalars['Float'];
  noOfBedroom: Scalars['Float'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
  unitLayout: UnitLayoutEntity;
  unitType?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type PlatformUserAssignedAccountEntity = {
  __typename?: 'PlatformUserAssignedAccountEntity';
  accountId: Scalars['String'];
  commonStatus: CommonStatus;
  id: Scalars['String'];
  platformUserId: Scalars['String'];
};

export type PlatformUserEntity = {
  __typename?: 'PlatformUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  contactNo?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  ID: Scalars['String'];
  isActivated: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  role: PlatformUserRole;
  username: Scalars['String'];
};

export enum PlatformUserRole {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  Superadmin = 'SUPERADMIN'
}

export type PostCodeMasterDataOutput = {
  __typename?: 'PostCodeMasterDataOutput';
  cityID: Scalars['String'];
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  postcode: Scalars['String'];
};

export type PostLogEntity = {
  __typename?: 'postLogEntity';
  body: Scalars['JSONObject'];
  endpoint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  modifiedDate: Scalars['DateTime'];
  postDate: Scalars['DateTime'];
  response?: Maybe<Scalars['String']>;
  retryCount?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

export type PreBookingQueueAssignmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type PreBookingQueueAssignmentOutput = {
  __typename?: 'preBookingQueueAssignmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PreBookingQueueEntity = {
  __typename?: 'preBookingQueueEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  convertedBy: Scalars['String'];
  convertedDate: Scalars['DateTime'];
  convertedSaleId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAiLead: Scalars['Boolean'];
  jointBuyers?: Maybe<Array<PreBookingQueueJointBuyerEntity>>;
  leavereason?: Maybe<Scalars['String']>;
  leaveTime?: Maybe<Scalars['DateTime']>;
  preBookingAttachments: BookingAttachmentsOutput;
  project: ProjectEntity;
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  seqNo: Scalars['Float'];
  staffId: Scalars['String'];
  staffType: Scalars['String'];
  teamId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type PreBookingQueueJointBuyerEntity = {
  __typename?: 'preBookingQueueJointBuyerEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  preBookingQueue: PreBookingQueueEntity;
  preBookingQueueId: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type PreBookingRequiredFieldInput = {
  ADDRESS?: InputMaybe<Scalars['Boolean']>;
  BOOKING_DOCS?: InputMaybe<Scalars['Boolean']>;
  CREDIT_REPORT_DOC?: InputMaybe<Scalars['Boolean']>;
  EMAIL?: InputMaybe<Scalars['Boolean']>;
  IC_NO?: InputMaybe<Scalars['Boolean']>;
  NRIC_DOC?: InputMaybe<Scalars['Boolean']>;
};

export type PreBookingRequiredFieldOutput = {
  __typename?: 'preBookingRequiredFieldOutput';
  ADDRESS?: Maybe<Scalars['Boolean']>;
  BOOKING_DOCS?: Maybe<Scalars['Boolean']>;
  CREDIT_REPORT_DOC?: Maybe<Scalars['Boolean']>;
  EMAIL?: Maybe<Scalars['Boolean']>;
  IC_NO?: Maybe<Scalars['Boolean']>;
  NRIC_DOC?: Maybe<Scalars['Boolean']>;
};

export type PreLaunchWaitingListByUnitOrStaffOutput = {
  __typename?: 'PreLaunchWaitingListByUnitOrStaffOutput';
  contacts: Array<ContactsListByProjectOutput>;
  total: Scalars['Float'];
};

export type PreLaunchWaitingListOutput = {
  __typename?: 'PreLaunchWaitingListOutput';
  totalUnit: Scalars['Float'];
  totalWaiting: Scalars['Float'];
  unitListOutput: Array<UnitListOutput>;
};

export type PriceAdjustmentEntity = {
  __typename?: 'priceAdjustmentEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  computationMode: Scalars['String'];
  computationValue: Scalars['Float'];
  id: Scalars['String'];
  name: Scalars['String'];
  priceAdjustmentUnit?: Maybe<Array<PriceAdjustmentUnitEntity>>;
  projectId: Scalars['String'];
  reason: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
};

export type PriceAdjustmentUnitEntity = {
  __typename?: 'priceAdjustmentUnitEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  newUnitListPrice: Scalars['Float'];
  priceAdjustmentId: Scalars['String'];
  priceAdjustments?: Maybe<PriceAdjustmentEntity>;
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  unitListPrice: Scalars['Float'];
  units?: Maybe<UnitEntity>;
};

export type ProgressBillingEntity = {
  __typename?: 'progressBillingEntity';
  accountId: Scalars['String'];
  addOnRefId?: Maybe<Scalars['String']>;
  addOnRefTable?: Maybe<Scalars['String']>;
  allowReversal: Scalars['Boolean'];
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  chargePercent: Scalars['Float'];
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount?: Maybe<Scalars['Float']>;
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  financialBilling?: Maybe<Array<FinancialBillingEntity>>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchCreditTerm?: Maybe<Scalars['Float']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  includeInStageSeq?: Maybe<Scalars['Float']>;
  installmentSeqNo?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isDownpayment: Scalars['Boolean'];
  isEinvoice: Scalars['Boolean'];
  isIncludeHoliday: Scalars['Boolean'];
  isInstallment: Scalars['Boolean'];
  isStakeholder: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  paymentPlanDetail?: Maybe<PaymentPlanDetailEntity>;
  paymentPlanDetailId: Scalars['String'];
  principalAmt?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  roundingStage: Scalars['Boolean'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  stageSeqNo: Scalars['Float'];
  stakeholderProcess?: Maybe<StakeholderProcessEntity>;
  subproduct?: Maybe<SaleSubproductEntity>;
  taxLedger?: Maybe<Array<TaxLedgerEntity>>;
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  workProgressId: Scalars['String'];
};

export type ProgressLogDetails = {
  __typename?: 'ProgressLogDetails';
  appointmentDate?: Maybe<Scalars['DateTime']>;
  logType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  progressdate?: Maybe<Scalars['DateTime']>;
  progressdesc?: Maybe<Scalars['String']>;
  progresstype?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  spaSignedByPurchaserDate?: Maybe<Scalars['DateTime']>;
  spastatus?: Maybe<Scalars['String']>;
};

export type ProjectAgencyDiscountEntity = {
  __typename?: 'projectAgencyDiscountEntity';
  accountId: Scalars['String'];
  agency: AgencyAppointedEntity;
  agencyId: Scalars['String'];
  commonStatus: Scalars['String'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type ProjectAgencyPackageEntity = {
  __typename?: 'projectAgencyPackageEntity';
  accountId: Scalars['String'];
  agency: AgencyAppointedEntity;
  agencyId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  packageId: Scalars['String'];
  projectPackage: PackageEntity;
};

export type ProjectAgencyRebateEntity = {
  __typename?: 'projectAgencyRebateEntity';
  accountId: Scalars['String'];
  agency: AgencyAppointedEntity;
  agencyId: Scalars['String'];
  commonStatus: Scalars['String'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type ProjectAreaVarianceEntity = {
  __typename?: 'projectAreaVarianceEntity';
  accountId: Scalars['String'];
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  formulaNegative?: Maybe<Scalars['String']>;
  formulaPositive?: Maybe<Scalars['String']>;
  generateMisc: Scalars['Boolean'];
  generateRebate: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectBlockMediaOuput = {
  __typename?: 'ProjectBlockMediaOuput';
  block: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  compressedImage?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectBookingDetailOutput = {
  __typename?: 'ProjectBookingDetailOutput';
  bookingFeeAttachments: Scalars['Float'];
  buyer: Scalars['Float'];
  joinBuyer: Scalars['Float'];
  otherAttachments: Scalars['Float'];
  sale: Scalars['Float'];
  unit: Scalars['Float'];
};

export type ProjectBridgingFinancierEntity = {
  __typename?: 'projectBridgingFinancierEntity';
  accountId: Scalars['String'];
  bridgingFinancier: Array<BridgingFinancierEntity>;
  commonStatus: Scalars['String'];
  financier: FinancierEntity;
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  loanDrawndownAmount: Scalars['Float'];
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  solicitorReferenceNo: Scalars['String'];
};

export type ProjectConstructionEntity = {
  __typename?: 'projectConstructionEntity';
  accountId: Scalars['String'];
  architect?: Maybe<Scalars['String']>;
  architectureStructure?: Maybe<Scalars['String']>;
  basePrice?: Maybe<Scalars['Float']>;
  buildingDesigner?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  landPermitDate?: Maybe<Scalars['DateTime']>;
  landProprietor?: Maybe<Scalars['String']>;
  numberBlockUnit?: Maybe<Scalars['Float']>;
  planner?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  propertyAgent?: Maybe<Scalars['String']>;
  spaDuration?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  superStructureType?: Maybe<Scalars['String']>;
  taxRegNo?: Maybe<Scalars['String']>;
};

export type ProjectDiscountEntity = {
  __typename?: 'projectDiscountEntity';
  accountId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expired_date: Scalars['DateTime'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type ProjectEmailLetterEntity = AuditEntity & {
  __typename?: 'projectEmailLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  emailLetterTemplate: EmailLetterTemplateEntity;
  emailLetterTemplateId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  subject: Scalars['String'];
  templateBody: Scalars['String'];
};

export type ProjectEntity = {
  __typename?: 'projectEntity';
  accountId: Scalars['String'];
  activeLoans?: Maybe<ActiveLoanStatusOutput>;
  agencyAppointedCount?: Maybe<AgencyAppointedCount>;
  agencyContract: Array<AgencyContractEntity>;
  agencySalesChartUnitDisplay?: Maybe<Array<AgencySalesChartOutput>>;
  allocations: Array<AllocationEntity>;
  amenities?: Maybe<Array<Amenities>>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  blockGalleryImage?: Maybe<Array<ProjectBlockMediaOuput>>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  builtup?: Maybe<Array<Scalars['Float']>>;
  city?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  company?: Maybe<CompanyEntity>;
  completionDate?: Maybe<Scalars['DateTime']>;
  countBook?: Maybe<BookStatusOutput>;
  countBookConfirmation?: Maybe<BookingConfirmationStatusOutput>;
  countLoan?: Maybe<LoanStatusOutput>;
  countPreLaunchWaitListAgencyOutput: CountWaitingUnitOutput;
  countPreLaunchWaitListOutput: CountWaitingUnitOutput;
  country: Scalars['String'];
  countUnassignedLeads: Scalars['Float'];
  countUnitAvailable: Scalars['Float'];
  countUnitReserved: Scalars['Float'];
  countUnitSigned: Scalars['Float'];
  countUnitTotal: Scalars['Float'];
  countWaitlistTotal: CountWaitingUnitOutput;
  currency: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  developmentCompany: CompanyEntity;
  developmentCompanyId: Scalars['String'];
  discounts: Array<ProjectDiscountEntity>;
  distinctBlock: Array<Scalars['String']>;
  distinctBlockFloor?: Maybe<Array<ProjectUnitBlockFloorOuput>>;
  embededGoogleDriveLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  embededVimeoLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  embededYoutubeLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  endfinProjectFinanciers: Array<EndfinProjectFinancierEntity>;
  existingPurchaser?: Maybe<Scalars['Float']>;
  firstGalleryImage?: Maybe<ProjectResourceOuput>;
  floorGalleryImage?: Maybe<Array<ProjectFloorMediaOuput>>;
  floorLayoutImage?: Maybe<Array<ProjectFloorMediaOuput>>;
  galleryImage?: Maybe<Array<ProjectGalleryMediaOuput>>;
  holdingCompany: CompanyEntity;
  holdingCompanyId: Scalars['String'];
  id: Scalars['String'];
  integrationDiscount: Array<IntegrationDiscountEntity>;
  integrationType?: Maybe<Scalars['String']>;
  interests: Array<InterestEntity>;
  isIntegrated: Scalars['Boolean'];
  isManager: Scalars['Boolean'];
  isSaleMade: Scalars['Boolean'];
  IsSubscribed: Scalars['JSONObject'];
  landType: Scalars['String'];
  landTypeDesc: Scalars['String'];
  launchDate?: Maybe<Scalars['DateTime']>;
  leadActivitiesFromProject: Array<LeadActivityEntity>;
  leadActivitiesProject: Array<LeadActivityEntity>;
  leads: Array<LeadEntity>;
  leadStatusCount?: Maybe<LeadStatusCountOutput>;
  ledgers: Array<LedgerEntity>;
  loanScreens: Array<LoanScreenEntity>;
  loanStatusList: Array<EndfinLoanAppStatusEntity>;
  maxPrice?: Maybe<Scalars['Float']>;
  minPrice?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  packages: Array<PackageEntity>;
  pictureBlocks: Array<PictureBlockEntity>;
  pictureBlockUrl?: Maybe<Scalars['String']>;
  pictureFloors: Array<PictureFloorEntity>;
  pictureGalleries: Array<PictureGalleryEntity>;
  pictureUnitLayouts: Array<PictureUnitlayoutEntity>;
  preBookingQueue: Array<PreBookingQueueEntity>;
  priceRange?: Maybe<Scalars['String']>;
  projectAddress?: Maybe<Scalars['String']>;
  projectAgencyDiscount: ProjectAgencyDiscountEntity;
  projectAgencyRebate: ProjectAgencyRebateEntity;
  projectCode: Scalars['String'];
  projectDetailsUnit?: Maybe<Array<UnitEntity>>;
  projectEmailLetter: Array<ProjectEmailLetterEntity>;
  projectExt?: Maybe<ProjectExtEntity>;
  projectGps?: Maybe<Scalars['String']>;
  projectIntegration: ProjectIntegrationEntity;
  projectLetter: Array<ProjectLetterEntity>;
  projectSpec: Array<ProjectSpecEntity>;
  projectSpecs: ProjectSpecEntity;
  projectType: ProjectTypeEntity;
  reminders: Array<ReminderEntity>;
  resourcefloor?: Maybe<Array<ResourceEntity>>;
  resourceunitlayout?: Maybe<Array<ResourceEntity>>;
  saleGalleryAddress?: Maybe<Scalars['String']>;
  saleGalleryGps?: Maybe<Scalars['String']>;
  sales: Array<SaleEntity>;
  saleschartBlock: Array<Scalars['String']>;
  salesCharts: Array<SalesChartEntity>;
  salesDoc: Array<SalesDocEntity>;
  saleTeamAllocation: Array<SaleTeamAllocationEntity>;
  schedules: Array<ScheduleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
  solicitorCount?: Maybe<SolicitorStatusCount>;
  solicitorLayoutList?: Maybe<Array<SolicitorLayoutList>>;
  solicitorStatusCount: ProjectSolicitorCount;
  state?: Maybe<Scalars['String']>;
  tenure: Scalars['String'];
  tenureDesc: Scalars['String'];
  totalLoanCount?: Maybe<Scalars['Float']>;
  township?: Maybe<TownshipEntity>;
  townshipId?: Maybe<Scalars['String']>;
  unitCountByBlock: Array<BlockCountByStatusOutput>;
  unitCountByStatus?: Maybe<ProjectUnitStatusCount>;
  unitCountByUnitType: Array<UnitTypeCountByStatusOutput>;
  unitLayoutGalleryImage?: Maybe<Array<ProjectUnitLayoutMediaOuput>>;
  unitLayoutImage?: Maybe<Array<ProjectUnitLayoutMediaOuput>>;
  unitLayouts: Array<UnitLayoutEntity>;
  unitMaxBuiltUp?: Maybe<Scalars['String']>;
  unitMaxPrice?: Maybe<Scalars['String']>;
  unitMinBuiltUp?: Maybe<Scalars['String']>;
  unitMinPrice?: Maybe<Scalars['String']>;
  units: Array<UnitEntity>;
  unitTourVirtual?: Maybe<Array<UnitTourVirtualOutput>>;
  unitTypes?: Maybe<Array<UnitTypeOutput>>;
  uom: Scalars['String'];
  uomDesc: Scalars['String'];
  videoLink?: Maybe<Array<MediaSource>>;
  virtualModel?: Maybe<Array<ProjectResourceOuput>>;
  virtualModelLink?: Maybe<Array<MediaSource>>;
  vpDate?: Maybe<Scalars['DateTime']>;
  withdrawnLoans?: Maybe<WithdrawnLoanStatusOutput>;
};


export type ProjectEntityAgencySalesChartUnitDisplayArgs = {
  agencyId: Scalars['String'];
  block: Scalars['String'];
};


export type ProjectEntityBlockGalleryImageArgs = {
  phase?: InputMaybe<Scalars['String']>;
};


export type ProjectEntityDistinctBlockArgs = {
  phase?: InputMaybe<Scalars['String']>;
};


export type ProjectEntityFloorLayoutImageArgs = {
  block?: InputMaybe<Array<Scalars['String']>>;
  floor?: InputMaybe<Array<Scalars['Float']>>;
};


export type ProjectEntityPictureBlockUrlArgs = {
  block: Scalars['String'];
};


export type ProjectEntitySaleschartBlockArgs = {
  phase?: InputMaybe<Scalars['String']>;
};


export type ProjectEntitySolicitorLayoutListArgs = {
  solicitorAppointedId?: InputMaybe<Scalars['String']>;
};


export type ProjectEntityUnitLayoutImageArgs = {
  unitBlock?: InputMaybe<Array<Scalars['String']>>;
  unitLayout?: InputMaybe<Array<Scalars['String']>>;
  unitType?: InputMaybe<Array<Scalars['String']>>;
};


export type ProjectEntityUnitMaxPriceArgs = {
  phase?: InputMaybe<Scalars['String']>;
};


export type ProjectEntityUnitMinPriceArgs = {
  phase?: InputMaybe<Scalars['String']>;
};

export type ProjectExtEntity = {
  __typename?: 'projectExtEntity';
  accountId: Scalars['String'];
  bankAccount: BankAccountEntity;
  bankAccountId?: Maybe<Scalars['String']>;
  bankProfile: BankProfileEntity;
  bankProfileId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  plotNo?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type ProjectFireInsuranceEntity = {
  __typename?: 'projectFireInsuranceEntity';
  accountId: Scalars['String'];
  certificateNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  companyAddress?: Maybe<AddressJson>;
  companyName?: Maybe<Scalars['String']>;
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
  issueDate: Scalars['DateTime'];
  projectId: Scalars['String'];
};

export type ProjectFloorMediaOuput = {
  __typename?: 'ProjectFloorMediaOuput';
  block: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  compressedImage?: Maybe<Scalars['String']>;
  floor: Scalars['Float'];
  floorlabel?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectGalleryMediaOuput = {
  __typename?: 'ProjectGalleryMediaOuput';
  caption?: Maybe<Scalars['String']>;
  compressedImage?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  seqno?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectIntegrationEntity = {
  __typename?: 'projectIntegrationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  gracePeriod?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ifcaCompanyId?: Maybe<Scalars['String']>;
  ifcaCompanyName?: Maybe<Scalars['String']>;
  ifcaPhaseId?: Maybe<Scalars['String']>;
  ifcaPhaseName?: Maybe<Scalars['String']>;
  ifcaProjectId?: Maybe<Scalars['String']>;
  ifcaProjectName?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrationUrl?: Maybe<Scalars['String']>;
  isDiscountIntegrated: Scalars['Boolean'];
  isMultiplePhaseIntegrated: Scalars['Boolean'];
  isPackagesIntegrated: Scalars['Boolean'];
  isRebateIntegrated: Scalars['Boolean'];
  isSolicitorIntegrated: Scalars['Boolean'];
  paymentPlanCode?: Maybe<Scalars['String']>;
  paymentPlanDesc?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectIntegrationLogEntity = AuditEntity & {
  __typename?: 'projectIntegrationLogEntity';
  accountId: Scalars['String'];
  activityType: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  phase: Array<Scalars['Float']>;
  projectId: Scalars['String'];
};

export type ProjectKeyCollectionContractorEntity = {
  __typename?: 'projectKeyCollectionContractorEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contactNo: Scalars['String'];
  contractorType: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectKeyCollectionScheduleEntity = {
  __typename?: 'projectKeyCollectionScheduleEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  endDate: Scalars['DateTime'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  interval: Scalars['Float'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  teamMember: TeamMemberObject;
  timeslot: Array<ProjectKeyCollectionTimeSlotEntity>;
};

export type ProjectKeyCollectionTimeSlotEntity = {
  __typename?: 'projectKeyCollectionTimeSlotEntity';
  accountId: Scalars['String'];
  appointment?: Maybe<KeyCollectionAppointmentEntity>;
  collectionScheduleId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  keyCollectionSchedule?: Maybe<ProjectKeyCollectionScheduleEntity>;
  projectId: Scalars['String'];
  scheduleDate: Scalars['DateTime'];
  scheduleTime: Scalars['String'];
  userId: Scalars['String'];
};

export type ProjectLadEntity = {
  __typename?: 'projectLadEntity';
  accountId: Scalars['String'];
  commonFacility: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  facilityAdditionalDay?: Maybe<Scalars['Float']>;
  facilityLadDuration?: Maybe<Scalars['Float']>;
  facilityLadPercent?: Maybe<Scalars['Float']>;
  facilityStartWith?: Maybe<Scalars['String']>;
  facilityVpDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  payoutPercent: Scalars['Float'];
  projectId: Scalars['String'];
  spaPercent?: Maybe<Scalars['Float']>;
  startWith: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
  unitAdditionalDay?: Maybe<Scalars['Float']>;
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
};

export type ProjectLastActiveTransactionsEntity = {
  __typename?: 'projectLastActiveTransactionsEntity';
  booked: Scalars['Float'];
  cancelled: Scalars['Float'];
  project_id: Scalars['String'];
  signed: Scalars['Float'];
  total: Scalars['Float'];
  transaction_date: Scalars['DateTime'];
};

export type ProjectLateInterestEntity = {
  __typename?: 'projectLateInterestEntity';
  accountId: Scalars['String'];
  enableFloatingInterest: Scalars['Boolean'];
  excludeHoliday: Scalars['Boolean'];
  excludePaymentDate: Scalars['Boolean'];
  id: Scalars['String'];
  loanGracePeriod: Scalars['Float'];
  loanGracePeriodStartWith: Scalars['String'];
  minimumInterestAmount: Scalars['Float'];
  projectId: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
};

export type ProjectLateInterestExceptionEntity = {
  __typename?: 'projectLateInterestExceptionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
};

export type ProjectLetterEntity = {
  __typename?: 'projectLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isLetterVisibleInESigning: Scalars['Boolean'];
  isViewInESigning: Scalars['Boolean'];
  letterTemplate: LetterTemplateEntity;
  project: ProjectEntity;
};

export type ProjectLetterTemplateEntity = {
  __typename?: 'projectLetterTemplateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  standardLetter: StandardLetterEntity;
  standardLetterDataSourceVersion?: Maybe<Scalars['Float']>;
  standardLetterId: Scalars['String'];
  templateBody?: Maybe<Scalars['String']>;
};

export type ProjectLetterTemplateSelectorEntity = {
  __typename?: 'projectLetterTemplateSelectorEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  selectionBookingEntry: Scalars['Boolean'];
  standardLetterId: Scalars['String'];
};

export type ProjectMiscChargesEntity = {
  __typename?: 'projectMiscChargesEntity';
  accountId: Scalars['String'];
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  formula: Scalars['String'];
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  taxScheme?: Maybe<TaxSchemeEntity>;
  taxSchemeId: Scalars['String'];
};

export type ProjectPaymentPlanEntity = {
  __typename?: 'projectPaymentPlanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  paymentPlan: PaymentPlanEntity;
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectPaymentReminderExceptionEntity = AuditEntity & {
  __typename?: 'projectPaymentReminderExceptionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  maxReminder?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
};

export type ProjectPermitEntity = {
  __typename?: 'projectPermitEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
  issueDate: Scalars['DateTime'];
  permitNo: Scalars['String'];
  permitType: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectPolicyEntity = {
  __typename?: 'projectPolicyEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaultAdminFeeBillItemId?: Maybe<Scalars['String']>;
  defaultAreaVarianceMiscBillItemId?: Maybe<Scalars['String']>;
  defaultForfeitureSumBillItemId?: Maybe<Scalars['String']>;
  defaultLadBillItemId?: Maybe<Scalars['String']>;
  defaultLatePaymentBillItemId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  toleranceAmount: Scalars['Float'];
};

export type ProjectReminderEntity = AuditEntity & {
  __typename?: 'projectReminderEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  downpaymentReminder1: Scalars['Float'];
  downpaymentReminder2: Scalars['Float'];
  downpaymentReminder3: Scalars['Float'];
  downpaymentReminder4: Scalars['Float'];
  id: Scalars['String'];
  minimumAmount: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentReminder1: Scalars['Float'];
  paymentReminder2: Scalars['Float'];
  paymentReminder3: Scalars['Float'];
  paymentReminder4: Scalars['Float'];
  projectId: Scalars['String'];
  reminderFor?: Maybe<Scalars['String']>;
  spaReminder1: Scalars['Float'];
  spaReminder2: Scalars['Float'];
  spaReminder3: Scalars['Float'];
  spaReminder4: Scalars['Float'];
};

export type ProjectResourceOuput = {
  __typename?: 'ProjectResourceOuput';
  caption?: Maybe<Scalars['String']>;
  compressedImage?: Maybe<Scalars['String']>;
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectSaleListOuput = {
  __typename?: 'ProjectSaleListOuput';
  booking_amount?: Maybe<Scalars['Float']>;
  contact_id: Scalars['String'];
  date: Scalars['DateTime'];
  full_name: Scalars['String'];
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
  sales_status: Scalars['String'];
  salesPerson?: Maybe<UserEntity>;
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_price: Scalars['String'];
};

export type ProjectSalesOfficeEntity = {
  __typename?: 'ProjectSalesOfficeEntity';
  accountId: Scalars['String'];
  architecturePermit?: Maybe<Scalars['String']>;
  areaUOM1?: Maybe<Scalars['String']>;
  areaUOM2?: Maybe<Scalars['String']>;
  areaUOM3?: Maybe<Scalars['String']>;
  areaUOMConversion1?: Maybe<Scalars['String']>;
  areaUOMConversion2?: Maybe<Scalars['String']>;
  buildingContractorAwarded?: Maybe<Scalars['String']>;
  buildingContractorName?: Maybe<Scalars['String']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  commonArea?: Maybe<Scalars['Float']>;
  commonAreaPercent?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  constructionPermit?: Maybe<Scalars['String']>;
  creditControlEmail?: Maybe<Scalars['String']>;
  creditControlHOD?: Maybe<Scalars['String']>;
  creditControlOfficeTel?: Maybe<Scalars['String']>;
  customerCareContactNo?: Maybe<Scalars['String']>;
  customerCareEmail?: Maybe<Scalars['String']>;
  customerCareHOD?: Maybe<Scalars['String']>;
  customerCareLocalAuthorityAddress?: Maybe<AddressJson>;
  customerCareLocalAuthorityContactNo?: Maybe<Scalars['String']>;
  customerCareLocalAuthorityName?: Maybe<Scalars['String']>;
  densityPercentage?: Maybe<Scalars['Float']>;
  DLPTerm1?: Maybe<Scalars['String']>;
  DLPTerm2?: Maybe<Scalars['String']>;
  floorArea?: Maybe<Scalars['Float']>;
  floorAreaPercent?: Maybe<Scalars['Float']>;
  generalManager?: Maybe<Scalars['String']>;
  greenspaceArea?: Maybe<Scalars['Float']>;
  greenspaceAreaPercent?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  landArea?: Maybe<Scalars['Float']>;
  mccAddress?: Maybe<AddressJson>;
  mccContactPersonName?: Maybe<Scalars['String']>;
  mccEmail?: Maybe<Scalars['String']>;
  mccName?: Maybe<Scalars['String']>;
  mccTelNo?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  projectManager?: Maybe<Scalars['String']>;
  propertyManager?: Maybe<Scalars['String']>;
  salesLocalAuthorityAddress?: Maybe<AddressJson>;
  salesLocalAuthorityContactNo?: Maybe<Scalars['String']>;
  salesLocalAuthorityName?: Maybe<Scalars['String']>;
  salesMarketingHOD?: Maybe<Scalars['String']>;
  salesOfficeAddress?: Maybe<AddressJson>;
  salesOfficeEmail?: Maybe<Scalars['String']>;
  salesOfficeFax?: Maybe<Scalars['String']>;
  salesOfficeTel?: Maybe<Scalars['String']>;
  salesPermit?: Maybe<Scalars['String']>;
  usagePurpose?: Maybe<Scalars['String']>;
  usageRatioPercent?: Maybe<Scalars['Float']>;
  warrantyPeriod?: Maybe<Scalars['Float']>;
};

export type ProjectSalesPerformanceBiSummaryOutput = {
  __typename?: 'ProjectSalesPerformanceBISummaryOutput';
  psp_available_count?: Maybe<Scalars['Float']>;
  psp_booked_count?: Maybe<Scalars['Float']>;
  psp_reservation_count?: Maybe<Scalars['Float']>;
  psp_signed_count?: Maybe<Scalars['Float']>;
  psp_total_count?: Maybe<Scalars['Float']>;
  psp_unavailable_count?: Maybe<Scalars['Float']>;
};

export type ProjectSolicitorCount = {
  __typename?: 'ProjectSolicitorCount';
  open?: Maybe<Scalars['Float']>;
  signed?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type ProjectSpecEntity = {
  __typename?: 'projectSpecEntity';
  accountId: Scalars['String'];
  agencyLeadNotification?: Maybe<AgencyLeadNotificationOutput>;
  agencyLeadsAssignmentShow: Scalars['Boolean'];
  alertAgingActivated: Scalars['Boolean'];
  assignEndTime?: Maybe<Scalars['String']>;
  assignStartTime?: Maybe<Scalars['String']>;
  autoAssignLeadActivated: Scalars['Boolean'];
  autoReassignLeadActivated: Scalars['Boolean'];
  autoReassignLeadDuration?: Maybe<Scalars['Float']>;
  autoReleaseNotificationReminder?: Maybe<AutoReleaseNotificationReminderOutput>;
  autoReleaseReservationDay: Scalars['Float'];
  bookingfeeAmountRequired: Scalars['Boolean'];
  bookingFeeMandatory: Scalars['Boolean'];
  bookingFormLang: Scalars['String'];
  bookingPDPAconsentRequired: Scalars['Boolean'];
  bookingRefundPolicyconsentRequired: Scalars['Boolean'];
  bookingSignRequired: Scalars['Boolean'];
  ccrAttachmentRequired: Scalars['Boolean'];
  creditTerm?: Maybe<Scalars['Float']>;
  display2DChart: Scalars['Boolean'];
  displayBuiltUpArea: Scalars['Boolean'];
  displayDirection: Scalars['Boolean'];
  displayUnitType: Scalars['Boolean'];
  ELetteringSMSRequired: Scalars['Boolean'];
  expectedSnpDuration?: Maybe<Scalars['Float']>;
  expectedSnpRequired: Scalars['Boolean'];
  getAccountSpec?: Maybe<AccountSpecEntity>;
  gracePeriod?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  ifcaReceiptDesc: Scalars['String'];
  isIfcaReceiptDefaultDesc: Scalars['Boolean'];
  isReservationEnable?: Maybe<Scalars['Boolean']>;
  lateInterestRate?: Maybe<Scalars['Float']>;
  leadAgingActivated: Scalars['Boolean'];
  leadAgingManagerHandled?: Maybe<Array<Scalars['String']>>;
  leadAgingNotificationMethod?: Maybe<Array<Scalars['String']>>;
  leadAssignNotificationActivated: Scalars['Boolean'];
  leadAssignNotificationMethod?: Maybe<Array<Scalars['String']>>;
  leadEmailRequired: Scalars['Boolean'];
  leadIdleOne?: Maybe<Scalars['Float']>;
  leadIdleThree?: Maybe<Scalars['Float']>;
  leadIdleTwo?: Maybe<Scalars['Float']>;
  loanAlertAging?: Maybe<LoanAlertAgingOutput>;
  loanconsentRequired: Scalars['Boolean'];
  loanScreening: Scalars['Boolean'];
  maxWaitingList: Scalars['Float'];
  minAge?: Maybe<Scalars['Float']>;
  minAgeRequired: Scalars['Boolean'];
  minBookingfeeAmount: Scalars['Float'];
  notifyUnattendedLeadActivated: Scalars['Boolean'];
  notifyUnattendedLeadDuration?: Maybe<Scalars['Float']>;
  nricAttachmentRequired: Scalars['Boolean'];
  paymentGateway?: Maybe<PaymentGatewayEntity>;
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentGatewayRefundPolicy?: Maybe<Scalars['String']>;
  preBookingRequiredField?: Maybe<PreBookingRequiredFieldOutput>;
  preLaunchWaitlist: Scalars['Boolean'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  purchaserAppSetting: Scalars['String'];
  purchaserAppSubmenu?: Maybe<PurchaserAppSubmenuOutput>;
  purchaserLeadNotification?: Maybe<PurchaserLeadNotificationOutput>;
  reassignEndTime?: Maybe<Scalars['String']>;
  reassignStartTime?: Maybe<Scalars['String']>;
  reminder_1Duration?: Maybe<Scalars['Float']>;
  reminder_2Duration?: Maybe<Scalars['Float']>;
  reminder_3Duration?: Maybe<Scalars['Float']>;
  reminder_4Duration?: Maybe<Scalars['Float']>;
  requiredField?: Maybe<RequiredFieldOutput>;
  reservationAgency: Scalars['Boolean'];
  reservationSales: Scalars['Boolean'];
  saleLeadNotification?: Maybe<SaleLeadNotificationOutput>;
  salesAlertAging?: Maybe<SalesAlertAgingOutput>;
  solicitorAlertAging?: Maybe<SolicitorAlertAgingOutput>;
  statementRefundPolicy?: Maybe<Scalars['String']>;
  templateAddressShow: Scalars['Boolean'];
  templateCompanyShow?: Maybe<Scalars['String']>;
  templateDiscountsShow: Scalars['Boolean'];
  templateMaritalStatusShow: Scalars['Boolean'];
  templatePackagesShow: Scalars['Boolean'];
  templateRemarksShow: Scalars['Boolean'];
  trGeneration: Scalars['Boolean'];
  unattendedLeadManagerHandled?: Maybe<Array<Scalars['String']>>;
  unattendedLeadNotificationMethod?: Maybe<Array<Scalars['String']>>;
  unitLockAgency: Scalars['Boolean'];
  unitLockBufferDuration: Scalars['Float'];
  unitLockDuration: Scalars['Float'];
  unitLockSales: Scalars['Boolean'];
  unitSort: Scalars['String'];
};

export type ProjectTitleEntity = AuditEntity & {
  __typename?: 'projectTitleEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  issueDate?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  projectTitleUnits: Array<ProjectTitleUnitEntity>;
  receiveDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  titleNo: Scalars['String'];
  titleType: Scalars['String'];
};

export type ProjectTitleUnitEntity = {
  __typename?: 'projectTitleUnitEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  projectTitle: ProjectTitleEntity;
  projectTitleId: Scalars['String'];
  unitId: Scalars['String'];
  units: UnitEntity;
};

export type ProjectTypeEntity = {
  __typename?: 'projectTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  projects: Array<ProjectEntity>;
  seq_no?: Maybe<Scalars['Float']>;
};

export type ProjectUnitBlockFloorOuput = {
  __typename?: 'ProjectUnitBlockFloorOuput';
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorlabel: Scalars['String'];
};

export type ProjectUnitLayoutMediaOuput = {
  __typename?: 'ProjectUnitLayoutMediaOuput';
  block?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  compressedImage?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  noOfBathroom?: Maybe<Scalars['Float']>;
  noOfBedroom?: Maybe<Scalars['Float']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  seqno?: Maybe<Scalars['Float']>;
  unit_type_desc?: Maybe<Scalars['String']>;
  unit_type_id?: Maybe<Scalars['String']>;
  unitcount?: Maybe<Scalars['Float']>;
  unitLayout?: Maybe<Scalars['String']>;
  unitlayoutid?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  virtualModelLink?: Maybe<Scalars['String']>;
};

export type ProjectUnitStatusCount = {
  __typename?: 'ProjectUnitStatusCount';
  availableUnitCount?: Maybe<Scalars['Float']>;
  bookUnitCount?: Maybe<Scalars['Float']>;
  reservationUnitCount?: Maybe<Scalars['Float']>;
  signedUnitCount?: Maybe<Scalars['Float']>;
  totalAvailableUnitPrice?: Maybe<Scalars['Float']>;
  totalBookUnitPrice?: Maybe<Scalars['Float']>;
  totalReservationUnitPrice?: Maybe<Scalars['Float']>;
  totalSignedUnitPrice?: Maybe<Scalars['Float']>;
  totalSoldUnitPrice?: Maybe<Scalars['Float']>;
  totalUnavailableUnitPrice?: Maybe<Scalars['Float']>;
  totalUnitCount?: Maybe<Scalars['Float']>;
  totalUnitPrice?: Maybe<Scalars['Float']>;
  unavailableUnitCount?: Maybe<Scalars['Float']>;
};

export type ProjectYoutubeLinkOutput = {
  __typename?: 'ProjectYoutubeLinkOutput';
  caption?: Maybe<Scalars['String']>;
  thumbnail: Scalars['String'];
  url: Scalars['String'];
  videoType?: Maybe<Scalars['String']>;
};

export type PropertyTypeEntity = {
  __typename?: 'propertyTypeEntity';
  accountId: Scalars['String'];
  commercialPurpose: Scalars['String'];
  commercialPurposeDesc: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  propertyTypeExt?: Maybe<PropertyTypeExtEntity>;
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
};

export type PropertyTypeExtEntity = {
  __typename?: 'propertyTypeExtEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  propertyType: PropertyTypeEntity;
  propertyTypeId: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type PurchaseLeadNotificationInput = {
  keyCollectionAppointment?: InputMaybe<PurchaserKeyCollectionAppointmentInput>;
  keyCollectionAppointmentReschedule?: InputMaybe<KeyCollectionAppointmentRescheduleInput>;
};

export type PurchaserAccountReferenceEntity = AuditEntity & {
  __typename?: 'purchaserAccountReferenceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId?: Maybe<Array<PurchaserReferenceOutput>>;
  userId: Scalars['String'];
};

export type PurchaserAppBookedSubmenuInput = {
  booking_info?: InputMaybe<Scalars['Boolean']>;
  loan?: InputMaybe<Scalars['Boolean']>;
  overall_site_progress?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserAppBookedSubmenuOutput = {
  __typename?: 'PurchaserAppBookedSubmenuOutput';
  booking_info?: Maybe<Scalars['Boolean']>;
  loan?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppCssInput = {
  backgroundAttachment?: InputMaybe<Scalars['String']>;
  backgroundImage?: InputMaybe<Scalars['String']>;
  backgroundPosition?: InputMaybe<Scalars['String']>;
  backgroundRepeat?: InputMaybe<Scalars['String']>;
  backgroundSize?: InputMaybe<Scalars['String']>;
  boxShadow?: InputMaybe<Scalars['String']>;
  cardColor?: InputMaybe<Scalars['String']>;
  headerColor?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  showLoginIcon?: InputMaybe<Scalars['Boolean']>;
  showPurchaserAppWord?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserAppCssOutput = {
  __typename?: 'purchaserAppCssOutput';
  backgroundAttachment?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  backgroundPosition?: Maybe<Scalars['String']>;
  backgroundRepeat?: Maybe<Scalars['String']>;
  backgroundSize?: Maybe<Scalars['String']>;
  boxShadow?: Maybe<Scalars['String']>;
  cardColor?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  showLoginIcon?: Maybe<Scalars['Boolean']>;
  showPurchaserAppWord?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSignedSubmenuInput = {
  accounts?: InputMaybe<Scalars['Boolean']>;
  key_collection?: InputMaybe<Scalars['Boolean']>;
  overall_site_progress?: InputMaybe<Scalars['Boolean']>;
  s_and_p?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserAppSignedSubmenuOutput = {
  __typename?: 'PurchaserAppSignedSubmenuOutput';
  accounts?: Maybe<Scalars['Boolean']>;
  key_collection?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
  s_and_p?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSubmenuInput = {
  booked?: InputMaybe<PurchaserAppBookedSubmenuInput>;
  signed?: InputMaybe<PurchaserAppSignedSubmenuInput>;
};

export type PurchaserAppSubmenuOutput = {
  __typename?: 'PurchaserAppSubmenuOutput';
  booked?: Maybe<PurchaserAppBookedSubmenuOutput>;
  signed?: Maybe<PurchaserAppSignedSubmenuOutput>;
};

export type PurchaserContactEntity = AuditEntity & {
  __typename?: 'purchaserContactEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lead?: Maybe<Array<PurchaserLeadContactOutput>>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: PurchaserUserEntity;
  userId: Scalars['String'];
};

export type PurchaserKeyCollectionAppointmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: InputMaybe<Scalars['Boolean']>;
  purchaserUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserKeyCollectionAppointmentOutput = {
  __typename?: 'purchaserKeyCollectionAppointmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserKeyCollectionAppointmentRescheduleOutput = {
  __typename?: 'purchaserKeyCollectionAppointmentRescheduleOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserLeadContactInput = {
  LeadId: Scalars['String'];
  ProjectId: Scalars['String'];
};

export type PurchaserLeadContactOutput = {
  __typename?: 'PurchaserLeadContactOutput';
  LeadId: Scalars['String'];
  ProjectId: Scalars['String'];
};

export type PurchaserLeadNotificationOutput = {
  __typename?: 'PurchaserLeadNotificationOutput';
  keyCollectionAppointment?: Maybe<PurchaserKeyCollectionAppointmentOutput>;
  keyCollectionAppointmentReschedule?: Maybe<PurchaserKeyCollectionAppointmentRescheduleOutput>;
};

export type PurchaserNotificationEntity = {
  __typename?: 'purchaserNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  purchaserNotificationRecipient: Array<PurchaserNotificationRecipientEntity>;
  subject: Scalars['String'];
};

export type PurchaserNotificationRecipientEntity = {
  __typename?: 'purchaserNotificationRecipientEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserNotification: PurchaserNotificationEntity;
  recipientId: Scalars['String'];
};

export type PurchaserPaymentEntity = AuditEntity & {
  __typename?: 'purchaserPaymentEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  ifcaSaleId?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentStatus: Scalars['String'];
  receiptNo?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
  response: Scalars['JSONObject'];
  saleId?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  transactionMethod?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type PurchaserReferenceInput = {
  AccountID: Scalars['Float'];
  IntegrationId?: InputMaybe<Scalars['String']>;
  IsIntegrate?: InputMaybe<Scalars['Boolean']>;
  ProjectId: Scalars['Float'];
  ProjectID: Scalars['Float'];
  SaleId: Scalars['Float'];
  SaleStatus: Scalars['String'];
  UnitId: Scalars['Float'];
};

export type PurchaserReferenceOutput = {
  __typename?: 'PurchaserReferenceOutput';
  AccountID: Scalars['Float'];
  IntegrationId?: Maybe<Scalars['String']>;
  IsIntegrate?: Maybe<Scalars['Boolean']>;
  ProjectId: Scalars['Float'];
  ProjectID: Scalars['Float'];
  SaleId: Scalars['Float'];
  SaleStatus: Scalars['String'];
  UnitId: Scalars['Float'];
};

export type PurchaserUserEntity = AuditEntity & {
  __typename?: 'purchaserUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  passwordHash?: Maybe<Scalars['String']>;
  purchaserAccountReference?: Maybe<PurchaserAccountReferenceEntity>;
  purchaserContact: PurchaserContactEntity;
  refreshToken?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  CaseStatus: Scalars['JSONObject'];
  GetBookingDetails: SaleEntity;
  getELetterPDF: ELetterOutput;
  getESignLetter: Array<ESignProjectLetterListingOutput>;
  getFlattenMultiELetterBySaleId?: Maybe<Array<ESignProjectLetterListingOutput>>;
  getMultiELetterBySaleId?: Maybe<Array<MultipleEsignProjectLetterListingOutput>>;
  getNotificationHistoryDay?: Maybe<Scalars['Float']>;
  getNotificationPermission: Scalars['JSONObject'];
  getNotifications?: Maybe<Scalars['JSONObject']>;
  getProject: ProjectEntity;
  getProjectLetterForDocListing?: Maybe<Array<ESignProjectLetterListingOutput>>;
  getProjects: Array<ProjectEntity>;
  GetPurchaserDetails: ContactEntity;
  getSaleList: Array<SoliciorListingOutput>;
  getSolicitorAccountName: Scalars['String'];
  getStaff?: Maybe<Array<SolicitorContactEntity>>;
  getStaffById: SolicitorContactEntity;
  GetUnitDetails: UnitEntity;
  getUserNotificationPermission?: Maybe<Array<Scalars['String']>>;
  LoanAgreementStatus: Scalars['JSONObject'];
  login: SolicitorUserEntity;
  logout: Scalars['Boolean'];
  markAllRead: Scalars['Boolean'];
  passswordPolicy: PassswordPolicyOuput;
  profile: SolicitorContactEntity;
  refreshToken?: Maybe<AccessTokenInterface>;
  registerToken: SolicitorAppointedEntity;
};


export type QueryGetBookingDetailsArgs = {
  sale_id: Scalars['String'];
};


export type QueryGetELetterPdfArgs = {
  letterTemplateId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetESignLetterArgs = {
  saleId: Scalars['String'];
};


export type QueryGetFlattenMultiELetterBySaleIdArgs = {
  saleId: Scalars['String'];
};


export type QueryGetMultiELetterBySaleIdArgs = {
  saleId: Scalars['String'];
};


export type QueryGetNotificationsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProjectLetterForDocListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPurchaserDetailsArgs = {
  contactId: Scalars['String'];
};


export type QueryGetStaffByIdArgs = {
  contactId: Scalars['String'];
};


export type QueryGetUnitDetailsArgs = {
  unitId: Scalars['String'];
};


export type QueryLoginArgs = {
  LoginId: Scalars['String'];
  Password: Scalars['String'];
  SolicitorAppointedId?: InputMaybe<Scalars['String']>;
};


export type QueryRegisterTokenArgs = {
  register_link: Scalars['String'];
};

export type QueryFilterString = {
  __typename?: 'QueryFilterString';
  Column: Scalars['String'];
  Expression: Scalars['String'];
  ParameterName?: Maybe<Scalars['String']>;
  Value: Scalars['String'];
};

export type QueryFilterStringInput = {
  Column: Scalars['String'];
  Expression: Scalars['String'];
  ParameterName?: InputMaybe<Scalars['String']>;
  Value: Scalars['String'];
};

export type QueryParameter = {
  __typename?: 'QueryParameter';
  Name: Scalars['String'];
  Type?: Maybe<Scalars['String']>;
  Value: Scalars['String'];
  ValueType: Scalars['String'];
};

export type QueryParameterInput = {
  Name: Scalars['String'];
  Type?: InputMaybe<Scalars['String']>;
  Value: Scalars['String'];
  ValueType: Scalars['String'];
};

export type RaceEntity = {
  __typename?: 'raceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
};

export type ReasonCodeEntity = {
  __typename?: 'reasonCodeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
  type: Scalars['String'];
};

export type RebateEntity = {
  __typename?: 'rebateEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  saleRebatePackage: SaleRebatePackageEntity;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type ReceiptEntity = {
  __typename?: 'receiptEntity';
  accountId: Scalars['String'];
  accounts?: Maybe<Array<BankAccountEntity>>;
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardFacilityId?: Maybe<Scalars['String']>;
  creditCardTypeId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  exchangeRate?: Maybe<Scalars['Float']>;
  financierId?: Maybe<Scalars['String']>;
  financiers?: Maybe<FinancierEntity>;
  generationBatch: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
  projectId: Scalars['String'];
  receiptAmount: Scalars['Float'];
  referenceNo?: Maybe<Scalars['String']>;
  roundingAmount: Scalars['Float'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type ReceiptReversalEntity = {
  __typename?: 'receiptReversalEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccount?: Maybe<Array<BankAccountEntity>>;
  bankAccountId?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  exchangeRate?: Maybe<Scalars['Float']>;
  financierId?: Maybe<Scalars['String']>;
  financiers?: Maybe<Array<FinancierEntity>>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  receiptAmount: Scalars['Float'];
  referenceNo?: Maybe<Scalars['String']>;
  roundingAmount: Scalars['Float'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export enum RecognitionMethodEnum {
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  OvertimeByPoc = 'OVERTIME_BY_POC',
  PointInTimeUponSpaSign = 'POINT_IN_TIME_UPON_SPA_SIGN'
}

export type RedemptionDetailEntity = {
  __typename?: 'redemptionDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectBridgingFinancierId: Scalars['String'];
  projectId: Scalars['String'];
  redemption: RedemptionEntity;
  redemptionAmount: Scalars['Float'];
  redemptionId: Scalars['String'];
  unitId: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RedemptionEntity = {
  __typename?: 'redemptionEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  isPosted: Scalars['Boolean'];
  paidById: Scalars['String'];
  paymentParty: Scalars['String'];
  projectId: Scalars['String'];
  redemptionDetails: Array<RedemptionDetailEntity>;
  redemptionSum: Scalars['Float'];
  referenceNo?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['DateTime']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RefinancingEntity = {
  __typename?: 'refinancingEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  completedDate?: Maybe<Scalars['DateTime']>;
  doaDate?: Maybe<Scalars['DateTime']>;
  doaSolicitorId?: Maybe<Scalars['String']>;
  doaSolicitorReferenceNo?: Maybe<Scalars['String']>;
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  financiers?: Maybe<Array<FinancierEntity>>;
  generationBatch: Scalars['String'];
  id: Scalars['String'];
  loanAgreementDate?: Maybe<Scalars['DateTime']>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanSeqNo?: Maybe<Scalars['Float']>;
  loanSolicitorId?: Maybe<Scalars['String']>;
  loanSolicitorReferenceNo?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  rrDate?: Maybe<Scalars['DateTime']>;
  rrSolicitorId?: Maybe<Scalars['String']>;
  rrSolicitorReferenceNo?: Maybe<Scalars['String']>;
  sale?: Maybe<Array<SaleEntity>>;
  status: Scalars['String'];
  subsale?: Maybe<Array<SubsaleEntity>>;
};

export type RefundEntity = {
  __typename?: 'refundEntity';
  accountId: Scalars['String'];
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  beneficiaryBankAcc?: Maybe<Scalars['String']>;
  beneficiaryBankName?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  financierId?: Maybe<Scalars['String']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  payeeName?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  refundParty?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RefundReversalEntity = {
  __typename?: 'refundReversalEntity';
  accountId: Scalars['String'];
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  beneficiaryBankAcc?: Maybe<Scalars['String']>;
  beneficiaryBankName?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  financierId?: Maybe<Scalars['String']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  payeeName?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  refundParty?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RegionEntity = {
  __typename?: 'regionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
};

export type RelationColumn = {
  __typename?: 'RelationColumn';
  detailColumnName?: Maybe<Scalars['String']>;
  masterColumnName?: Maybe<Scalars['String']>;
};

export type RelationColumnInput = {
  detailColumnName?: InputMaybe<Scalars['String']>;
  masterColumnName?: InputMaybe<Scalars['String']>;
};

export type ReminderEntity = {
  __typename?: 'reminderEntity';
  balanceAmount: Scalars['String'];
  batchId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ledger: LedgerEntity;
  project: ProjectEntity;
  reminderDate: Scalars['DateTime'];
  reminderNo?: Maybe<Scalars['String']>;
  reminderSeq: Scalars['Float'];
  sale: SaleEntity;
  trxStatus: Scalars['String'];
};

export type ReportParameter = {
  __typename?: 'ReportParameter';
  AllowNull?: Maybe<Scalars['Boolean']>;
  Description: Scalars['String'];
  DropDownMember?: Maybe<DropDownMember>;
  GlobalType?: Maybe<Scalars['String']>;
  IsDateRange?: Maybe<Scalars['Boolean']>;
  MultiValue?: Maybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  Tag?: Maybe<Scalars['String']>;
  Type: Scalars['String'];
  Visible?: Maybe<Scalars['Boolean']>;
};

export type ReportParameterInput = {
  AllowNull?: InputMaybe<Scalars['Boolean']>;
  Description: Scalars['String'];
  DropDownMember?: InputMaybe<DropDownMemberInput>;
  GlobalType?: InputMaybe<Scalars['String']>;
  IsDateRange?: InputMaybe<Scalars['Boolean']>;
  MultiValue?: InputMaybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  Tag?: InputMaybe<Scalars['String']>;
  Type: Scalars['String'];
  Visible?: InputMaybe<Scalars['Boolean']>;
};

export type ReportPermissionEntity = AuditEntity & {
  __typename?: 'reportPermissionEntity';
  accountId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permission_uuid: Scalars['String'];
  permissionId: Scalars['Float'];
  roleId: Scalars['String'];
};

export type RequiredFieldInput = {
  ADDRESS?: InputMaybe<Scalars['Boolean']>;
  BUY_PURPOSE?: InputMaybe<Scalars['Boolean']>;
  BUY_REASON?: InputMaybe<Scalars['Boolean']>;
  EMPLOYER_ADDRESS?: InputMaybe<Scalars['Boolean']>;
  EMPLOYER_NAME?: InputMaybe<Scalars['Boolean']>;
  INCOME_RANGE?: InputMaybe<Scalars['Boolean']>;
  LEAD_CHANNEL?: InputMaybe<Scalars['Boolean']>;
  MARITAL_STATUS?: InputMaybe<Scalars['Boolean']>;
  OCCUPATION?: InputMaybe<Scalars['Boolean']>;
  RACE?: InputMaybe<Scalars['Boolean']>;
  SALUTATION?: InputMaybe<Scalars['Boolean']>;
};

export type RequiredFieldOutput = {
  __typename?: 'requiredFieldOutput';
  ADDRESS?: Maybe<Scalars['Boolean']>;
  BUY_PURPOSE?: Maybe<Scalars['Boolean']>;
  BUY_REASON?: Maybe<Scalars['Boolean']>;
  EMPLOYER_ADDRESS?: Maybe<Scalars['Boolean']>;
  EMPLOYER_NAME?: Maybe<Scalars['Boolean']>;
  INCOME_RANGE?: Maybe<Scalars['Boolean']>;
  LEAD_CHANNEL?: Maybe<Scalars['Boolean']>;
  MARITAL_STATUS?: Maybe<Scalars['Boolean']>;
  OCCUPATION?: Maybe<Scalars['Boolean']>;
  RACE?: Maybe<Scalars['Boolean']>;
  SALUTATION?: Maybe<Scalars['Boolean']>;
};

export type ResourceEntity = AuditEntity & {
  __typename?: 'resourceEntity';
  account_id: Scalars['String'];
  bucketFileName: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  mediaType: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  pictureBlocks: Array<PictureBlockEntity>;
  pictureFloors: Array<PictureFloorEntity>;
  pictureGalleries: Array<PictureGalleryEntity>;
  pictureUnitlayouts: Array<PictureUnitlayoutEntity>;
  resourceUrl: Scalars['String'];
  salesCharts: Array<SalesChartEntity>;
};

export type RevenueRecognitionSpecEntity = {
  __typename?: 'RevenueRecognitionSpecEntity';
  accountId: Scalars['String'];
  balanceSheetCode: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  percentageOfSale: Scalars['String'];
  pnlCode: Scalars['String'];
  revenueRecognition: Scalars['String'];
};

export type RoleAccessRight = {
  __typename?: 'roleAccessRight';
  permission: Scalars['String'];
  roleId: Scalars['String'];
};

export type RoleAccessRightInput = {
  permission: Scalars['String'];
  roleId: Scalars['String'];
};

export type RoleEntity = AuditEntity & {
  __typename?: 'roleEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  newPermissionIds: Array<Scalars['String']>;
  newPermissions: Array<Scalars['String']>;
  newSalesAndReportPermissionIds: Array<Scalars['String']>;
  permissionIds: Array<Scalars['Float']>;
  permissions: Array<Scalars['Float']>;
  returnSalePermissionOutput: Array<SalesPermission>;
  salesAndReportPermission: Array<Scalars['Float']>;
  salesAndReportPermissionIds: Array<Scalars['Float']>;
  softwareCode: Scalars['String'];
  userCountByRole: Scalars['Float'];
  userIndex: Scalars['String'];
  users?: Maybe<Array<UserEntity>>;
};


export type RoleEntityUsersArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};

export type SaleCancellationEntity = AuditEntity & {
  __typename?: 'saleCancellationEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  cancellationDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forfeitureSum: Scalars['Float'];
  id: Scalars['String'];
  isEinvoice: Scalars['Boolean'];
  miscBilling?: Maybe<MiscBillingEntity>;
  miscBillingId?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
  sales: SaleEntity;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  taxSchemeId?: Maybe<Scalars['String']>;
};

export type SaleContactEntity = AuditEntity & {
  __typename?: 'saleContactEntity';
  accountId: Scalars['String'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  parameter?: Maybe<ParameterEntity>;
  relationshipId?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  salutation?: Maybe<SalutationEntity>;
  salutationId?: Maybe<Scalars['String']>;
};

export type SaleDiscountEntity = {
  __typename?: 'saleDiscountEntity';
  accountId?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  id: Scalars['String'];
  sale: SaleEntity;
  saleDiscountExtension?: Maybe<SalesDiscountExtEntity>;
  saleId: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type SaleEntity = {
  __typename?: 'saleEntity';
  accountId: Scalars['String'];
  accountNumber?: Maybe<Scalars['Float']>;
  accountSpec?: Maybe<AccountSpecEntity>;
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<ContactAddressEntity>>;
  agencyAccId?: Maybe<AgencyEntity>;
  agencyAcctId?: Maybe<Scalars['String']>;
  agencyContractId?: Maybe<Scalars['String']>;
  agencyUser?: Maybe<AgencyContactEntity>;
  agentPersonId?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  areaVariance?: Maybe<Array<AreaVarianceEntity>>;
  attachment?: Maybe<AttachmentEntity>;
  attendedBy?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  beneficiaryName?: Maybe<Scalars['String']>;
  billMethod?: Maybe<Scalars['String']>;
  bookDate: Scalars['DateTime'];
  bookingAmount?: Maybe<Scalars['Float']>;
  bookingAttachments: BookingAttachmentsOutput;
  bookingAttachmentsCount: Scalars['Float'];
  bookingBadgeCount: Scalars['Float'];
  bookingFeeAttachments: Array<AttachmentEntity>;
  bookingFeeInfo?: Maybe<SalePaymentEntity>;
  bookingRemark?: Maybe<Scalars['String']>;
  bookingTimeTaken?: Maybe<Scalars['Float']>;
  buyerIdentityNo?: Maybe<Scalars['String']>;
  buyerIdentityType?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerReference?: Maybe<Scalars['String']>;
  buyerSignatureUrl?: Maybe<Scalars['String']>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  buyerSolicitorId?: Maybe<Scalars['String']>;
  buyPurpose?: Maybe<ParameterEntity>;
  buyReason?: Maybe<ParameterEntity>;
  cancelledBy?: Maybe<Scalars['String']>;
  cancelledByUser?: Maybe<UserEntity>;
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledReason?: Maybe<Scalars['String']>;
  cancelReasonId?: Maybe<Scalars['String']>;
  collectedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  contact: ContactEntity;
  contactAddress?: Maybe<Array<AddressJson>>;
  contactExt?: Maybe<ContactExtensionEntity>;
  contactExtention?: Maybe<ContactExtensionEntity>;
  contactId: Scalars['String'];
  convertedToBooking: Scalars['Boolean'];
  debitNote?: Maybe<Array<DebitNoteEntity>>;
  designation?: Maybe<ParameterEntity>;
  developerReference?: Maybe<Scalars['String']>;
  developerSolicitor?: Maybe<SolicitorAppointedEntity>;
  developerSolicitorId?: Maybe<Scalars['String']>;
  developerSpaStatus?: Maybe<Scalars['String']>;
  discount: Array<SaleDiscountEntity>;
  distance?: Maybe<Scalars['String']>;
  elaunchId?: Maybe<Scalars['String']>;
  employerAddress?: Maybe<Scalars['String']>;
  employerName?: Maybe<Scalars['String']>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinLoanAppsCount: Scalars['Float'];
  eventId?: Maybe<Scalars['String']>;
  events?: Maybe<EventsEntity>;
  expectedSnpDate?: Maybe<Scalars['DateTime']>;
  followUpBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ifcaContactId: Scalars['String'];
  ifcaSaleId: Scalars['Float'];
  ifcaSaleNo: Scalars['String'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  integrationDiscount?: Maybe<Array<IntegrationDiscountEntity>>;
  interests: Array<InterestEntity>;
  isAutoReleaseNotified: Scalars['Boolean'];
  isBumi: Scalars['Boolean'];
  isCancelNotified: Scalars['Boolean'];
  isCompany: Scalars['Boolean'];
  isCustomisedBookingForm: Scalars['Boolean'];
  joinBuyer: Array<JointBuyerEntity>;
  joinBuyerInfo?: Maybe<JointBuyerInfoForBookingListing>;
  jointBuyers: Array<JointBuyerEntity>;
  keyCollectionAppointment?: Maybe<Array<KeyCollectionAppointmentEntity>>;
  lateInterest?: Maybe<Array<LateInterestEntity>>;
  lateInterestException?: Maybe<ProjectLateInterestExceptionEntity>;
  lead: LeadEntity;
  leadId?: Maybe<Scalars['String']>;
  leadSource?: Maybe<LeadSourceEntity>;
  ledgers: Array<LedgerEntity>;
  letterSign: Array<LetterSignEntity>;
  listPrice?: Maybe<Scalars['Float']>;
  loanAgreementAppointmentDate?: Maybe<Scalars['DateTime']>;
  loanAgreementCollectedDate?: Maybe<Scalars['DateTime']>;
  loanAgreementSignedDate?: Maybe<Scalars['DateTime']>;
  loanAgreementStampedDate?: Maybe<Scalars['DateTime']>;
  loanAgreementStatus?: Maybe<Scalars['String']>;
  loanScreening?: Maybe<LoanScreenStatusOutput>;
  loanScreeningReports?: Maybe<Array<LoanScreenReportOutput>>;
  markUpAmount?: Maybe<Scalars['Float']>;
  markUpBy?: Maybe<Scalars['String']>;
  markUpModBy?: Maybe<Scalars['String']>;
  markUpModTs?: Maybe<Scalars['DateTime']>;
  markUpReason?: Maybe<Scalars['String']>;
  markUpValue?: Maybe<Scalars['Float']>;
  miscBilling?: Maybe<Array<MiscBillingEntity>>;
  motTracking?: Maybe<Array<MotTrackingEntity>>;
  nonIntegratedRebate?: Maybe<Array<SaleRebatePackageEntity>>;
  otherAttachments: Array<AttachmentEntity>;
  package?: Maybe<Array<Scalars['String']>>;
  packageList?: Maybe<Array<PackageEntity>>;
  parameter?: Maybe<ParameterEntity>;
  paymentMethod?: Maybe<PaymentMethodEntity>;
  paymentMethodDesc?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentReference?: Maybe<Scalars['String']>;
  paymentRemark?: Maybe<Scalars['String']>;
  PdpaSignatureUrl?: Maybe<Scalars['String']>;
  pendingIntegrate: Scalars['Boolean'];
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  progressLogSolicitor?: Maybe<Array<ProgressLogDetails>>;
  project: ProjectEntity;
  projectCompany: CompanyEntity;
  projectId: Scalars['String'];
  projectIntegration?: Maybe<Array<ProjectIntegrationEntity>>;
  purchaserSignedSpaDate?: Maybe<Scalars['DateTime']>;
  receipt?: Maybe<Array<ReceiptEntity>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  referralContactNo?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  refinancing?: Maybe<Array<RefinancingEntity>>;
  refund?: Maybe<Array<RefundEntity>>;
  refundReversal?: Maybe<Array<RefundReversalEntity>>;
  reminders: Array<ReminderEntity>;
  repeatPurchaserAgency?: Maybe<Scalars['Float']>;
  repeatPurchaserSales?: Maybe<Scalars['Float']>;
  reserveDate?: Maybe<Scalars['DateTime']>;
  retryCount: Scalars['Float'];
  saleCancellation?: Maybe<SaleCancellationEntity>;
  saleContact: Array<SaleContactEntity>;
  saleExt?: Maybe<SaleExtensionEntity>;
  saleExtension?: Maybe<SaleExtensionEntity>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  saleLoanCancellation?: Maybe<Array<SaleLoanCancellationEntity>>;
  saleOrigin: Scalars['String'];
  salePackage?: Maybe<Array<SalePackageEntity>>;
  salePayment?: Maybe<SalePaymentEntity>;
  saleRebate?: Maybe<Array<SaleRebatePackageEntity>>;
  salesDiscount: Array<SaleDiscountEntity>;
  salesNo: Scalars['String'];
  salesPerson?: Maybe<Scalars['String']>;
  salesPersonId?: Maybe<Scalars['String']>;
  salesStatus: Scalars['String'];
  SaleStatusList: Scalars['JSONObject'];
  salesTeam?: Maybe<SaleTeamEntity>;
  salesTeamId?: Maybe<Scalars['String']>;
  salesTeamName?: Maybe<Scalars['String']>;
  schedules: Array<ScheduleEntity>;
  sellingPrice?: Maybe<Scalars['Float']>;
  snpReminderAfterDaysNotify: Scalars['Boolean'];
  snpReminderBeforeDaysNotify: Scalars['Boolean'];
  solicitorProgressLog?: Maybe<Array<SolicitorProgressLogEntity>>;
  spaDate?: Maybe<Scalars['DateTime']>;
  spaNo?: Maybe<Scalars['String']>;
  spaReminder?: Maybe<Array<SpaReminderEntity>>;
  specialDiscount?: Maybe<Scalars['Float']>;
  spouse?: Maybe<ContactEntity>;
  spouseContactId?: Maybe<Scalars['String']>;
  stakeholder: SolicitorAppointedEntity;
  stampDate?: Maybe<Scalars['DateTime']>;
  subProduct?: Maybe<Array<SaleSubproductEntity>>;
  taxAmt?: Maybe<Scalars['Float']>;
  taxDetail?: Maybe<Array<SaleTaxOutput>>;
  taxRate?: Maybe<Scalars['Float']>;
  trNo: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
  unitIntegration?: Maybe<UnitIntegrationEntity>;
  vpDate?: Maybe<Scalars['DateTime']>;
};


export type SaleEntityParameterArgs = {
  parameterType: Scalars['String'];
};

export type SaleExtensionEntity = AuditEntity & {
  __typename?: 'saleExtensionEntity';
  accountId: Scalars['String'];
  campaignId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  creditTerm?: Maybe<Scalars['Float']>;
  discardBumiDiscount?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isCashBuyer?: Maybe<Scalars['Boolean']>;
  isEInvoiceRequired: Scalars['Boolean'];
  isGenerateInterest?: Maybe<Scalars['Boolean']>;
  isGenerateReminder?: Maybe<Scalars['Boolean']>;
  isGovAuth: Scalars['Boolean'];
  loanGracePeriod?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales: SaleEntity;
  salesType?: Maybe<Scalars['String']>;
  totalSalesValue?: Maybe<Scalars['Float']>;
};

export type SaleLeadNotificationInput = {
  booking?: InputMaybe<BookingNotificationInput>;
  bookingCancellation?: InputMaybe<BookingCancellationNotificationInput>;
  bookingReassignment?: InputMaybe<Scalars['Boolean']>;
  eSignCompleted?: InputMaybe<BookingCancellationNotificationInput>;
  leadAssignment?: InputMaybe<Scalars['Boolean']>;
  loanAssignment?: InputMaybe<LoanAssignmentInput>;
  preBookingQueueAssignment?: InputMaybe<PreBookingQueueAssignmentInput>;
  reservation?: InputMaybe<BookingNotificationInput>;
  snpSigningReminder?: InputMaybe<SnpSigningReminderInput>;
  solicitorCaseAssignment?: InputMaybe<SolicitorCaseAssignmentInput>;
};

export type SaleLeadNotificationOutput = {
  __typename?: 'SaleLeadNotificationOutput';
  booking?: Maybe<BookingNotificationOutput>;
  bookingCancellation?: Maybe<BookingCancellationNotificationOutput>;
  bookingReassignment?: Maybe<Scalars['Boolean']>;
  eSignCompleted?: Maybe<BookingCancellationNotificationOutput>;
  leadAssignment?: Maybe<Scalars['Boolean']>;
  loanAssignment?: Maybe<LoanAssignmentOutput>;
  preBookingQueueAssignment?: Maybe<PreBookingQueueAssignmentOutput>;
  reservation?: Maybe<BookingNotificationOutput>;
  snpSigningReminder?: Maybe<SnpSigningReminderOutput>;
  solicitorCaseAssignment?: Maybe<SolicitorCaseAssignmentOutput>;
};

export type SaleLoanCancellationDetailEntity = AuditEntity & {
  __typename?: 'saleLoanCancellationDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  saleLoanCancellationId: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type SaleLoanCancellationEntity = AuditEntity & {
  __typename?: 'saleLoanCancellationEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  cancelRemark?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  sale: SaleEntity;
  saleId: Scalars['String'];
};

export type SaleLoanEntity = AuditEntity & {
  __typename?: 'saleLoanEntity';
  accountId: Scalars['String'];
  borrowerAddress?: Maybe<AddressJson>;
  borrowerName?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  financialBilling?: Maybe<Array<FinancialBillingEntity>>;
  financierId: Scalars['String'];
  financierReference: Scalars['String'];
  financiers?: Maybe<Array<FinancierEntity>>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  gstFinanceByBank: Scalars['Boolean'];
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  loanApprovalDate?: Maybe<Scalars['DateTime']>;
  loanLimit: Scalars['Float'];
  loanLooDate?: Maybe<Scalars['DateTime']>;
  loanPercentage: Scalars['Float'];
  loanPeriod?: Maybe<Scalars['Float']>;
  loanSeqNo: Scalars['Float'];
  loanSignDate?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  renoticeDate?: Maybe<Scalars['DateTime']>;
  rrDate?: Maybe<Scalars['DateTime']>;
  rrSolicitorId?: Maybe<Scalars['String']>;
  rrSolicitorReferenceNo?: Maybe<Scalars['String']>;
  sale?: Maybe<SaleEntity>;
  saleId: Scalars['String'];
  solicitorAppointed?: Maybe<Array<SolicitorAppointedEntity>>;
  solicitorId: Scalars['String'];
  solicitorReference: Scalars['String'];
  taxSchemeId: Scalars['String'];
  totalLoanAmount: Scalars['Float'];
};

export type SalePackageEntity = AuditEntity & {
  __typename?: 'salePackageEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discountAmount?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isIncludeContract: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  openMarketValue: Scalars['Float'];
  package: PackageEntity;
  packageId: Scalars['String'];
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  sellingMethod?: Maybe<Scalars['String']>;
  sellingPrice: Scalars['Float'];
  taxSchemeId?: Maybe<Scalars['String']>;
  workProgress?: Maybe<WorkProgressEntity>;
  workProgressId?: Maybe<Scalars['String']>;
};

export type SalePaymentEntity = AuditEntity & {
  __typename?: 'salePaymentEntity';
  accountId: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  attachment?: Maybe<AttachmentEntity>;
  bookingFeeAttachments: Array<AttachmentEntity>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethodEntity;
  paymentMethodDesc?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  receiptId?: Maybe<Scalars['String']>;
  receiptNo?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  response: Scalars['JSONObject'];
  sale: SaleEntity;
  saleId: Scalars['String'];
  status: Scalars['String'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  transactionMethod?: Maybe<Scalars['String']>;
};

export type SalePaymentValueOutput = {
  __typename?: 'SalePaymentValueOutput';
  amount: Scalars['Float'];
  receiptNo: Scalars['String'];
};

export type SaleRebatePackageEntity = AuditEntity & {
  __typename?: 'saleRebatePackageEntity';
  accountId: Scalars['String'];
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  campaign?: Maybe<CampaignEntity>;
  campaignId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount: DiscountEntity;
  discountAmount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  rebate?: Maybe<RebateEntity>;
  rebateId?: Maybe<Scalars['String']>;
  roundingMode?: Maybe<Scalars['String']>;
  roundingPrecision?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
  workProgress?: Maybe<WorkProgressEntity>;
  workProgressId?: Maybe<Scalars['String']>;
};

export type SaleRecognitionSpecEntity = {
  __typename?: 'SaleRecognitionSpecEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  minBilledPaidCashBuyer: Scalars['Float'];
  minBilledPaidCompletedProject: Scalars['Float'];
  vpIssued: Scalars['Boolean'];
};

export type SalesActivityEntity = {
  __typename?: 'salesActivityEntity';
  accountId: Scalars['String'];
  actionBy?: Maybe<Scalars['String']>;
  activityDate: Scalars['DateTime'];
  activityDesc?: Maybe<Scalars['String']>;
  activityType: Scalars['String'];
  fromPerson?: Maybe<Scalars['String']>;
  fromTeam?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  person?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  salesPersonType: Scalars['String'];
  team?: Maybe<Scalars['String']>;
};

export type SalesAddAttachmentsInput = {
  attachments: Array<Scalars['Upload']>;
  ref_type: Scalars['String'];
  sale_id: Scalars['String'];
};

export type SalesAgingDetails = {
  __typename?: 'SalesAgingDetails';
  alertAgingActivated?: Maybe<Scalars['Boolean']>;
  salesAlertAging?: Maybe<SalesAlertAginggOutput>;
};

export type SalesAlertAginggOutput = {
  __typename?: 'SalesAlertAginggOutput';
  isActive: Scalars['Boolean'];
  maxMajorSalesAlertAging: Scalars['Float'];
  maxMinorSalesAlertAging: Scalars['Float'];
};

export type SalesAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMajorSalesAlertAging: Scalars['Float'];
  maxMinorSalesAlertAging: Scalars['Float'];
};

export type SalesAlertAgingOutput = {
  __typename?: 'SalesAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMajorSalesAlertAging: Scalars['Float'];
  maxMinorSalesAlertAging: Scalars['Float'];
};

export type SalesCancellationEntity = AuditEntity & {
  __typename?: 'salesCancellationEntity';
  accountId: Scalars['String'];
  approvalLevel?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
};

export type SalesChartEntity = {
  __typename?: 'salesChartEntity';
  accountId?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  coordinates: Scalars['String'];
  floor: Scalars['Float'];
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  unit: UnitEntity;
};

export type SalesDiscountExtEntity = AuditEntity & {
  __typename?: 'salesDiscountExtEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  saleDiscount: SaleDiscountEntity;
  saleDiscountId: Scalars['String'];
};

export type SalesDocEntity = AuditEntity & {
  __typename?: 'salesDocEntity';
  accountId: Scalars['String'];
  allowAgency: Scalars['Boolean'];
  allowSalesTeam: Scalars['Boolean'];
  attachment: AttachmentEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docName: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  type: Scalars['String'];
  typeDescription: Scalars['String'];
};

export type SalesDownloadAttachmentInput = {
  attachmentName: Scalars['String'];
  attachmentUrl: Scalars['String'];
};

export type SalesGalleryCloseDateEntity = {
  __typename?: 'salesGalleryCloseDateEntity';
  accountId: Scalars['String'];
  appointmentScheduling: AppointmentSchedulingEntity;
  appointmentSchedulingId: Scalars['String'];
  endDate: Scalars['DateTime'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['String'];
};

export type SalesLeadOutput = {
  __typename?: 'SalesLeadOutput';
  coldTotal?: Maybe<Scalars['Float']>;
  data?: Maybe<Array<LeadDataOutput>>;
  dropTotal?: Maybe<Scalars['Float']>;
  hotTotal?: Maybe<Scalars['Float']>;
  openTotal?: Maybe<Scalars['Float']>;
  reservedTotal?: Maybe<Scalars['Float']>;
  salesAgingDetails?: Maybe<SalesAgingDetails>;
  showSaleStaff?: Maybe<Scalars['Boolean']>;
  signTotal?: Maybe<Scalars['Float']>;
  soldTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  waitingListTotal?: Maybe<Scalars['Float']>;
  warmTotal?: Maybe<Scalars['Float']>;
};

export type SalesLeadPerformanceBiOutput = {
  __typename?: 'SalesLeadPerformanceBIOutput';
  coldCount?: Maybe<Scalars['Float']>;
  dropCount?: Maybe<Scalars['Float']>;
  hotCount?: Maybe<Scalars['Float']>;
  openCount?: Maybe<Scalars['Float']>;
  waitingCount?: Maybe<Scalars['Float']>;
};

export type SalesMovementBiSummaryOutput = {
  __typename?: 'SalesMovementBISummaryOutput';
  counted?: Maybe<Scalars['Float']>;
  sale_origin?: Maybe<Scalars['String']>;
};

export enum SalesPermission {
  AdminRead = 'ADMIN__READ',
  AdminProjectCarParkSetupRead = 'ADMIN_PROJECT_CAR_PARK_SETUP_READ',
  AdminProjectDiscountRead = 'ADMIN_PROJECT_DISCOUNT_READ',
  AdminProjectEmailLetterRead = 'ADMIN_PROJECT_EMAIL_LETTER_READ',
  AdminProjectGalleryRead = 'ADMIN_PROJECT_GALLERY_READ',
  AdminProjectLayoutImagesRead = 'ADMIN_PROJECT_LAYOUT_IMAGES_READ',
  AdminProjectPanelEndFinancierRead = 'ADMIN_PROJECT_PANEL_END_FINANCIER_READ',
  AdminProjectPanelSolicitorRead = 'ADMIN_PROJECT_PANEL_SOLICITOR_READ',
  AdminProjectPolicySettingRead = 'ADMIN_PROJECT_POLICY_SETTING_READ',
  AdminProjectProjectDetailsRead = 'ADMIN_PROJECT_PROJECT_DETAILS_READ',
  AdminProjectRoleAuthorizationRead = 'ADMIN_PROJECT_ROLE_AUTHORIZATION_READ',
  AdminProjectSalesChartSetupRead = 'ADMIN_PROJECT_SALES_CHART_SETUP_READ',
  AdminProjectSalesDocumentsRead = 'ADMIN_PROJECT_SALES_DOCUMENTS_READ',
  AdminProjectSalesPackagesRead = 'ADMIN_PROJECT_SALES_PACKAGES_READ',
  AdminProjectSiteProgressRead = 'ADMIN_PROJECT_SITE_PROGRESS_READ',
  AdminProjectStandardLetterRead = 'ADMIN_PROJECT_STANDARD_LETTER_READ',
  AdminProjectTeamAssignmentRead = 'ADMIN_PROJECT_TEAM_ASSIGNMENT_READ',
  AdminProjectUnitAllocationRead = 'ADMIN_PROJECT_UNIT_ALLOCATION_READ',
  AdminProjectUnitSetupRead = 'ADMIN_PROJECT_UNIT_SETUP_READ',
  ProjectReadAll = 'PROJECT_______READ_ALL',
  ProjectReadInternalAndAgencyTeam = 'PROJECT_______READ_INTERNAL_AND_AGENCY_TEAM',
  ProjectReadSelf = 'PROJECT_______READ_SELF',
  ProjectReadTeam = 'PROJECT_______READ_TEAM',
  ProjectAppointedAgencyRead = 'PROJECT_APPOINTED_AGENCY____READ',
  ProjectBookingListAllowBook = 'PROJECT_BOOKING_LIST____ALLOW_BOOK',
  ProjectBookingListCancel = 'PROJECT_BOOKING_LIST____CANCEL',
  ProjectBookingListCarParkAdd = 'PROJECT_BOOKING_LIST____CAR_PARK_ADD',
  ProjectBookingListCarParkDelete = 'PROJECT_BOOKING_LIST____CAR_PARK_DELETE',
  ProjectBookingListCarParkUpdate = 'PROJECT_BOOKING_LIST____CAR_PARK_UPDATE',
  ProjectBookingListCarParkView = 'PROJECT_BOOKING_LIST____CAR_PARK_VIEW',
  ProjectBookingListEditDiscount = 'PROJECT_BOOKING_LIST____EDIT_DISCOUNT',
  ProjectBookingListEditPurchaserAndJointBuyer = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER',
  ProjectBookingListEditPurchaserAndJointBuyerCompanyRegNo = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_COMPANY_REG_NO',
  ProjectBookingListEditPurchaserAndJointBuyerIdType = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_ID_TYPE',
  ProjectBookingListEditPurchaserAndJointBuyerNameAndIc = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_NAME_AND_IC',
  ProjectBookingListEditPurchaserAndJointBuyerNationality = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_NATIONALITY',
  ProjectBookingListEditPurchaserAndJointBuyerSequence = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_SEQUENCE',
  ProjectBookingListEditPurchaserAndJointBuyerTinNoAndSstRegNo = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_TIN_NO_AND_SST_REG_NO',
  ProjectBookingListEditSalesPackages = 'PROJECT_BOOKING_LIST____EDIT_SALES_PACKAGES',
  ProjectBookingListEditSalesRebates = 'PROJECT_BOOKING_LIST____EDIT_SALES_REBATES',
  ProjectBookingListEditSalesTeamAndSalesPersonnel = 'PROJECT_BOOKING_LIST____EDIT_SALES_TEAM_AND_SALES_PERSONNEL',
  ProjectBookingListMarkupReset = 'PROJECT_BOOKING_LIST____MARKUP_RESET',
  ProjectBookingListMarkupUpdate = 'PROJECT_BOOKING_LIST____MARKUP_UPDATE',
  ProjectBookingListMarkupView = 'PROJECT_BOOKING_LIST____MARKUP_VIEW',
  ProjectBookingListOnline = 'PROJECT_BOOKING_LIST____ONLINE',
  ProjectBookingListRead = 'PROJECT_BOOKING_LIST____READ',
  ProjectBookingListSpecialDiscount = 'PROJECT_BOOKING_LIST____SPECIAL_DISCOUNT',
  ProjectBusinessActiveSalesPerformanceRead = 'PROJECT_BUSINESS_ACTIVE_SALES_PERFORMANCE_READ',
  ProjectBusinessInsightsRead = 'PROJECT_BUSINESS_INSIGHTS____READ',
  ProjectBusinessInsightsBookingListAnalysisRead = 'PROJECT_BUSINESS_INSIGHTS_BOOKING_LIST_ANALYSIS_READ',
  ProjectBusinessInsightsBookingListRead = 'PROJECT_BUSINESS_INSIGHTS_BOOKING_LIST_READ',
  ProjectBusinessInsightsCampaignPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_CAMPAIGN_PERFORMANCE_READ',
  ProjectBusinessInsightsELaunchBookingTimeTakenRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_BOOKING_TIME_TAKEN_READ',
  ProjectBusinessInsightsELaunchMostFavouriteRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_MOST_FAVOURITE_READ',
  ProjectBusinessInsightsELaunchPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_PERFORMANCE_READ',
  ProjectBusinessInsightsELaunchPurchaserDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_PURCHASER_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsLeadDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_LEAD_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsLeadSourceRead = 'PROJECT_BUSINESS_INSIGHTS_LEAD_SOURCE_READ',
  ProjectBusinessInsightsLoanRead = 'PROJECT_BUSINESS_INSIGHTS_LOAN_READ',
  ProjectBusinessInsightsPaymentSourceRead = 'PROJECT_BUSINESS_INSIGHTS_PAYMENT_SOURCE_READ',
  ProjectBusinessInsightsPurchaserDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_PURCHASER_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsSalesLeadPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_LEAD_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesLeadTeamPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_LEAD_TEAM_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesMovementRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_MOVEMENT_READ',
  ProjectBusinessInsightsSalesPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesTeamPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_TEAM_PERFORMANCE_READ',
  ProjectBusinessInsightsWaitingListRead = 'PROJECT_BUSINESS_INSIGHTS_WAITING_LIST_READ',
  ProjectDigitalDocumentsPurchaserBooking = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING',
  ProjectDigitalDocumentsPurchaserBookingCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING_CREATE',
  ProjectDigitalDocumentsPurchaserBookingDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING_DELETE',
  ProjectDigitalDocumentsPurchaserLoan = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN',
  ProjectDigitalDocumentsPurchaserLoanCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN_CREATE',
  ProjectDigitalDocumentsPurchaserLoanDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN_DELETE',
  ProjectDigitalDocumentsPurchaserSales = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES',
  ProjectDigitalDocumentsPurchaserSalesCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES_CREATE',
  ProjectDigitalDocumentsPurchaserSalesDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES_DELETE',
  ProjectLoanRead = 'PROJECT_LOAN____READ',
  ProjectNotificationBookingListAllowBook = 'PROJECT_NOTIFICATION_BOOKING_LIST_ALLOW_BOOK',
  ProjectNotificationBookingListBookingFee = 'PROJECT_NOTIFICATION_BOOKING_LIST_BOOKING_FEE',
  ProjectNotificationBookingListCancel = 'PROJECT_NOTIFICATION_BOOKING_LIST_CANCEL',
  ProjectNotificationBookingListSpaCollected = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_COLLECTED',
  ProjectNotificationBookingListSpaReminder = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_REMINDER',
  ProjectNotificationBookingListSpaSign = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_SIGN',
  ProjectNotificationBookingListSpaStamped = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_STAMPED',
  ProjectNotificationCollaborativeAgecny = 'PROJECT_NOTIFICATION_COLLABORATIVE_AGECNY',
  ProjectNotificationCollaborativeEndFinancier = 'PROJECT_NOTIFICATION_COLLABORATIVE_END_FINANCIER',
  ProjectNotificationCollaborativeSolicitor = 'PROJECT_NOTIFICATION_COLLABORATIVE_SOLICITOR',
  ProjectNotificationLoanAccepted = 'PROJECT_NOTIFICATION_LOAN_ACCEPTED',
  ProjectNotificationLoanAmountUpdate = 'PROJECT_NOTIFICATION_LOAN_AMOUNT_UPDATE',
  ProjectNotificationLoanAssign = 'PROJECT_NOTIFICATION_LOAN_ASSIGN',
  ProjectNotificationLoanIssued = 'PROJECT_NOTIFICATION_LOAN_ISSUED',
  ProjectNotificationLoanWithdrawal = 'PROJECT_NOTIFICATION_LOAN_WITHDRAWAL',
  ProjectNotificationSalesLeadAging = 'PROJECT_NOTIFICATION_SALES_LEAD_AGING',
  ProjectNotificationSalesLeadAssign = 'PROJECT_NOTIFICATION_SALES_LEAD_ASSIGN',
  ProjectNotificationSalesLeadAssignProejct = 'PROJECT_NOTIFICATION_SALES_LEAD_ASSIGN_PROEJCT',
  ProjectNotificationSalesLeadDrop = 'PROJECT_NOTIFICATION_SALES_LEAD_DROP',
  ProjectNotificationSalesLeadReassign = 'PROJECT_NOTIFICATION_SALES_LEAD_REASSIGN',
  ProjectNotificationSalesLeadUnattended = 'PROJECT_NOTIFICATION_SALES_LEAD_UNATTENDED',
  ProjectNotificationWaitingListAvailable = 'PROJECT_NOTIFICATION_WAITING_LIST_AVAILABLE',
  ProjectNotificationWaitingListLeadJoint = 'PROJECT_NOTIFICATION_WAITING_LIST_LEAD_JOINT',
  ProjectNotificationWaitingListLeadLeaveQueue = 'PROJECT_NOTIFICATION_WAITING_LIST_LEAD_LEAVE_QUEUE',
  ProjectNotificationWaitingListMoveToTop = 'PROJECT_NOTIFICATION_WAITING_LIST_MOVE_TO_TOP',
  ProjectNotificationWaitingListUnavailable = 'PROJECT_NOTIFICATION_WAITING_LIST_UNAVAILABLE',
  ProjectPreLaunchWaitingListEditDocuments = 'PROJECT_PRE_LAUNCH_WAITING_LIST_EDIT_DOCUMENTS',
  ProjectPreLaunchWaitingListEditInfo = 'PROJECT_PRE_LAUNCH_WAITING_LIST_EDIT_INFO',
  ProjectPreLaunchWaitingListLeaveQueue = 'PROJECT_PRE_LAUNCH_WAITING_LIST_LEAVE_QUEUE',
  ProjectPreLaunchWaitingListRead = 'PROJECT_PRE_LAUNCH_WAITING_LIST_READ',
  ProjectSalesLeadAssign = 'PROJECT_SALES_LEAD____ASSIGN',
  ProjectSalesLeadRead = 'PROJECT_SALES_LEAD____READ',
  ProjectSolicitorAssignmentRead = 'PROJECT_SOLICITOR_ASSIGNMENT____READ',
  ProjectSolicitorAssignmentReassignment = 'PROJECT_SOLICITOR_ASSIGNMENT_REASSIGNMENT',
  ProjectSolicitorSpaSign = 'PROJECT_SOLICITOR_SPA_SIGN',
  ProjectWaitingListLeaveQueue = 'PROJECT_WAITING_LIST____LEAVE_QUEUE',
  ProjectWaitingListMoveToTop = 'PROJECT_WAITING_LIST____MOVE_TO_TOP',
  ProjectWaitingListRead = 'PROJECT_WAITING_LIST____READ',
  WorkdeskProjectWorkdeskAppointmentAppointmentAdd = 'WORKDESK_PROJECT_WORKDESK_APPOINTMENT_APPOINTMENT_ADD'
}

export type SalesPersonLeadsDataOutput = {
  __typename?: 'SalesPersonLeadsDataOutput';
  salesPersonName?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type SalesPersonSalesAvgOutput = {
  __typename?: 'SalesPersonSalesAvgOutput';
  bookCount?: Maybe<Scalars['Float']>;
  cancelCount?: Maybe<Scalars['Float']>;
  reserveCount?: Maybe<Scalars['Float']>;
  salesPersonName?: Maybe<Scalars['String']>;
  signedCount?: Maybe<Scalars['Float']>;
  sumBookAmt?: Maybe<Scalars['Float']>;
  sumCancelAmt?: Maybe<Scalars['Float']>;
  sumReserveAmt?: Maybe<Scalars['Float']>;
  sumSpaPrice?: Maybe<Scalars['Float']>;
};

export type SalesStatisticEntity = AuditEntity & {
  __typename?: 'salesStatisticEntity';
  accountId: Scalars['String'];
  contactId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  listPrice: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  saleStatus: Scalars['String'];
  spaPrice?: Maybe<Scalars['Float']>;
  transactionDate: Scalars['DateTime'];
  unitId: Scalars['String'];
};

export type SalesTeamBiSearchDateOutput = {
  __typename?: 'SalesTeamBISearchDateOutput';
  createdTs: Scalars['DateTime'];
};

export type SalesTeamOutput = {
  __typename?: 'SalesTeamOutput';
  commonStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<SalesTeamUserOuput>;
};

export type SalesTeamPerformanceBiSummaryOutput = {
  __typename?: 'SalesTeamPerformanceBISummaryOutput';
  agency_count?: Maybe<Scalars['Float']>;
  internalAndAgencyUser?: Maybe<Scalars['String']>;
  team_count?: Maybe<Scalars['Float']>;
};

export type SalesTeamUserInfoOuput = {
  __typename?: 'SalesTeamUserInfoOuput';
  contactNo: Scalars['String'];
  email: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type SalesTeamUserOuput = {
  __typename?: 'SalesTeamUserOuput';
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  leadCount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
};

export type SaleSubproductEntity = AuditEntity & {
  __typename?: 'saleSubproductEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount?: Maybe<DiscountEntity>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  sellingMethod: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unit?: Maybe<UnitEntity>;
  unitId: Scalars['String'];
};

export type SalesUpdateStatusInput = {
  appointment_date?: InputMaybe<Scalars['DateTime']>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  collected_date?: InputMaybe<Scalars['DateTime']>;
  purchaser_signed_date?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  sale_id: Scalars['String'];
  spa_status: Scalars['String'];
  stamped_date?: InputMaybe<Scalars['DateTime']>;
};

export type SaleTaxOutput = {
  __typename?: 'SaleTaxOutput';
  description: Scalars['String'];
  sale_id: Scalars['String'];
  tax_code?: Maybe<Scalars['String']>;
  tax_desc?: Maybe<Scalars['String']>;
  tax_id: Scalars['String'];
  tax_rate: Scalars['Float'];
};

export type SaleTeamAllocationEntity = {
  __typename?: 'saleTeamAllocationEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  saleTeam: SaleTeamEntity;
  teamId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type SaleTeamEntity = {
  __typename?: 'saleTeamEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  enableAllocation: Scalars['Boolean'];
  id: Scalars['String'];
  leadActivities: Array<LeadActivityEntity>;
  leadActivitiesTeam: Array<LeadActivityEntity>;
  leads: Array<LeadEntity>;
  memberCount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  sales: Array<SaleEntity>;
  saleTeamMembers?: Maybe<Array<SaleTeamUserEntity>>;
  saleTeamUnitAllocation?: Maybe<Array<SaleTeamAllocationEntity>>;
  saleTeamUsers?: Maybe<Array<SaleTeamUserEntity>>;
  waitlistTeam?: Maybe<Array<BookingWaitlistEntity>>;
};

export type SaleTeamMemberLeadAssignmentOutput = {
  __typename?: 'SaleTeamMemberLeadAssignmentOutput';
  leadCount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type SaleTeamPerformanceOutput = {
  __typename?: 'SaleTeamPerformanceOutput';
  agency?: Maybe<Array<PerformanceByInternalAndAgency>>;
  team?: Maybe<Array<PerformanceByInternalAndAgency>>;
};

export type SaleTeamUserEntity = {
  __typename?: 'saleTeamUserEntity';
  acceptLead: Scalars['Boolean'];
  accountId: Scalars['String'];
  id: Scalars['String'];
  saleTeam: SaleTeamEntity;
  teamId: Scalars['String'];
  user?: Maybe<UserEntity>;
  userId: Scalars['String'];
};

export type SalutationEntity = {
  __typename?: 'salutationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  saleContact: SaleContactEntity;
  seqNo?: Maybe<Scalars['Float']>;
};

export type ScheduleEntity = {
  __typename?: 'scheduleEntity';
  batchId?: Maybe<Scalars['String']>;
  billedDate?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  docAmount: Scalars['String'];
  id: Scalars['String'];
  ledgers: Array<LedgerEntity>;
  project: ProjectEntity;
  sale: SaleEntity;
  scheduleDate: Scalars['DateTime'];
};

export type SCityEntity = {
  __typename?: 'sCityEntity';
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  sPostcode?: Maybe<Array<SPostcodeEntity>>;
  state: SStateEntity;
};

export type SCountryEntity = {
  __typename?: 'sCountryEntity';
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  einvCode: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  sStates: Array<SStateEntity>;
};

export type SGatewayUpdates_A = AuditEntity & {
  __typename?: 'SGatewayUpdates_A';
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  hasSqlUpdate: Scalars['Boolean'];
  ID: Scalars['String'];
  IntegrationType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  releaseNote?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  verifySql?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/** JsonType */
export type ShareObject = {
  __typename?: 'shareObject';
  attachmentIds?: Maybe<Array<Scalars['String']>>;
  generationBatchIds?: Maybe<Array<Scalars['String']>>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['String'];
  sharedMethod?: Maybe<Scalars['String']>;
  sharedTo?: Maybe<Array<ShareTo>>;
};

export type ShareTo = {
  __typename?: 'shareTo';
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type SiteProgressEntity = {
  __typename?: 'siteProgressEntity';
  accountId: Scalars['String'];
  attachment: Array<AttachmentEntity>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  publishDate: Scalars['DateTime'];
  title: Scalars['String'];
};

export type SmtpInfoInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdTs?: InputMaybe<Scalars['DateTime']>;
  enableSSL?: InputMaybe<Scalars['Boolean']>;
  hostName: Scalars['String'];
  lastUpdateBy?: InputMaybe<Scalars['String']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  maxRetry: Scalars['Float'];
  modBy?: InputMaybe<Scalars['String']>;
  modTs?: InputMaybe<Scalars['DateTime']>;
  password: Scalars['String'];
  portNumber: Scalars['Float'];
  userName: Scalars['String'];
};

export type SmtpInfoOutput = {
  __typename?: 'smtpInfoOutput';
  createdBy?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  enableSSL?: Maybe<Scalars['Boolean']>;
  hostName: Scalars['String'];
  lastUpdateBy?: Maybe<Scalars['String']>;
  lastUpdatedDate?: Maybe<Scalars['DateTime']>;
  maxRetry: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  password: Scalars['String'];
  portNumber: Scalars['Float'];
  userName: Scalars['String'];
};

export type SNationalityEntity = {
  __typename?: 'sNationalityEntity';
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  id: Scalars['String'];
  leadContacts: Array<LeadContactEntity>;
  name: Scalars['String'];
};

export type SnpSigningReminderInput = {
  afterDay?: InputMaybe<Scalars['Float']>;
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  beforeDay?: InputMaybe<Scalars['Float']>;
  purchaserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type SnpSigningReminderOutput = {
  __typename?: 'SNPSigningReminderOutput';
  afterDay?: Maybe<Scalars['Float']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  beforeDay?: Maybe<Scalars['Float']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type SoliciorListingOutput = {
  __typename?: 'soliciorListingOutput';
  bookDate: Scalars['DateTime'];
  caseStatus: Scalars['String'];
  caseStatusCode?: Maybe<Scalars['String']>;
  collectedDate?: Maybe<Scalars['DateTime']>;
  contactId: Scalars['String'];
  contactName: Scalars['String'];
  loanAgreementStatus?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  saleStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  solicitorId: Scalars['String'];
  stampedDate?: Maybe<Scalars['DateTime']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SolicitorAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMajorSolicitorAlertAging: Scalars['Float'];
  maxMinorSolicitorAlertAging: Scalars['Float'];
};

export type SolicitorAlertAgingOutput = {
  __typename?: 'SolicitorAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMajorSolicitorAlertAging: Scalars['Float'];
  maxMinorSolicitorAlertAging: Scalars['Float'];
};

export type SolicitorAppointedBankEntity = AuditEntity & {
  __typename?: 'solicitorAppointedBankEntity';
  accountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankId: Scalars['String'];
  bankName?: Maybe<Scalars['String']>;
  bankSwiftCode: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['ID'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectData?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  solicitorAppointedId: Scalars['String'];
  townshipName?: Maybe<Scalars['String']>;
};

export type SolicitorAppointedContactEntity = AuditEntity & {
  __typename?: 'solicitorAppointedContactEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  solicitor: SolicitorAppointedEntity;
  solicitorAppointedId: Scalars['String'];
};

export type SolicitorAppointedCount = {
  __typename?: 'solicitorAppointedCount';
  lastAppointedDate?: Maybe<Scalars['DateTime']>;
  totalAppointed?: Maybe<Scalars['Float']>;
};

export type SolicitorAppointedEntity = AuditEntity & {
  __typename?: 'solicitorAppointedEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  assignedProjectCount: Scalars['Float'];
  commonStatus: Scalars['String'];
  contact: Array<SolicitorAppointedContactEntity>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhoneNo?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  default?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationLink: Scalars['String'];
  isIntegrated: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  projectCount: Scalars['Float'];
  saleBuyerSolicitor: Array<SaleEntity>;
  saleDeveloperSolicitor: Array<SaleEntity>;
  saleLoan: Array<SaleLoanEntity>;
  saleStakeholder: Array<SaleEntity>;
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorId?: Maybe<Scalars['String']>;
  solicitorUnitCount?: Maybe<SolicitorUnitCount>;
  subsaleBuyerSolicitor: Array<SubsaleEntity>;
  unitCount: Scalars['Float'];
  unitExt: Array<UnitExtensionEntity>;
  unitExtLawyer: Array<UnitExtensionEntity>;
};


export type SolicitorAppointedEntityDefaultArgs = {
  projectId: Scalars['String'];
};


export type SolicitorAppointedEntitySolicitorUnitCountArgs = {
  project_id: Scalars['String'];
};

export type SolicitorCaseAssignmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
  solicitorUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type SolicitorCaseAssignmentOutput = {
  __typename?: 'solicitorCaseAssignmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  solicitorUserReceive?: Maybe<Scalars['Boolean']>;
};

export type SolicitorChangePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type SolicitorContactEntity = AuditEntity & {
  __typename?: 'solicitorContactEntity';
  commonStatus?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSuspendible: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: SolicitorUserEntity;
  userId: Scalars['String'];
};

export type SolicitorEntity = AuditEntity & {
  __typename?: 'solicitorEntity';
  address?: Maybe<AddressJson>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
};

export type SolicitorInput = {
  confirmPassword: Scalars['String'];
  loginID: Scalars['String'];
  password: Scalars['String'];
  solicitorName: Scalars['String'];
};

export type SolicitorLayoutList = {
  __typename?: 'solicitorLayoutList';
  allotted: Scalars['Float'];
  desc: Scalars['String'];
  layout_id: Scalars['String'];
  project_id: Scalars['String'];
  sold: Scalars['Float'];
  solicitor_project_id: Scalars['String'];
  total_selling: Scalars['Float'];
};

export type SolicitorLeadNotificationInput = {
  leadAssignment?: InputMaybe<Scalars['Boolean']>;
};

export type SolicitorLeadNotificationOutput = {
  __typename?: 'SolicitorLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type SolicitorNotificationEntity = AuditEntity & {
  __typename?: 'solicitorNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  solicitorNotificationRecipient: Array<SolicitorNotificationRecipientEntity>;
  subject: Scalars['String'];
};

export type SolicitorNotificationPolicyEntity = {
  __typename?: 'solicitorNotificationPolicyEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notificationDuration: Scalars['Float'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type SolicitorNotificationRecipientEntity = AuditEntity & {
  __typename?: 'solicitorNotificationRecipientEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
  solicitorNotification: SolicitorNotificationEntity;
};

export type SolicitorProgressLogEntity = AuditEntity & {
  __typename?: 'solicitorProgressLogEntity';
  accountId: Scalars['String'];
  actionBy: Scalars['String'];
  appointmentDate?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  logType: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  progressDate: Scalars['DateTime'];
  progressDesc?: Maybe<Scalars['String']>;
  progressType: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  solicitorId?: Maybe<Scalars['String']>;
  spaStatus?: Maybe<Scalars['String']>;
};

export type SolicitorProjectEntity = AuditEntity & {
  __typename?: 'solicitorProjectEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
};

export type SolicitorStatusCount = {
  __typename?: 'solicitorStatusCount';
  assignedCount?: Maybe<Scalars['Float']>;
  bookedCount?: Maybe<Scalars['Float']>;
  reservationCount?: Maybe<Scalars['Float']>;
  snpSignedCount?: Maybe<Scalars['Float']>;
  toBeAssignedCount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type SolicitorUnitAllocationEntity = AuditEntity & {
  __typename?: 'solicitorUnitAllocationEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type SolicitorUnitCount = {
  __typename?: 'solicitorUnitCount';
  allocated?: Maybe<Scalars['Float']>;
  sold?: Maybe<Scalars['Float']>;
};

export type SolicitorUserEntity = AuditEntity & {
  __typename?: 'solicitorUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  passwordHash?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
};

export type SpaReminderEntity = AuditEntity & {
  __typename?: 'spaReminderEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  share?: Maybe<Array<ShareObject>>;
};

export type SPostcodeEntity = {
  __typename?: 'sPostcodeEntity';
  citys: SCityEntity;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  postcode: Scalars['String'];
};

export type SStateEntity = {
  __typename?: 'sStateEntity';
  commonStatus: Scalars['String'];
  country: SCountryEntity;
  einvCode: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  sCities?: Maybe<Array<SCityEntity>>;
};

export type StakeholderProcessEntity = {
  __typename?: 'stakeholderProcessEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  commonStatus: Scalars['String'];
  deemCollectionDetail: Array<DeemCollectionDetailEntity>;
  duration: Scalars['Float'];
  finalReleaseDate?: Maybe<Scalars['DateTime']>;
  financialBillingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  progressBilling: ProgressBillingEntity;
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  sales: SaleEntity;
  solicitorId: Scalars['String'];
  stakeholderProcessReleaseDetail: Array<StakeholderProcessReleaseDetailEntity>;
};

export type StakeholderProcessReleaseDetailEntity = {
  __typename?: 'stakeholderProcessReleaseDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  deemCollectionDetail: DeemCollectionDetailEntity;
  deemCollectionDetailId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentNo: Scalars['String'];
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  isVoid: Scalars['Boolean'];
  refVoidId?: Maybe<Scalars['String']>;
  releaseAmount: Scalars['Float'];
  stakeholderProcess: StakeholderProcessEntity;
  stakeholderProcessId: Scalars['String'];
  stakeholderProcessRelease: StakeholderProcessReleaseEntity;
  stakeholderProcessReleaseId: Scalars['String'];
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type StakeholderProcessReleaseEntity = {
  __typename?: 'stakeholderProcessReleaseEntity';
  accountId: Scalars['String'];
  bankAccountId: Scalars['String'];
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  releaseDate: Scalars['DateTime'];
  releaseMethod: Scalars['String'];
  releaseReferenceNo?: Maybe<Scalars['String']>;
  releaseTo: Scalars['String'];
  solicitorId: Scalars['String'];
  stakeholderProcessReleaseDetail: Array<StakeholderProcessReleaseDetailEntity>;
  status: Scalars['String'];
};

export type StandardAuditEntity = {
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type StandardCoreBaseEntity = AuditEntity & {
  __typename?: 'StandardCoreBaseEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type StandardLetterDataSourceEntity = {
  __typename?: 'standardLetterDataSourceEntity';
  accountId: Scalars['String'];
  dataSource: Array<DataSource>;
  id: Scalars['String'];
  masterDetailRelation?: Maybe<Array<MasterDetailRelation>>;
  name: Scalars['String'];
  queryFilterString: Array<QueryFilterString>;
  queryParameter: Array<QueryParameter>;
  reportParameter: Array<ReportParameter>;
  standardLetterId: Scalars['String'];
  version: Scalars['Float'];
};

export type StandardLetterEntity = {
  __typename?: 'standardLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  isAllowHtmlEditor: Scalars['Boolean'];
  isAllowReportDesignEditor: Scalars['Boolean'];
  letterCategory: Scalars['String'];
  letterTemplate: Array<LetterTemplateEntity>;
  letterType: Scalars['String'];
  name: Scalars['String'];
  projectTemplate: Array<ProjectLetterTemplateEntity>;
  standardLetterParameter: Array<StandardLetterParameterEntity>;
};

export type StandardLetterParameterEntity = {
  __typename?: 'standardLetterParameterEntity';
  accountId: Scalars['String'];
  columnName: Scalars['String'];
  commonStatus: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['String'];
  standardLetter: StandardLetterEntity;
  standardLetterId: Scalars['String'];
};

export type StateMasterDataOutput = {
  __typename?: 'StateMasterDataOutput';
  commonStatus: Scalars['String'];
  countryID: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type StaticData = {
  __typename?: 'StaticData';
  Desc: Scalars['String'];
  Value: Scalars['String'];
};

export type StaticDataInput = {
  Desc: Scalars['String'];
  Value: Scalars['String'];
};

export type SubsaleAllocationEntity = {
  __typename?: 'subsaleAllocationEntity';
  accountId: Scalars['String'];
  allocateAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  contra?: Maybe<SubsaleContraEntity>;
  creditId: Scalars['String'];
  creditNote?: Maybe<SubsaleCreditNoteEntity>;
  creditRefTable: Scalars['String'];
  debitId: Scalars['String'];
  debitNote?: Maybe<SubsaleDebitNoteEntity>;
  debitRefTable: Scalars['String'];
  id: Scalars['String'];
  miscBilling?: Maybe<SubsaleMiscBillingEntity>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  receipt?: Maybe<SubsaleReceiptEntity>;
  refund?: Maybe<SubsaleRefundEntity>;
};

export type SubsaleContraEntity = {
  __typename?: 'subsaleContraEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<SubsaleAllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  requestedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleCreditNoteEntity = {
  __typename?: 'subsaleCreditNoteEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<SubsaleAllocationEntity>>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleDebitNoteEntity = {
  __typename?: 'subsaleDebitNoteEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<SubsaleAllocationEntity>>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItemId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  isIncludeHoliday: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleEntity = {
  __typename?: 'subsaleEntity';
  accountId: Scalars['String'];
  administrationCharges?: Maybe<Scalars['Float']>;
  buyerIdentityNo: Scalars['String'];
  buyerName: Scalars['String'];
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  buyerSolicitorId?: Maybe<Scalars['String']>;
  buyerSolicitorReferenceNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  completedDate?: Maybe<Scalars['DateTime']>;
  contact: ContactEntity;
  contactId: Scalars['String'];
  contra?: Maybe<Array<SubsaleContraEntity>>;
  creditNote?: Maybe<Array<SubsaleCreditNoteEntity>>;
  debitNote?: Maybe<Array<SubsaleDebitNoteEntity>>;
  dmcDate?: Maybe<Scalars['DateTime']>;
  doaDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isCompany: Scalars['Boolean'];
  isEInvoiceRequired: Scalars['Boolean'];
  isGovAuth: Scalars['Boolean'];
  miscBilling?: Maybe<Array<SubsaleMiscBillingEntity>>;
  printingCharges?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  receipt?: Maybe<Array<SubsaleCreditNoteEntity>>;
  receiptReversal?: Maybe<Array<SubsaleReceiptReversalEntity>>;
  refinancing?: Maybe<Array<RefinancingEntity>>;
  refund?: Maybe<Array<SubsaleRefundEntity>>;
  refundReversal?: Maybe<Array<SubsaleRefundReversalEntity>>;
  rrDate?: Maybe<Scalars['DateTime']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  seqNo: Scalars['Float'];
  serviceChargeDeposit?: Maybe<Scalars['Float']>;
  spaDate: Scalars['DateTime'];
  status: Scalars['String'];
  subsaleCategory: Scalars['String'];
  subsaleJointBuyers?: Maybe<Array<SubsaleJointBuyerEntity>>;
  subsaleLoans?: Maybe<Array<SubsaleLoanEntity>>;
  unitId: Scalars['String'];
  units?: Maybe<UnitEntity>;
  vendorSolicitorId?: Maybe<Scalars['String']>;
  vendorSolicitorReferenceNo?: Maybe<Scalars['String']>;
};

export type SubsaleJointBuyerEntity = {
  __typename?: 'subsaleJointBuyerEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact: ContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  ranking: Scalars['Float'];
  subsaleId: Scalars['String'];
  subsales: SubsaleEntity;
};

export type SubsaleLoanEntity = {
  __typename?: 'subsaleLoanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  doaDate?: Maybe<Scalars['DateTime']>;
  doaSolicitorId?: Maybe<Scalars['String']>;
  doaSolicitorReferenceNo?: Maybe<Scalars['String']>;
  financierId?: Maybe<Scalars['String']>;
  financierReferenceNo?: Maybe<Scalars['String']>;
  financiers?: Maybe<Array<FinancierEntity>>;
  id: Scalars['String'];
  loanSeqNo: Scalars['Float'];
  LoanSolicitorId?: Maybe<Scalars['String']>;
  loanSolicitorReferenceNo?: Maybe<Scalars['String']>;
  rrDate?: Maybe<Scalars['DateTime']>;
  rrSolicitorId?: Maybe<Scalars['String']>;
  rrSolicitorReferenceNo?: Maybe<Scalars['String']>;
  subsaleId: Scalars['String'];
  subsales: SubsaleEntity;
};

export type SubsaleMiscBillingEntity = {
  __typename?: 'subsaleMiscBillingEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<SubsaleAllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentBatchId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  einvoiceBuyerAddress?: Maybe<Scalars['String']>;
  einvoiceBuyerCity?: Maybe<Scalars['String']>;
  einvoiceBuyerContactNo?: Maybe<Scalars['String']>;
  einvoiceBuyerCountry?: Maybe<Scalars['String']>;
  einvoiceBuyerEmail?: Maybe<Scalars['String']>;
  einvoiceBuyerIdentityType?: Maybe<Scalars['String']>;
  einvoiceBuyerName?: Maybe<Scalars['String']>;
  einvoiceBuyerPostCode?: Maybe<Scalars['String']>;
  einvoiceBuyerRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerState?: Maybe<Scalars['String']>;
  einvoiceBuyerTaxRegNo?: Maybe<Scalars['String']>;
  einvoiceBuyerTin?: Maybe<Scalars['String']>;
  einvoiceCancelledBy?: Maybe<Scalars['String']>;
  einvoiceCancelledDate?: Maybe<Scalars['DateTime']>;
  einvoiceCancelledReason?: Maybe<Scalars['String']>;
  einvoiceCertDigest?: Maybe<Scalars['String']>;
  einvoiceCertIssuer?: Maybe<Scalars['String']>;
  einvoiceCertSerialNo?: Maybe<Scalars['String']>;
  eInvoiceClassification?: Maybe<EInvoiceClassificationEntity>;
  einvoiceClassificationId?: Maybe<Scalars['String']>;
  einvoiceDirectsend: Scalars['Boolean'];
  einvoiceDocDigest?: Maybe<Scalars['String']>;
  einvoiceDocRefInvoiceId?: Maybe<Scalars['String']>;
  einvoiceFailedResendDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedSendReason?: Maybe<Scalars['String']>;
  einvoiceFailedValidationDate?: Maybe<Scalars['DateTime']>;
  einvoiceFailedValidationReason?: Maybe<Scalars['String']>;
  einvoiceIrbmUniqueId?: Maybe<Scalars['String']>;
  eInvoiceMsic?: Maybe<EInvoiceMsicEntity>;
  einvoiceMsicId?: Maybe<Scalars['String']>;
  einvoicePropsDigest?: Maybe<Scalars['String']>;
  einvoiceQrId?: Maybe<Scalars['String']>;
  einvoiceQrUrl?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmBy?: Maybe<Scalars['String']>;
  einvoiceRejectedConfirmDate?: Maybe<Scalars['DateTime']>;
  einvoiceRejectedReason?: Maybe<Scalars['String']>;
  einvoiceRejectedRequestDate?: Maybe<Scalars['DateTime']>;
  einvoiceSentDate?: Maybe<Scalars['DateTime']>;
  einvoiceSignatureValue?: Maybe<Scalars['String']>;
  einvoiceSigningTime?: Maybe<Scalars['DateTime']>;
  einvoiceStatus?: Maybe<Scalars['String']>;
  einvoiceValidationDate?: Maybe<Scalars['DateTime']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate: Scalars['DateTime'];
  glExportId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  irbmTrxSubmissionId?: Maybe<Scalars['String']>;
  isEinvoice: Scalars['Boolean'];
  isIncludeHoliday: Scalars['Boolean'];
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleReceiptEntity = {
  __typename?: 'subsaleReceiptEntity';
  accountId: Scalars['String'];
  accounts?: Maybe<BankAccountEntity>;
  allocation?: Maybe<Array<SubsaleAllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardFacilityId?: Maybe<Scalars['String']>;
  creditCardType?: Maybe<CreditCardTypeEntity>;
  creditCardTypeId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  paymentMethod?: Maybe<PaymentMethodEntity>;
  paymentMethodId: Scalars['String'];
  projectId: Scalars['String'];
  receiptAmount: Scalars['Float'];
  referenceNo?: Maybe<Scalars['String']>;
  roundingAmount: Scalars['Float'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleReceiptReversalEntity = {
  __typename?: 'subsaleReceiptReversalEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccount?: Maybe<Array<BankAccountEntity>>;
  bankAccountId?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  exchangeRate?: Maybe<Scalars['Float']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  receiptAmount: Scalars['Float'];
  referenceNo?: Maybe<Scalars['String']>;
  roundingAmount: Scalars['Float'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleRefundEntity = {
  __typename?: 'subsaleRefundEntity';
  accountId: Scalars['String'];
  accounts?: Maybe<BankAccountEntity>;
  allocation?: Maybe<Array<SubsaleAllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardType?: Maybe<CreditCardTypeEntity>;
  creditCardTypeId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  payeeName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodEntity>;
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type SubsaleRefundReversalEntity = {
  __typename?: 'subsaleRefundReversalEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  creditCardTypeId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  glCancelledBy?: Maybe<Scalars['String']>;
  glCancelledDate?: Maybe<Scalars['DateTime']>;
  glExportId?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  id: Scalars['String'];
  payeeName?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  subsale?: Maybe<SubsaleEntity>;
  subsaleId: Scalars['String'];
  trxDate: Scalars['DateTime'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type SUserEntity = {
  __typename?: 'sUserEntity';
  accountID: Scalars['String'];
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']>;
  blockCount: Scalars['Float'];
  blockDuration: Scalars['Float'];
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  deviceToken?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  hasSalesAdminAccess: Scalars['Boolean'];
  hasSalesCrmAccess: Scalars['Boolean'];
  hims?: Maybe<Scalars['Boolean']>;
  hims_admin?: Maybe<Scalars['Boolean']>;
  ID: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  isActivated: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  languageSet?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  lastPwdChangedDate?: Maybe<Scalars['DateTime']>;
  latestAccessedCompany?: Maybe<Scalars['String']>;
  loginAttempt: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  softwareCode: Scalars['String'];
  superUser: Scalars['Boolean'];
  userFeaturePermission: UserFeaturePermissionEntity;
  userName?: Maybe<Scalars['String']>;
  workflowTicket?: Maybe<Scalars['String']>;
};

export type TaxDetailEntity = {
  __typename?: 'taxDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  rate: Scalars['Float'];
  tax: TaxEntity;
  taxId: Scalars['String'];
};

export type TaxEntity = {
  __typename?: 'taxEntity';
  accountId: Scalars['String'];
  classType: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isClaimable: Scalars['Boolean'];
  schemeType: TaxSchemeTypeEntity;
  schemeTypeId: Scalars['String'];
  taxDetail: Array<TaxDetailEntity>;
  taxSchemeDetailItem: Array<TaxSchemeDetailItemEntity>;
};

export type TaxLedgerEntity = {
  __typename?: 'taxLedgerEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  taxAmount: Scalars['Float'];
  taxId: Scalars['String'];
  taxRate: Scalars['Float'];
  taxSchemeDetailId?: Maybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type TaxOnSeqInput = {
  seqNo: Scalars['Float'];
  taxSchemeDetailItemId: Scalars['String'];
};

/** JsonType */
export type TaxOnSeqObjects = {
  __typename?: 'taxOnSeqObjects';
  seqNo: Scalars['Float'];
  taxSchemeDetailItemId: Scalars['String'];
};

export type TaxSchemeDetailEntity = {
  __typename?: 'taxSchemeDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  taxScheme: TaxSchemeEntity;
  taxSchemeDetailItems?: Maybe<Array<TaxSchemeDetailItemEntity>>;
  taxSchemeId: Scalars['String'];
};

export type TaxSchemeDetailItemEntity = {
  __typename?: 'taxSchemeDetailItemEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  computeMethod: Scalars['String'];
  id: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  tax: TaxEntity;
  taxId: Scalars['String'];
  taxOnSeq?: Maybe<Array<TaxOnSeqObjects>>;
  taxSchemeDetail: TaxSchemeDetailEntity;
  taxSchemeDetailId: Scalars['String'];
};

export type TaxSchemeEntity = {
  __typename?: 'taxSchemeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isExclusive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taxSchemeDetails?: Maybe<Array<TaxSchemeDetailEntity>>;
};

export type TaxSchemeTypeEntity = {
  __typename?: 'taxSchemeTypeEntity';
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  softwareCode: Scalars['String'];
  tax?: Maybe<Array<TaxEntity>>;
};

export type TeamMember = {
  person_in_charge: Array<Scalars['String']>;
};

/** JsonType */
export type TeamMemberObject = {
  __typename?: 'teamMemberObject';
  person_in_charge: Array<Scalars['String']>;
};

export type TotpSecretTyes = {
  __typename?: 'TotpSecretTyes';
  dataURL?: Maybe<Scalars['String']>;
  is2FA?: Maybe<Scalars['Boolean']>;
  otpURL?: Maybe<Scalars['String']>;
  totpSecret?: Maybe<Scalars['String']>;
};

export type TownshipEntity = {
  __typename?: 'townshipEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  companyId: Scalars['String'];
  id: Scalars['String'];
  location: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  project?: Maybe<Array<ProjectEntity>>;
  seqNo: Scalars['Float'];
};

export enum TrxPriceMethodEnum {
  DescriptionList = 'DescriptionList',
  FixAmount = 'FIX_AMOUNT',
  GetDescription = 'GetDescription',
  PercentOnSpa = 'PERCENT_ON_SPA'
}

export type TryToFixAConstantValueHere = {
  __typename?: 'TryToFixAConstantValueHere';
  amount: Scalars['Float'];
};

export type UdfReport = AuditEntity & {
  __typename?: 'udfReport';
  accessRight: AccessRight;
  accountId: Scalars['String'];
  categoryTypeId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  dataSourceId: Scalars['String'];
  id: Scalars['String'];
  isSubReport: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  permissionId: Scalars['String'];
  softwareCode: Scalars['String'];
  systemUse: Scalars['Boolean'];
  version: Scalars['Float'];
};

export type UnitBufferEntity = {
  __typename?: 'unitBufferEntity';
  accountId: Scalars['String'];
  bufferExpiresAt: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type UnitCarParkAssignedOutput = {
  __typename?: 'UnitCarParkAssignedOutput';
  id?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Float']>;
  paymentPlan?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitColorThemeInput = {
  availableColor: Scalars['String'];
  bookedColor: Scalars['String'];
  reservedColor: Scalars['String'];
  signedColor: Scalars['String'];
  unavailableColor: Scalars['String'];
};

export type UnitColorThemeOutput = {
  __typename?: 'unitColorThemeOutput';
  availableColor: Scalars['String'];
  bookedColor: Scalars['String'];
  reservedColor: Scalars['String'];
  signedColor: Scalars['String'];
  unavailableColor: Scalars['String'];
};

export type UnitEntity = {
  __typename?: 'unitEntity';
  accountId?: Maybe<Scalars['String']>;
  activeSale?: Maybe<SaleEntity>;
  architectCertUnits?: Maybe<Array<ArchitectCertUnitEntity>>;
  block?: Maybe<Scalars['String']>;
  bookingWaitlists?: Maybe<Array<BookingWaitlistEntity>>;
  builtUp: Scalars['Float'];
  carParkAssigned?: Maybe<Array<UnitCarParkAssignedOutput>>;
  carParks?: Maybe<Array<UnitEntity>>;
  cccDate?: Maybe<Scalars['DateTime']>;
  cell: Scalars['Float'];
  cellLabel?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  defaultPaymentPlan?: Maybe<ProjectPaymentPlanEntity>;
  defaultProjectDiscount?: Maybe<Scalars['Float']>;
  events: Array<EventsEntity>;
  extraLandArea?: Maybe<Scalars['Float']>;
  facingDirection?: Maybe<DirectionEntity>;
  facingDirectionId?: Maybe<Scalars['String']>;
  facingView?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Float']>;
  floorLabel?: Maybe<Scalars['String']>;
  floorLayoutUrl?: Maybe<Scalars['String']>;
  getIntegratedProjectCarParkNo?: Maybe<Scalars['String']>;
  hsdNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isBumiRelease: Scalars['Boolean'];
  isCccReady: Scalars['Boolean'];
  isSubProduct: Scalars['Boolean'];
  isWaitingListExceed: Scalars['Boolean'];
  landArea?: Maybe<Scalars['String']>;
  leads: Array<LeadEntity>;
  leadSelection: Array<LeadEntity>;
  packageAssigned?: Maybe<Array<UnitPackageAssignedOutput>>;
  parentId?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  preBookingQueue?: Maybe<Array<PreBookingQueueEntity>>;
  preBookingQueueCount?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  priceAdjustmentUnit?: Maybe<PriceAdjustmentUnitEntity>;
  project: ProjectEntity;
  projectDetailsUnitLayout?: Maybe<UnitLayoutEntity>;
  projectId: Scalars['String'];
  projectSpec: Array<ProjectSpecEntity>;
  projectTitleUnit?: Maybe<ProjectTitleUnitEntity>;
  propertyType: PropertyTypeEntity;
  ptdNo?: Maybe<Scalars['String']>;
  sales: Array<SaleEntity>;
  salesCharts?: Maybe<SalesChartEntity>;
  saleSubProduct?: Maybe<SaleSubproductEntity>;
  subsaleUnit?: Maybe<SubsaleEntity>;
  timeLock?: Maybe<Scalars['DateTime']>;
  unitBuffer: Array<UnitBufferEntity>;
  unitExt?: Maybe<UnitExtensionEntity>;
  unitIntegration?: Maybe<UnitIntegrationEntity>;
  unitLayout?: Maybe<UnitLayoutEntity>;
  unitLayoutDes?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutUrl?: Maybe<Scalars['String']>;
  unitLayoutVitualLink?: Maybe<Array<Scalars['String']>>;
  unitLockBy?: Maybe<Scalars['String']>;
  unitLockType?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
  unitPackageAssignment?: Maybe<Array<UnitPackageAssignmentEntity>>;
  unitPriceHistory?: Maybe<Array<UnitPriceHistoryOutput>>;
  units?: Maybe<UnitEntity>;
  unitStatus: Scalars['String'];
  unitType?: Maybe<UnitTypeEntity>;
  unitTypeId?: Maybe<Scalars['String']>;
  unitUsedForDesc?: Maybe<Scalars['String']>;
  waitingListCount?: Maybe<Scalars['Float']>;
  waitingListId?: Maybe<Scalars['String']>;
};

export type UnitExcelOutput = {
  __typename?: 'UnitExcelOutput';
  base64: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  projectname: Scalars['String'];
};

export type UnitExcelReturnOutput = {
  __typename?: 'UnitExcelReturnOutput';
  file?: Maybe<Scalars['String']>;
  file_name: Scalars['String'];
  isSubProduct?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type UnitExtensionEntity = {
  __typename?: 'unitExtensionEntity';
  accountId: Scalars['String'];
  actualBuiltUpArea?: Maybe<Scalars['Float']>;
  actualLandArea?: Maybe<Scalars['Float']>;
  areaVarianceThreshold?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  builtUpAreaVarianceRate?: Maybe<Scalars['Float']>;
  bumiReleaseDate?: Maybe<Scalars['DateTime']>;
  bumiReleaseReferenceNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  district?: Maybe<Scalars['String']>;
  dlp1Date?: Maybe<Scalars['DateTime']>;
  dlp2Date?: Maybe<Scalars['DateTime']>;
  dlpExpiryDate?: Maybe<Scalars['DateTime']>;
  extraLandAreaRate?: Maybe<Scalars['Float']>;
  hsdHsmNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  landAreaRate?: Maybe<Scalars['Float']>;
  landAreaVarianceRate?: Maybe<Scalars['Float']>;
  lawyer?: Maybe<SolicitorAppointedEntity>;
  lawyerId?: Maybe<Scalars['String']>;
  leaseNo?: Maybe<Scalars['String']>;
  leasePejakanNegeri?: Maybe<Scalars['String']>;
  lotPtNo?: Maybe<Scalars['String']>;
  masterGrantNo?: Maybe<Scalars['String']>;
  noOfKey?: Maybe<Scalars['Float']>;
  noOfStorey?: Maybe<Scalars['Float']>;
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  scheduleLaunchDate?: Maybe<Scalars['DateTime']>;
  shareValue?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<SolicitorAppointedEntity>;
  stakeholderId?: Maybe<Scalars['String']>;
  stampDutyWaiver?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  subdivisionMukim?: Maybe<Scalars['String']>;
  unitAddress?: Maybe<AddressJson>;
  unitId: Scalars['String'];
  units: UnitEntity;
  unitUsedFor?: Maybe<Scalars['String']>;
  usableArea?: Maybe<Scalars['Float']>;
  vpBillingDate?: Maybe<Scalars['DateTime']>;
  vpLetterDate?: Maybe<Scalars['DateTime']>;
};

export type UnitImportCountOutput = {
  __typename?: 'UnitImportCountOutput';
  agencyUnitCount: Scalars['Float'];
  architectCertCount: Scalars['Float'];
  assignCarparkCount: Scalars['Float'];
  bookingCount: Scalars['Float'];
  bridgingFinancierCount: Scalars['Float'];
  elaunchCount: Scalars['Float'];
  elaunchFavouriteCount: Scalars['Float'];
  leadCount: Scalars['Float'];
  priceAdjustmentCount: Scalars['Float'];
  projectTitleCount: Scalars['Float'];
  saleChartCount: Scalars['Float'];
  salesCount: Scalars['Float'];
  saleSubproductCount: Scalars['Float'];
  saleTeamAllocationCount: Scalars['Float'];
  unitIds: Array<Scalars['String']>;
  unitIntegrationCount: Scalars['Float'];
};

export type UnitImportOptionOutput = {
  __typename?: 'UnitImportOptionOutput';
  append: Scalars['Boolean'];
  displayImportMethods: Scalars['Boolean'];
  emptyProject: Scalars['Boolean'];
  integrated: Scalars['Boolean'];
  modify: Scalars['Boolean'];
  overwrite: Scalars['Boolean'];
  unitIds: Array<Scalars['String']>;
};

export type UnitIntegrationEntity = {
  __typename?: 'unitIntegrationEntity';
  accountId: Scalars['String'];
  accountSpec?: Maybe<AccountSpecEntity>;
  bumiReleaseDate?: Maybe<Scalars['DateTime']>;
  bumiReleaseRefNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  hdaAccNo?: Maybe<Scalars['String']>;
  hdaBankAddress?: Maybe<Scalars['String']>;
  hdaBankName?: Maybe<Scalars['String']>;
  hdaBankSwiftCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ifcaBlockId: Scalars['Float'];
  ifcaCompanyId: Scalars['Float'];
  ifcaPhaseId: Scalars['Float'];
  ifcaProjectId: Scalars['Float'];
  ifcaUnitId: Scalars['Float'];
  projectId: Scalars['String'];
  projectIntegration?: Maybe<ProjectIntegrationEntity>;
  sale?: Maybe<SaleEntity>;
  unit: UnitEntity;
  unitId: Scalars['String'];
  waitingList?: Maybe<BookingWaitlistEntity>;
};

export type UnitLayoutEntity = {
  __typename?: 'unitLayoutEntity';
  accountId?: Maybe<Scalars['String']>;
  desc: Scalars['String'];
  id: Scalars['String'];
  pictureUnitlayouts: Array<PictureUnitlayoutEntity>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  units: Array<UnitEntity>;
  unitTourVirtualLinks: Array<UnitTourVirtualLinkEntity>;
};

export type UnitListOutput = {
  __typename?: 'UnitListOutput';
  contacts: Array<ContactsListOutput>;
  total: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitMortgageOutput = {
  __typename?: 'UnitMortgageOutput';
  financierList?: Maybe<Array<FinancierUnitMortgage>>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitPrice: Scalars['Float'];
};

export type UnitPackageAssignedOutput = {
  __typename?: 'UnitPackageAssignedOutput';
  id?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  paymentPlan?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
};

export type UnitPackageAssignmentEntity = AuditEntity & {
  __typename?: 'unitPackageAssignmentEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  package: PackageEntity;
  packageId: Scalars['String'];
  projectId: Scalars['String'];
  sellingMethod: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
  workProgress: WorkProgressEntity;
  workProgressId: Scalars['String'];
};

export type UnitPriceHistoryOutput = {
  __typename?: 'UnitPriceHistoryOutput';
  approvedDate: Scalars['DateTime'];
  id: Scalars['String'];
  newPrice: Scalars['Float'];
  oldPrice: Scalars['Float'];
  titleName: Scalars['String'];
};

export type UnitTourVirtualLinkEntity = {
  __typename?: 'unitTourVirtualLinkEntity';
  accountId?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  seqNo: Scalars['Float'];
  unitLayout: UnitLayoutEntity;
  unitLayoutId?: Maybe<Scalars['String']>;
  unitType: UnitTypeEntity;
  unitTypeId?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type UnitTourVirtualOutput = {
  __typename?: 'unitTourVirtualOutput';
  block: Scalars['String'];
  tourId: Scalars['String'];
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutName?: Maybe<Scalars['String']>;
  unitTypeId?: Maybe<Scalars['String']>;
  unitTypeName?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type UnitTransferEntity = AuditEntity & {
  __typename?: 'unitTransferEntity';
  accountId: Scalars['String'];
  administrationCharges: Scalars['Float'];
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount?: Maybe<DiscountObject>;
  id: Scalars['String'];
  isEinvoice: Scalars['Boolean'];
  miscBilling?: Maybe<MiscBillingEntity>;
  miscBillingId?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  newListPrice: Scalars['Float'];
  newSellingPrice: Scalars['Float'];
  newUnit?: Maybe<UnitEntity>;
  newUnitId: Scalars['String'];
  oldSaleDetail?: Maybe<OldSaleDetail>;
  oldSellingPrice?: Maybe<Scalars['Float']>;
  oldUnit?: Maybe<UnitEntity>;
  oldUnitId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  reason: Scalars['String'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
  transferDate: Scalars['DateTime'];
};

export type UnitTypeCountByStatusOutput = {
  __typename?: 'UnitTypeCountByStatusOutput';
  availableUnitCount: Scalars['Float'];
  bookUnitCount: Scalars['Float'];
  reservationUnitCount?: Maybe<Scalars['Float']>;
  signUnitCount: Scalars['Float'];
  totalUnitCount: Scalars['Float'];
  unavailableUnitCount: Scalars['Float'];
  unitType: Scalars['String'];
};

export type UnitTypeEntity = {
  __typename?: 'unitTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
  unitTourVirtualLinks: Array<UnitTourVirtualLinkEntity>;
};

export type UnitTypeOutput = {
  __typename?: 'unitTypeOutput';
  builtUp?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UnitViewLogEntity = {
  __typename?: 'unitViewLogEntity';
  accountId: Scalars['String'];
  block: Scalars['String'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  leftTime?: Maybe<Scalars['DateTime']>;
  projectId: Scalars['String'];
  socketId?: Maybe<Scalars['String']>;
  softwareCode: Scalars['String'];
  unitId: Scalars['String'];
  userId: Scalars['String'];
  visitTime: Scalars['DateTime'];
};

export type UpdateAuditInput = {
  modBy?: InputMaybe<Scalars['String']>;
};

export type UpdateLoanAgreementStatusInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  loan_agreement_status: Scalars['String'];
  progress_date?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  sale_id: Scalars['String'];
};

export type UserAccessRight = {
  __typename?: 'userAccessRight';
  permission: Scalars['String'];
  userId: Scalars['String'];
};

export type UserAccessRightInput = {
  permission: Scalars['String'];
  userId: Scalars['String'];
};

export type UserContactInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type UserEntity = {
  __typename?: 'UserEntity';
  accountID: Scalars['String'];
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']>;
  blockCount: Scalars['Float'];
  blockDuration: Scalars['Float'];
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  hasSalesAdminAccess: Scalars['Boolean'];
  hasSalesCrmAccess: Scalars['Boolean'];
  ID: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  isActivated: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  loginAttempt: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  softwareCode: Scalars['String'];
  superUser: Scalars['Boolean'];
  userFeaturePermission: UserFeaturePermissionEntity;
  userName?: Maybe<Scalars['String']>;
};

export type UserFeaturePermissionEntity = AuditEntity & {
  __typename?: 'userFeaturePermissionEntity';
  access_security: Scalars['Boolean'];
  accountId: Scalars['String'];
  allowGlobalBI: Scalars['Boolean'];
  allowOpenlead: Scalars['Boolean'];
  allowOpenLeadRoundRobin: Scalars['Boolean'];
  allowPropertyAgency: Scalars['Boolean'];
  allowReporting: Scalars['Boolean'];
  allowRoundRobin: Scalars['Boolean'];
  bulletin: Scalars['Boolean'];
  campaign: Scalars['Boolean'];
  company: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount: Scalars['Boolean'];
  end_financier: Scalars['Boolean'];
  general_setting: Scalars['Boolean'];
  id: Scalars['String'];
  isIfcaUse: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationEnabled: Scalars['Boolean'];
  notificationHistory: Scalars['Float'];
  purchaser_app_setting: Scalars['Boolean'];
  solicitor: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UserInput = {
  address?: InputMaybe<AddressInput>;
  avatar?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<CommonStatus>;
  contactNo: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  hashed?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  superUser?: InputMaybe<Scalars['Boolean']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type UserNotificationSettingEntity = {
  __typename?: 'userNotificationSettingEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type UserOutput = {
  __typename?: 'UserOutput';
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type UserResponse = AuditEntity & {
  __typename?: 'UserResponse';
  accountID: Scalars['String'];
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']>;
  blockCount?: Maybe<Scalars['Float']>;
  blockDuration?: Maybe<Scalars['Float']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors?: Maybe<Array<FieldError>>;
  ID: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  loginAttempt?: Maybe<Scalars['Float']>;
  loginTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  userName: Scalars['String'];
};

export type WaitingListBiSummaryOutput = {
  __typename?: 'WaitingListBISummaryOutput';
  cancelled?: Maybe<Scalars['Float']>;
  converted?: Maybe<Scalars['Float']>;
  total_waiting?: Maybe<Scalars['Float']>;
};

export type WhatsappLogEntity = {
  __typename?: 'whatsappLogEntity';
  accountId: Scalars['String'];
  attachment?: Maybe<Array<Scalars['String']>>;
  commonStatus: Scalars['String'];
  content: Scalars['String'];
  id: Scalars['String'];
  payload: Scalars['JSONObject'];
  refInfo?: Maybe<Scalars['JSONObject']>;
  refTable: Scalars['String'];
  response: Scalars['JSONObject'];
};

export type WithdrawnLoanStatusOutput = {
  __typename?: 'WithdrawnLoanStatusOutput';
  count: Scalars['Float'];
  customerCancelledCount: Scalars['Float'];
  customerRejectedCount: Scalars['Float'];
  developerCancelledCount: Scalars['Float'];
  loanRejectedCount: Scalars['Float'];
};

export type WorkdeskNotificationEntity = AuditEntity & {
  __typename?: 'workdeskNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  integrationData: Scalars['JSONObject'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationType: WorkdeskNotificationTypeEnum;
  permissionId?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  readTs?: Maybe<Scalars['DateTime']>;
  subject: Scalars['String'];
  wdNotificationRecipient: Array<WorkdeskNotificationRecipientEntity>;
};

export type WorkdeskNotificationRecipientEntity = AuditEntity & {
  __typename?: 'workdeskNotificationRecipientEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  integrationData?: Maybe<Scalars['JSONObject']>;
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  readTs?: Maybe<Scalars['DateTime']>;
  recipientId: Scalars['String'];
  workdeskNotification: WorkdeskNotificationEntity;
};

export enum WorkdeskNotificationTypeEnum {
  Notification = 'NOTIFICATION',
  Todo = 'TODO'
}

export type WorkFlowApprovedStepEntity = AuditEntity & {
  __typename?: 'workFlowApprovedStepEntity';
  accountId: Scalars['String'];
  approvalDate: Scalars['DateTime'];
  approvalRoleId: Scalars['String'];
  approvalStatus: WorkFlowStatusEnum;
  approverId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  statusRemark?: Maybe<Scalars['String']>;
  workFlowStep: WorkFlowStepEntity;
  workFlowStepId: Scalars['String'];
};

export type WorkflowBranchPropertyEntity = AuditEntity & {
  __typename?: 'workflowBranchPropertyEntity';
  accountId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  entityCode: Scalars['String'];
  fieldDescription?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldText: Scalars['String'];
  fieldType: Scalars['String'];
  fieldValueQuery?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type WorkflowBranchQueryEntity = AuditEntity & {
  __typename?: 'workflowBranchQueryEntity';
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  entityCode: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  parameters?: Maybe<Scalars['JSON']>;
  querySql: Scalars['String'];
};

export type WorkflowConfigEntity = AuditEntity & {
  __typename?: 'workflowConfigEntity';
  accountId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refTable: Scalars['String'];
  tableColumnName: Scalars['String'];
  workflowValueName: Scalars['String'];
};

export type WorkFlowEntity = AuditEntity & {
  __typename?: 'workFlowEntity';
  accountId: Scalars['String'];
  approvalPolicyAssignmentId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  submitDate: Scalars['DateTime'];
  submitterId: Scalars['String'];
  workFlowStatus: WorkFlowStatusEnum;
  workFlowSteps: Array<WorkFlowStepEntity>;
};

export enum WorkFlowStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type WorkFlowStepEntity = AuditEntity & {
  __typename?: 'workFlowStepEntity';
  accountId: Scalars['String'];
  approvalRoleId: Scalars['String'];
  approvalStatus: WorkFlowStatusEnum;
  approvedSteps: Array<WorkFlowApprovedStepEntity>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  statusRemark?: Maybe<Scalars['String']>;
  stepNo: Scalars['Float'];
  workFlow: WorkFlowEntity;
  workFlowId: Scalars['String'];
};

export type WorkProgressEntity = {
  __typename?: 'workProgressEntity';
  accountId: Scalars['String'];
  archCert: Array<ArchitectCertWorkProgressEntity>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  isCarPark: Scalars['Boolean'];
  isPackage: Scalars['Boolean'];
  isVp: Scalars['Boolean'];
  name: Scalars['String'];
  paymentPlanDetail: Array<PaymentPlanDetailEntity>;
  salePackage?: Maybe<Array<SalePackageEntity>>;
  saleRebatePackage?: Maybe<Array<SaleRebatePackageEntity>>;
  systemUse: Scalars['Boolean'];
  unitPackageAssignment: Array<UnitPackageAssignmentEntity>;
};

export type UpdateProfileMutationVariables = Exact<{
  input: UserContactInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: boolean };

export type ChangePasswordMutationVariables = Exact<{
  input: SolicitorChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'solicitorContactEntity', id: string, email?: string | null, name: string, phoneNo?: string | null, photoUrl?: string | null } };

export type RefreshTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenQuery = { __typename?: 'Query', refreshToken?: { __typename?: 'AccessTokenInterface', accessToken: string, refreshToken: string } | null };

export type LoginQueryVariables = Exact<{
  loginId: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginQuery = { __typename?: 'Query', login: { __typename?: 'solicitorUserEntity', id: string, loginId: string, accessToken?: string | null, solicitorId: string } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type GetSolicitorAccountNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSolicitorAccountNameQuery = { __typename?: 'Query', getSolicitorAccountName: string };

export type NewPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type NewPasswordMutation = { __typename?: 'Mutation', newPassword: boolean };

export type RegisterSolicitorMutationVariables = Exact<{
  input: SolicitorInput;
}>;


export type RegisterSolicitorMutation = { __typename?: 'Mutation', registerSolicitor: boolean };

export type RegisterTokenQueryVariables = Exact<{
  registerLink: Scalars['String'];
}>;


export type RegisterTokenQuery = { __typename?: 'Query', registerToken: { __typename?: 'solicitorAppointedEntity', id: string, email?: string | null, name: string, contactName?: string | null, contactEmail?: string | null } };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'Query', getProjects: Array<{ __typename?: 'projectEntity', id: string, name: string, state?: string | null, city?: string | null }> };

export type ProjectListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectListQuery = { __typename?: 'Query', getProjects: Array<{ __typename?: 'projectEntity', id: string, currency: string, name: string, minPrice?: number | null, state?: string | null, city?: string | null, firstGalleryImage?: { __typename?: 'ProjectResourceOuput', url?: string | null, caption?: string | null } | null, solicitorStatusCount: { __typename?: 'ProjectSolicitorCount', open?: number | null, signed?: number | null, total?: number | null } }> };

export type SalesQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesQuery = { __typename?: 'Query', getSaleList: Array<{ __typename?: 'soliciorListingOutput', contactId: string, contactName: string, caseStatus: string, sellingPrice: number, unitId: string, unitNo: string, bookDate: any, saleId: string, caseStatusCode?: string | null, loanAgreementStatus?: string | null, collectedDate?: any | null, stampedDate?: any | null, saleStatus: string }> };

export type GetBookingUnitDetailsQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetBookingUnitDetailsQuery = { __typename?: 'Query', GetUnitDetails: { __typename?: 'unitEntity', unitNo: string, unitStatus: string, builtUp: number, block?: string | null, price: number, facingView?: string | null, unitLayout?: { __typename?: 'unitLayoutEntity', desc: string } | null, project: { __typename?: 'projectEntity', id: string, name: string, projectAddress?: string | null, city?: string | null, state?: string | null, completionDate?: any | null, company?: { __typename?: 'companyEntity', name: string } | null }, unitType?: { __typename?: 'unitTypeEntity', name: string } | null, facingDirection?: { __typename?: 'directionEntity', name: string } | null } };

export type GetBookingPurchaserDetailsQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetBookingPurchaserDetailsQuery = { __typename?: 'Query', GetPurchaserDetails: { __typename?: 'contactEntity', fullName: string, icNo?: string | null, phoneNo?: string | null, homeTel?: string | null, officeTel?: string | null, email?: string | null, companyName?: string | null, companyRegNo?: string | null, salutation?: { __typename?: 'salutationEntity', name: string } | null, race?: { __typename?: 'raceEntity', name: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, state?: string | null, country?: string | null, city?: string | null, postCode?: string | null } | null } };

export type BookingDetailsQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type BookingDetailsQuery = { __typename?: 'Query', GetBookingDetails: { __typename?: 'saleEntity', id: string, salesNo: string, sellingPrice?: number | null, bookDate: any, spaDate?: any | null, cancelledDate?: any | null, cancelledReason?: string | null, contact: { __typename?: 'contactEntity', id: string, fullName: string, companyName?: string | null }, joinBuyer: Array<{ __typename?: 'jointBuyerEntity', id: string, commonStatus: string, contact: { __typename?: 'contactEntity', id: string, fullName: string, phoneNo?: string | null, email?: string | null } }>, bookingFeeInfo?: { __typename?: 'salePaymentEntity', remark?: string | null, amount?: number | null, paymentMethodDesc?: string | null, refNo?: string | null } | null, bookingFeeAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number }>, incomeRange?: { __typename?: 'incomeRangeEntity', id: string, range: string } | null, leadSource?: { __typename?: 'leadSourceEntity', id: string, name: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, state?: string | null, city?: string | null, postCode?: string | null } | null, unit: { __typename?: 'unitEntity', id: string, price: number, block?: string | null, unitNo: string, builtUp: number, unitLayout?: { __typename?: 'unitLayoutEntity', desc: string } | null, facingDirection?: { __typename?: 'directionEntity', name: string } | null, project: { __typename?: 'projectEntity', completionDate?: any | null } }, packageList?: Array<{ __typename?: 'packageEntity', id: string, name: string, desc?: string | null }> | null, discount: Array<{ __typename?: 'saleDiscountEntity', amount: number, discount: { __typename?: 'discountEntity', title: string } }>, cancelledByUser?: { __typename?: 'UserEntity', name?: string | null } | null } };

export type ProgressLogQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type ProgressLogQuery = { __typename?: 'Query', GetBookingDetails: { __typename?: 'saleEntity', id: string, contact: { __typename?: 'contactEntity', id: string, fullName: string }, developerSolicitor?: { __typename?: 'solicitorAppointedEntity', id: string, name: string, contactName?: string | null, contactEmail?: string | null, contactPhoneNo?: string | null } | null, unit: { __typename?: 'unitEntity', id: string, unitNo: string }, progressLogSolicitor?: Array<{ __typename?: 'ProgressLogDetails', sale_id?: string | null, name?: string | null, progresstype?: string | null, progressdesc?: string | null, progressdate?: any | null, remark?: string | null, spastatus?: string | null, logType?: string | null, appointmentDate?: any | null, spaSignedByPurchaserDate?: any | null }> | null } };

export type GetAttachmentsQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetAttachmentsQuery = { __typename?: 'Query', GetBookingDetails: { __typename?: 'saleEntity', id: string, bookingAttachments: { __typename?: 'bookingAttachmentsOutput', bookingNricAttachments?: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }> | null, bookingFeeAttachments?: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }> | null, solicitorAgreementAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }>, solicitorOthersAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }> } }, getProjectLetterForDocListing?: Array<{ __typename?: 'ESignProjectLetterListingOutput', letterTemplateId?: string | null, name?: string | null, letterType?: string | null, defaulted?: boolean | null }> | null, getFlattenMultiELetterBySaleId?: Array<{ __typename?: 'ESignProjectLetterListingOutput', letterTemplateId?: string | null, name?: string | null, letterType?: string | null, defaulted?: boolean | null }> | null };

export type GetELetterPdfQueryVariables = Exact<{
  projectId: Scalars['String'];
  letterTemplateId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetELetterPdfQuery = { __typename?: 'Query', getELetterPDF: { __typename?: 'ELetterOutput', fileName: string, content: string } };

export type AddAttachmentsMutationVariables = Exact<{
  input: SalesAddAttachmentsInput;
}>;


export type AddAttachmentsMutation = { __typename?: 'Mutation', addAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, bucketFileName: string, fileName: string, isPrivate: boolean, mediaType: string, refId: string, refTable: string, refType: string, resourceUrl: string, seqNo: number }> };

export type GetNotificationsQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications?: any | null };

export type GetProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectQuery = { __typename?: 'Query', getProject: { __typename?: 'projectEntity', id: string, name: string } };

export type DownloadAttachmentMutationVariables = Exact<{
  input: SalesDownloadAttachmentInput;
}>;


export type DownloadAttachmentMutation = { __typename?: 'Mutation', downloadAttachment: { __typename?: 'AttachmentOutput', content?: string | null, fileName?: string | null } };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment: boolean };

export type CaseStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CaseStatusQuery = { __typename?: 'Query', CaseStatus: any };

export type LoanAgreementStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanAgreementStatusQuery = { __typename?: 'Query', LoanAgreementStatus: any };

export type UpdateStatusMutationVariables = Exact<{
  input: SalesUpdateStatusInput;
}>;


export type UpdateStatusMutation = { __typename?: 'Mutation', updateStatus: boolean };

export type UpdateLoanAgreementStatusMutationVariables = Exact<{
  input: UpdateLoanAgreementStatusInput;
}>;


export type UpdateLoanAgreementStatusMutation = { __typename?: 'Mutation', updateLoanAgreementStatus: boolean };

export type MarkAllReadQueryVariables = Exact<{ [key: string]: never; }>;


export type MarkAllReadQuery = { __typename?: 'Query', markAllRead: boolean };

export type MarkAsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type MarkAsReadMutation = { __typename?: 'Mutation', markAsRead: boolean };

export type NotificationPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPermissionQuery = { __typename?: 'Query', getNotificationPermission: any };

export type GetUserNotificationPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationPermissionQuery = { __typename?: 'Query', getUserNotificationPermission?: Array<string> | null };

export type GetNotificationHistoryDayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationHistoryDayQuery = { __typename?: 'Query', getNotificationHistoryDay?: number | null };

export type SaveNotificationPermissionMutationVariables = Exact<{
  input: NotificationInput;
}>;


export type SaveNotificationPermissionMutation = { __typename?: 'Mutation', saveNotificationPermission: boolean };

export type SolicitorStaffListQueryVariables = Exact<{ [key: string]: never; }>;


export type SolicitorStaffListQuery = { __typename?: 'Query', getStaff?: Array<{ __typename?: 'solicitorContactEntity', id: string, name: string, userId: string, email?: string | null, phoneNo?: string | null, isSuspendible: boolean, user: { __typename?: 'solicitorUserEntity', commonStatus: string, activated: boolean } }> | null };

export type StaffDetailQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type StaffDetailQuery = { __typename?: 'Query', getStaffById: { __typename?: 'solicitorContactEntity', name: string, email?: string | null, phoneNo?: string | null, user: { __typename?: 'solicitorUserEntity', activated: boolean } } };

export type AlterStaffAccessMutationVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type AlterStaffAccessMutation = { __typename?: 'Mutation', alterStaffAccess: boolean };

export type AddStaffMutationVariables = Exact<{
  input: AddStaffInput;
}>;


export type AddStaffMutation = { __typename?: 'Mutation', addStaff: boolean };

export type EditStaffMutationVariables = Exact<{
  input: EditStaffInput;
}>;


export type EditStaffMutation = { __typename?: 'Mutation', editStaff: boolean };

export type ResendInvitationEmailMutationVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type ResendInvitationEmailMutation = { __typename?: 'Mutation', resendInvitationEmail: boolean };


export const UpdateProfileDocument = gql`
    mutation updateProfile($input: UserContactInput!) {
  updateProfile(input: $input)
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: SolicitorChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ProfileDocument = gql`
    query profile {
  profile {
    id
    email
    name
    phoneNo
    photoUrl
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const RefreshTokenDocument = gql`
    query refreshToken {
  refreshToken {
    accessToken
    refreshToken
  }
}
    `;

/**
 * __useRefreshTokenQuery__
 *
 * To run a query within a React component, call `useRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenQuery(baseOptions?: Apollo.QueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
      }
export function useRefreshTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
        }
export type RefreshTokenQueryHookResult = ReturnType<typeof useRefreshTokenQuery>;
export type RefreshTokenLazyQueryHookResult = ReturnType<typeof useRefreshTokenLazyQuery>;
export type RefreshTokenQueryResult = Apollo.QueryResult<RefreshTokenQuery, RefreshTokenQueryVariables>;
export const LoginDocument = gql`
    query login($loginId: String!, $password: String!) {
  login(LoginId: $loginId, Password: $password) {
    id
    loginId
    accessToken
    solicitorId
  }
}
    `;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      loginId: // value for 'loginId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginQueryResult = Apollo.QueryResult<LoginQuery, LoginQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(Email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetSolicitorAccountNameDocument = gql`
    query getSolicitorAccountName {
  getSolicitorAccountName
}
    `;

/**
 * __useGetSolicitorAccountNameQuery__
 *
 * To run a query within a React component, call `useGetSolicitorAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSolicitorAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSolicitorAccountNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSolicitorAccountNameQuery(baseOptions?: Apollo.QueryHookOptions<GetSolicitorAccountNameQuery, GetSolicitorAccountNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSolicitorAccountNameQuery, GetSolicitorAccountNameQueryVariables>(GetSolicitorAccountNameDocument, options);
      }
export function useGetSolicitorAccountNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSolicitorAccountNameQuery, GetSolicitorAccountNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSolicitorAccountNameQuery, GetSolicitorAccountNameQueryVariables>(GetSolicitorAccountNameDocument, options);
        }
export type GetSolicitorAccountNameQueryHookResult = ReturnType<typeof useGetSolicitorAccountNameQuery>;
export type GetSolicitorAccountNameLazyQueryHookResult = ReturnType<typeof useGetSolicitorAccountNameLazyQuery>;
export type GetSolicitorAccountNameQueryResult = Apollo.QueryResult<GetSolicitorAccountNameQuery, GetSolicitorAccountNameQueryVariables>;
export const NewPasswordDocument = gql`
    mutation newPassword($newPassword: String!, $confirmPassword: String!) {
  newPassword(newPassword: $newPassword, confirmPassword: $confirmPassword)
}
    `;
export type NewPasswordMutationFn = Apollo.MutationFunction<NewPasswordMutation, NewPasswordMutationVariables>;

/**
 * __useNewPasswordMutation__
 *
 * To run a mutation, you first call `useNewPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newPasswordMutation, { data, loading, error }] = useNewPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useNewPasswordMutation(baseOptions?: Apollo.MutationHookOptions<NewPasswordMutation, NewPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewPasswordMutation, NewPasswordMutationVariables>(NewPasswordDocument, options);
      }
export type NewPasswordMutationHookResult = ReturnType<typeof useNewPasswordMutation>;
export type NewPasswordMutationResult = Apollo.MutationResult<NewPasswordMutation>;
export type NewPasswordMutationOptions = Apollo.BaseMutationOptions<NewPasswordMutation, NewPasswordMutationVariables>;
export const RegisterSolicitorDocument = gql`
    mutation registerSolicitor($input: SolicitorInput!) {
  registerSolicitor(input: $input)
}
    `;
export type RegisterSolicitorMutationFn = Apollo.MutationFunction<RegisterSolicitorMutation, RegisterSolicitorMutationVariables>;

/**
 * __useRegisterSolicitorMutation__
 *
 * To run a mutation, you first call `useRegisterSolicitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterSolicitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerSolicitorMutation, { data, loading, error }] = useRegisterSolicitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterSolicitorMutation(baseOptions?: Apollo.MutationHookOptions<RegisterSolicitorMutation, RegisterSolicitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterSolicitorMutation, RegisterSolicitorMutationVariables>(RegisterSolicitorDocument, options);
      }
export type RegisterSolicitorMutationHookResult = ReturnType<typeof useRegisterSolicitorMutation>;
export type RegisterSolicitorMutationResult = Apollo.MutationResult<RegisterSolicitorMutation>;
export type RegisterSolicitorMutationOptions = Apollo.BaseMutationOptions<RegisterSolicitorMutation, RegisterSolicitorMutationVariables>;
export const RegisterTokenDocument = gql`
    query registerToken($registerLink: String!) {
  registerToken(register_link: $registerLink) {
    id
    email
    name
    contactName
    contactEmail
  }
}
    `;

/**
 * __useRegisterTokenQuery__
 *
 * To run a query within a React component, call `useRegisterTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterTokenQuery({
 *   variables: {
 *      registerLink: // value for 'registerLink'
 *   },
 * });
 */
export function useRegisterTokenQuery(baseOptions: Apollo.QueryHookOptions<RegisterTokenQuery, RegisterTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisterTokenQuery, RegisterTokenQueryVariables>(RegisterTokenDocument, options);
      }
export function useRegisterTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisterTokenQuery, RegisterTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisterTokenQuery, RegisterTokenQueryVariables>(RegisterTokenDocument, options);
        }
export type RegisterTokenQueryHookResult = ReturnType<typeof useRegisterTokenQuery>;
export type RegisterTokenLazyQueryHookResult = ReturnType<typeof useRegisterTokenLazyQuery>;
export type RegisterTokenQueryResult = Apollo.QueryResult<RegisterTokenQuery, RegisterTokenQueryVariables>;
export const ProjectsDocument = gql`
    query projects {
  getProjects {
    id
    name
    state
    city
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectListDocument = gql`
    query projectList {
  getProjects {
    id
    currency
    name
    firstGalleryImage {
      url
      caption
    }
    minPrice
    state
    city
    solicitorStatusCount {
      open
      signed
      total
    }
  }
}
    `;

/**
 * __useProjectListQuery__
 *
 * To run a query within a React component, call `useProjectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectListQuery(baseOptions?: Apollo.QueryHookOptions<ProjectListQuery, ProjectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectListQuery, ProjectListQueryVariables>(ProjectListDocument, options);
      }
export function useProjectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectListQuery, ProjectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectListQuery, ProjectListQueryVariables>(ProjectListDocument, options);
        }
export type ProjectListQueryHookResult = ReturnType<typeof useProjectListQuery>;
export type ProjectListLazyQueryHookResult = ReturnType<typeof useProjectListLazyQuery>;
export type ProjectListQueryResult = Apollo.QueryResult<ProjectListQuery, ProjectListQueryVariables>;
export const SalesDocument = gql`
    query sales {
  getSaleList {
    contactId
    contactName
    caseStatus
    sellingPrice
    unitId
    unitNo
    bookDate
    saleId
    caseStatusCode
    loanAgreementStatus
    collectedDate
    stampedDate
    saleStatus
  }
}
    `;

/**
 * __useSalesQuery__
 *
 * To run a query within a React component, call `useSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesQuery(baseOptions?: Apollo.QueryHookOptions<SalesQuery, SalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesQuery, SalesQueryVariables>(SalesDocument, options);
      }
export function useSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesQuery, SalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesQuery, SalesQueryVariables>(SalesDocument, options);
        }
export type SalesQueryHookResult = ReturnType<typeof useSalesQuery>;
export type SalesLazyQueryHookResult = ReturnType<typeof useSalesLazyQuery>;
export type SalesQueryResult = Apollo.QueryResult<SalesQuery, SalesQueryVariables>;
export const GetBookingUnitDetailsDocument = gql`
    query getBookingUnitDetails($unitId: String!) {
  GetUnitDetails(unitId: $unitId) {
    unitNo
    unitStatus
    builtUp
    unitLayout {
      desc
    }
    project {
      id
      name
      projectAddress
      city
      state
      completionDate
      company {
        name
      }
    }
    block
    unitNo
    price
    unitType {
      name
    }
    facingDirection {
      name
    }
    facingView
  }
}
    `;

/**
 * __useGetBookingUnitDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookingUnitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingUnitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingUnitDetailsQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetBookingUnitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingUnitDetailsQuery, GetBookingUnitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingUnitDetailsQuery, GetBookingUnitDetailsQueryVariables>(GetBookingUnitDetailsDocument, options);
      }
export function useGetBookingUnitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingUnitDetailsQuery, GetBookingUnitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingUnitDetailsQuery, GetBookingUnitDetailsQueryVariables>(GetBookingUnitDetailsDocument, options);
        }
export type GetBookingUnitDetailsQueryHookResult = ReturnType<typeof useGetBookingUnitDetailsQuery>;
export type GetBookingUnitDetailsLazyQueryHookResult = ReturnType<typeof useGetBookingUnitDetailsLazyQuery>;
export type GetBookingUnitDetailsQueryResult = Apollo.QueryResult<GetBookingUnitDetailsQuery, GetBookingUnitDetailsQueryVariables>;
export const GetBookingPurchaserDetailsDocument = gql`
    query getBookingPurchaserDetails($contactId: String!) {
  GetPurchaserDetails(contactId: $contactId) {
    fullName
    icNo
    salutation {
      name
    }
    race {
      name
    }
    nationality {
      name
    }
    maritalStatus {
      name
    }
    address {
      address
      state
      country
      city
      postCode
    }
    phoneNo
    homeTel
    officeTel
    email
    companyName
    companyRegNo
  }
}
    `;

/**
 * __useGetBookingPurchaserDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookingPurchaserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPurchaserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPurchaserDetailsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetBookingPurchaserDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPurchaserDetailsQuery, GetBookingPurchaserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPurchaserDetailsQuery, GetBookingPurchaserDetailsQueryVariables>(GetBookingPurchaserDetailsDocument, options);
      }
export function useGetBookingPurchaserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPurchaserDetailsQuery, GetBookingPurchaserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPurchaserDetailsQuery, GetBookingPurchaserDetailsQueryVariables>(GetBookingPurchaserDetailsDocument, options);
        }
export type GetBookingPurchaserDetailsQueryHookResult = ReturnType<typeof useGetBookingPurchaserDetailsQuery>;
export type GetBookingPurchaserDetailsLazyQueryHookResult = ReturnType<typeof useGetBookingPurchaserDetailsLazyQuery>;
export type GetBookingPurchaserDetailsQueryResult = Apollo.QueryResult<GetBookingPurchaserDetailsQuery, GetBookingPurchaserDetailsQueryVariables>;
export const BookingDetailsDocument = gql`
    query bookingDetails($saleId: String!) {
  GetBookingDetails(sale_id: $saleId) {
    id
    salesNo
    sellingPrice
    bookDate
    spaDate
    contact {
      id
      fullName
      companyName
    }
    joinBuyer {
      id
      commonStatus
      contact {
        id
        fullName
        phoneNo
        email
      }
    }
    bookingFeeInfo {
      remark
      amount
      paymentMethodDesc
      refNo
    }
    bookingFeeAttachments {
      id
      accountId
      refTable
      refId
      refType
      mediaType
      resourceUrl
      fileName
      bucketFileName
      isPrivate
      seqNo
    }
    incomeRange {
      id
      range
    }
    leadSource {
      id
      name
    }
    address {
      address
      country
      state
      city
      postCode
    }
    unit {
      id
      price
      block
      unitNo
      builtUp
      unitLayout {
        desc
      }
      facingDirection {
        name
      }
      project {
        completionDate
      }
    }
    packageList {
      id
      name
      desc
    }
    discount {
      discount {
        title
      }
      amount
    }
    cancelledByUser {
      name
    }
    cancelledDate
    cancelledReason
  }
}
    `;

/**
 * __useBookingDetailsQuery__
 *
 * To run a query within a React component, call `useBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDetailsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useBookingDetailsQuery(baseOptions: Apollo.QueryHookOptions<BookingDetailsQuery, BookingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingDetailsQuery, BookingDetailsQueryVariables>(BookingDetailsDocument, options);
      }
export function useBookingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingDetailsQuery, BookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingDetailsQuery, BookingDetailsQueryVariables>(BookingDetailsDocument, options);
        }
export type BookingDetailsQueryHookResult = ReturnType<typeof useBookingDetailsQuery>;
export type BookingDetailsLazyQueryHookResult = ReturnType<typeof useBookingDetailsLazyQuery>;
export type BookingDetailsQueryResult = Apollo.QueryResult<BookingDetailsQuery, BookingDetailsQueryVariables>;
export const ProgressLogDocument = gql`
    query progressLog($saleId: String!) {
  GetBookingDetails(sale_id: $saleId) {
    id
    contact {
      id
      fullName
    }
    developerSolicitor {
      id
      name
      contactName
      contactEmail
      contactPhoneNo
    }
    unit {
      id
      unitNo
    }
    progressLogSolicitor {
      sale_id
      name
      progresstype
      progressdesc
      progressdate
      remark
      spastatus
      logType
      appointmentDate
      spaSignedByPurchaserDate
    }
  }
}
    `;

/**
 * __useProgressLogQuery__
 *
 * To run a query within a React component, call `useProgressLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressLogQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useProgressLogQuery(baseOptions: Apollo.QueryHookOptions<ProgressLogQuery, ProgressLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgressLogQuery, ProgressLogQueryVariables>(ProgressLogDocument, options);
      }
export function useProgressLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgressLogQuery, ProgressLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgressLogQuery, ProgressLogQueryVariables>(ProgressLogDocument, options);
        }
export type ProgressLogQueryHookResult = ReturnType<typeof useProgressLogQuery>;
export type ProgressLogLazyQueryHookResult = ReturnType<typeof useProgressLogLazyQuery>;
export type ProgressLogQueryResult = Apollo.QueryResult<ProgressLogQuery, ProgressLogQueryVariables>;
export const GetAttachmentsDocument = gql`
    query getAttachments($saleId: String!) {
  GetBookingDetails(sale_id: $saleId) {
    id
    bookingAttachments {
      bookingNricAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      bookingFeeAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      solicitorAgreementAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      solicitorOthersAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
    }
  }
  getProjectLetterForDocListing(saleId: $saleId) {
    letterTemplateId
    name
    letterType
    defaulted
  }
  getFlattenMultiELetterBySaleId(saleId: $saleId) {
    letterTemplateId
    name
    letterType
    defaulted
  }
}
    `;

/**
 * __useGetAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentsQuery, GetAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentsQuery, GetAttachmentsQueryVariables>(GetAttachmentsDocument, options);
      }
export function useGetAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentsQuery, GetAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentsQuery, GetAttachmentsQueryVariables>(GetAttachmentsDocument, options);
        }
export type GetAttachmentsQueryHookResult = ReturnType<typeof useGetAttachmentsQuery>;
export type GetAttachmentsLazyQueryHookResult = ReturnType<typeof useGetAttachmentsLazyQuery>;
export type GetAttachmentsQueryResult = Apollo.QueryResult<GetAttachmentsQuery, GetAttachmentsQueryVariables>;
export const GetELetterPdfDocument = gql`
    query getELetterPDF($projectId: String!, $letterTemplateId: String!, $saleId: String!) {
  getELetterPDF(projectId: $projectId, letterTemplateId: $letterTemplateId, saleId: $saleId) {
    fileName
    content
  }
}
    `;

/**
 * __useGetELetterPdfQuery__
 *
 * To run a query within a React component, call `useGetELetterPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetELetterPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetELetterPdfQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      letterTemplateId: // value for 'letterTemplateId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetELetterPdfQuery(baseOptions: Apollo.QueryHookOptions<GetELetterPdfQuery, GetELetterPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetELetterPdfQuery, GetELetterPdfQueryVariables>(GetELetterPdfDocument, options);
      }
export function useGetELetterPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetELetterPdfQuery, GetELetterPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetELetterPdfQuery, GetELetterPdfQueryVariables>(GetELetterPdfDocument, options);
        }
export type GetELetterPdfQueryHookResult = ReturnType<typeof useGetELetterPdfQuery>;
export type GetELetterPdfLazyQueryHookResult = ReturnType<typeof useGetELetterPdfLazyQuery>;
export type GetELetterPdfQueryResult = Apollo.QueryResult<GetELetterPdfQuery, GetELetterPdfQueryVariables>;
export const AddAttachmentsDocument = gql`
    mutation addAttachments($input: SalesAddAttachmentsInput!) {
  addAttachments(input: $input) {
    id
    accountId
    bucketFileName
    fileName
    isPrivate
    mediaType
    refId
    refTable
    refType
    resourceUrl
    seqNo
  }
}
    `;
export type AddAttachmentsMutationFn = Apollo.MutationFunction<AddAttachmentsMutation, AddAttachmentsMutationVariables>;

/**
 * __useAddAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttachmentsMutation, { data, loading, error }] = useAddAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddAttachmentsMutation, AddAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttachmentsMutation, AddAttachmentsMutationVariables>(AddAttachmentsDocument, options);
      }
export type AddAttachmentsMutationHookResult = ReturnType<typeof useAddAttachmentsMutation>;
export type AddAttachmentsMutationResult = Apollo.MutationResult<AddAttachmentsMutation>;
export type AddAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddAttachmentsMutation, AddAttachmentsMutationVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($limit: Float!, $page: Float!, $search: String) {
  getNotifications(limit: $limit, page: $page, search: $search)
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetProjectDocument = gql`
    query getProject {
  getProject {
    id
    name
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const DownloadAttachmentDocument = gql`
    mutation downloadAttachment($input: SalesDownloadAttachmentInput!) {
  downloadAttachment(input: $input) {
    content
    fileName
  }
}
    `;
export type DownloadAttachmentMutationFn = Apollo.MutationFunction<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>;

/**
 * __useDownloadAttachmentMutation__
 *
 * To run a mutation, you first call `useDownloadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAttachmentMutation, { data, loading, error }] = useDownloadAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>(DownloadAttachmentDocument, options);
      }
export type DownloadAttachmentMutationHookResult = ReturnType<typeof useDownloadAttachmentMutation>;
export type DownloadAttachmentMutationResult = Apollo.MutationResult<DownloadAttachmentMutation>;
export type DownloadAttachmentMutationOptions = Apollo.BaseMutationOptions<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation deleteAttachment($attachmentId: String!) {
  deleteAttachment(attachmentId: $attachmentId)
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const CaseStatusDocument = gql`
    query CaseStatus {
  CaseStatus
}
    `;

/**
 * __useCaseStatusQuery__
 *
 * To run a query within a React component, call `useCaseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCaseStatusQuery(baseOptions?: Apollo.QueryHookOptions<CaseStatusQuery, CaseStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseStatusQuery, CaseStatusQueryVariables>(CaseStatusDocument, options);
      }
export function useCaseStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseStatusQuery, CaseStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseStatusQuery, CaseStatusQueryVariables>(CaseStatusDocument, options);
        }
export type CaseStatusQueryHookResult = ReturnType<typeof useCaseStatusQuery>;
export type CaseStatusLazyQueryHookResult = ReturnType<typeof useCaseStatusLazyQuery>;
export type CaseStatusQueryResult = Apollo.QueryResult<CaseStatusQuery, CaseStatusQueryVariables>;
export const LoanAgreementStatusDocument = gql`
    query LoanAgreementStatus {
  LoanAgreementStatus
}
    `;

/**
 * __useLoanAgreementStatusQuery__
 *
 * To run a query within a React component, call `useLoanAgreementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanAgreementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanAgreementStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoanAgreementStatusQuery(baseOptions?: Apollo.QueryHookOptions<LoanAgreementStatusQuery, LoanAgreementStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanAgreementStatusQuery, LoanAgreementStatusQueryVariables>(LoanAgreementStatusDocument, options);
      }
export function useLoanAgreementStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanAgreementStatusQuery, LoanAgreementStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanAgreementStatusQuery, LoanAgreementStatusQueryVariables>(LoanAgreementStatusDocument, options);
        }
export type LoanAgreementStatusQueryHookResult = ReturnType<typeof useLoanAgreementStatusQuery>;
export type LoanAgreementStatusLazyQueryHookResult = ReturnType<typeof useLoanAgreementStatusLazyQuery>;
export type LoanAgreementStatusQueryResult = Apollo.QueryResult<LoanAgreementStatusQuery, LoanAgreementStatusQueryVariables>;
export const UpdateStatusDocument = gql`
    mutation updateStatus($input: SalesUpdateStatusInput!) {
  updateStatus(input: $input)
}
    `;
export type UpdateStatusMutationFn = Apollo.MutationFunction<UpdateStatusMutation, UpdateStatusMutationVariables>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusMutation, UpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument, options);
      }
export type UpdateStatusMutationHookResult = ReturnType<typeof useUpdateStatusMutation>;
export type UpdateStatusMutationResult = Apollo.MutationResult<UpdateStatusMutation>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const UpdateLoanAgreementStatusDocument = gql`
    mutation updateLoanAgreementStatus($input: UpdateLoanAgreementStatusInput!) {
  updateLoanAgreementStatus(input: $input)
}
    `;
export type UpdateLoanAgreementStatusMutationFn = Apollo.MutationFunction<UpdateLoanAgreementStatusMutation, UpdateLoanAgreementStatusMutationVariables>;

/**
 * __useUpdateLoanAgreementStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLoanAgreementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanAgreementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanAgreementStatusMutation, { data, loading, error }] = useUpdateLoanAgreementStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLoanAgreementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanAgreementStatusMutation, UpdateLoanAgreementStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanAgreementStatusMutation, UpdateLoanAgreementStatusMutationVariables>(UpdateLoanAgreementStatusDocument, options);
      }
export type UpdateLoanAgreementStatusMutationHookResult = ReturnType<typeof useUpdateLoanAgreementStatusMutation>;
export type UpdateLoanAgreementStatusMutationResult = Apollo.MutationResult<UpdateLoanAgreementStatusMutation>;
export type UpdateLoanAgreementStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLoanAgreementStatusMutation, UpdateLoanAgreementStatusMutationVariables>;
export const MarkAllReadDocument = gql`
    query markAllRead {
  markAllRead
}
    `;

/**
 * __useMarkAllReadQuery__
 *
 * To run a query within a React component, call `useMarkAllReadQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkAllReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkAllReadQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllReadQuery(baseOptions?: Apollo.QueryHookOptions<MarkAllReadQuery, MarkAllReadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkAllReadQuery, MarkAllReadQueryVariables>(MarkAllReadDocument, options);
      }
export function useMarkAllReadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkAllReadQuery, MarkAllReadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkAllReadQuery, MarkAllReadQueryVariables>(MarkAllReadDocument, options);
        }
export type MarkAllReadQueryHookResult = ReturnType<typeof useMarkAllReadQuery>;
export type MarkAllReadLazyQueryHookResult = ReturnType<typeof useMarkAllReadLazyQuery>;
export type MarkAllReadQueryResult = Apollo.QueryResult<MarkAllReadQuery, MarkAllReadQueryVariables>;
export const MarkAsReadDocument = gql`
    mutation markAsRead($notificationIds: [String!]!) {
  markAsRead(notificationIds: $notificationIds)
}
    `;
export type MarkAsReadMutationFn = Apollo.MutationFunction<MarkAsReadMutation, MarkAsReadMutationVariables>;

/**
 * __useMarkAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsReadMutation, { data, loading, error }] = useMarkAsReadMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsReadMutation, MarkAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsReadMutation, MarkAsReadMutationVariables>(MarkAsReadDocument, options);
      }
export type MarkAsReadMutationHookResult = ReturnType<typeof useMarkAsReadMutation>;
export type MarkAsReadMutationResult = Apollo.MutationResult<MarkAsReadMutation>;
export type MarkAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAsReadMutation, MarkAsReadMutationVariables>;
export const NotificationPermissionDocument = gql`
    query notificationPermission {
  getNotificationPermission
}
    `;

/**
 * __useNotificationPermissionQuery__
 *
 * To run a query within a React component, call `useNotificationPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPermissionQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPermissionQuery, NotificationPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPermissionQuery, NotificationPermissionQueryVariables>(NotificationPermissionDocument, options);
      }
export function useNotificationPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPermissionQuery, NotificationPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPermissionQuery, NotificationPermissionQueryVariables>(NotificationPermissionDocument, options);
        }
export type NotificationPermissionQueryHookResult = ReturnType<typeof useNotificationPermissionQuery>;
export type NotificationPermissionLazyQueryHookResult = ReturnType<typeof useNotificationPermissionLazyQuery>;
export type NotificationPermissionQueryResult = Apollo.QueryResult<NotificationPermissionQuery, NotificationPermissionQueryVariables>;
export const GetUserNotificationPermissionDocument = gql`
    query getUserNotificationPermission {
  getUserNotificationPermission
}
    `;

/**
 * __useGetUserNotificationPermissionQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationPermissionQuery, GetUserNotificationPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationPermissionQuery, GetUserNotificationPermissionQueryVariables>(GetUserNotificationPermissionDocument, options);
      }
export function useGetUserNotificationPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationPermissionQuery, GetUserNotificationPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationPermissionQuery, GetUserNotificationPermissionQueryVariables>(GetUserNotificationPermissionDocument, options);
        }
export type GetUserNotificationPermissionQueryHookResult = ReturnType<typeof useGetUserNotificationPermissionQuery>;
export type GetUserNotificationPermissionLazyQueryHookResult = ReturnType<typeof useGetUserNotificationPermissionLazyQuery>;
export type GetUserNotificationPermissionQueryResult = Apollo.QueryResult<GetUserNotificationPermissionQuery, GetUserNotificationPermissionQueryVariables>;
export const GetNotificationHistoryDayDocument = gql`
    query getNotificationHistoryDay {
  getNotificationHistoryDay
}
    `;

/**
 * __useGetNotificationHistoryDayQuery__
 *
 * To run a query within a React component, call `useGetNotificationHistoryDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationHistoryDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationHistoryDayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationHistoryDayQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>(GetNotificationHistoryDayDocument, options);
      }
export function useGetNotificationHistoryDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>(GetNotificationHistoryDayDocument, options);
        }
export type GetNotificationHistoryDayQueryHookResult = ReturnType<typeof useGetNotificationHistoryDayQuery>;
export type GetNotificationHistoryDayLazyQueryHookResult = ReturnType<typeof useGetNotificationHistoryDayLazyQuery>;
export type GetNotificationHistoryDayQueryResult = Apollo.QueryResult<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>;
export const SaveNotificationPermissionDocument = gql`
    mutation saveNotificationPermission($input: NotificationInput!) {
  saveNotificationPermission(input: $input)
}
    `;
export type SaveNotificationPermissionMutationFn = Apollo.MutationFunction<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>;

/**
 * __useSaveNotificationPermissionMutation__
 *
 * To run a mutation, you first call `useSaveNotificationPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationPermissionMutation, { data, loading, error }] = useSaveNotificationPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNotificationPermissionMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>(SaveNotificationPermissionDocument, options);
      }
export type SaveNotificationPermissionMutationHookResult = ReturnType<typeof useSaveNotificationPermissionMutation>;
export type SaveNotificationPermissionMutationResult = Apollo.MutationResult<SaveNotificationPermissionMutation>;
export type SaveNotificationPermissionMutationOptions = Apollo.BaseMutationOptions<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>;
export const SolicitorStaffListDocument = gql`
    query solicitorStaffList {
  getStaff {
    id
    name
    userId
    email
    phoneNo
    isSuspendible
    user {
      commonStatus
      activated
    }
  }
}
    `;

/**
 * __useSolicitorStaffListQuery__
 *
 * To run a query within a React component, call `useSolicitorStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitorStaffListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSolicitorStaffListQuery(baseOptions?: Apollo.QueryHookOptions<SolicitorStaffListQuery, SolicitorStaffListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolicitorStaffListQuery, SolicitorStaffListQueryVariables>(SolicitorStaffListDocument, options);
      }
export function useSolicitorStaffListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolicitorStaffListQuery, SolicitorStaffListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolicitorStaffListQuery, SolicitorStaffListQueryVariables>(SolicitorStaffListDocument, options);
        }
export type SolicitorStaffListQueryHookResult = ReturnType<typeof useSolicitorStaffListQuery>;
export type SolicitorStaffListLazyQueryHookResult = ReturnType<typeof useSolicitorStaffListLazyQuery>;
export type SolicitorStaffListQueryResult = Apollo.QueryResult<SolicitorStaffListQuery, SolicitorStaffListQueryVariables>;
export const StaffDetailDocument = gql`
    query staffDetail($contactId: String!) {
  getStaffById(contactId: $contactId) {
    name
    email
    phoneNo
    user {
      activated
    }
  }
}
    `;

/**
 * __useStaffDetailQuery__
 *
 * To run a query within a React component, call `useStaffDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffDetailQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useStaffDetailQuery(baseOptions: Apollo.QueryHookOptions<StaffDetailQuery, StaffDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaffDetailQuery, StaffDetailQueryVariables>(StaffDetailDocument, options);
      }
export function useStaffDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffDetailQuery, StaffDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaffDetailQuery, StaffDetailQueryVariables>(StaffDetailDocument, options);
        }
export type StaffDetailQueryHookResult = ReturnType<typeof useStaffDetailQuery>;
export type StaffDetailLazyQueryHookResult = ReturnType<typeof useStaffDetailLazyQuery>;
export type StaffDetailQueryResult = Apollo.QueryResult<StaffDetailQuery, StaffDetailQueryVariables>;
export const AlterStaffAccessDocument = gql`
    mutation alterStaffAccess($contactId: String!) {
  alterStaffAccess(contactId: $contactId)
}
    `;
export type AlterStaffAccessMutationFn = Apollo.MutationFunction<AlterStaffAccessMutation, AlterStaffAccessMutationVariables>;

/**
 * __useAlterStaffAccessMutation__
 *
 * To run a mutation, you first call `useAlterStaffAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterStaffAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterStaffAccessMutation, { data, loading, error }] = useAlterStaffAccessMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useAlterStaffAccessMutation(baseOptions?: Apollo.MutationHookOptions<AlterStaffAccessMutation, AlterStaffAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlterStaffAccessMutation, AlterStaffAccessMutationVariables>(AlterStaffAccessDocument, options);
      }
export type AlterStaffAccessMutationHookResult = ReturnType<typeof useAlterStaffAccessMutation>;
export type AlterStaffAccessMutationResult = Apollo.MutationResult<AlterStaffAccessMutation>;
export type AlterStaffAccessMutationOptions = Apollo.BaseMutationOptions<AlterStaffAccessMutation, AlterStaffAccessMutationVariables>;
export const AddStaffDocument = gql`
    mutation addStaff($input: AddStaffInput!) {
  addStaff(input: $input)
}
    `;
export type AddStaffMutationFn = Apollo.MutationFunction<AddStaffMutation, AddStaffMutationVariables>;

/**
 * __useAddStaffMutation__
 *
 * To run a mutation, you first call `useAddStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStaffMutation, { data, loading, error }] = useAddStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStaffMutation(baseOptions?: Apollo.MutationHookOptions<AddStaffMutation, AddStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStaffMutation, AddStaffMutationVariables>(AddStaffDocument, options);
      }
export type AddStaffMutationHookResult = ReturnType<typeof useAddStaffMutation>;
export type AddStaffMutationResult = Apollo.MutationResult<AddStaffMutation>;
export type AddStaffMutationOptions = Apollo.BaseMutationOptions<AddStaffMutation, AddStaffMutationVariables>;
export const EditStaffDocument = gql`
    mutation editStaff($input: EditStaffInput!) {
  editStaff(input: $input)
}
    `;
export type EditStaffMutationFn = Apollo.MutationFunction<EditStaffMutation, EditStaffMutationVariables>;

/**
 * __useEditStaffMutation__
 *
 * To run a mutation, you first call `useEditStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStaffMutation, { data, loading, error }] = useEditStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditStaffMutation(baseOptions?: Apollo.MutationHookOptions<EditStaffMutation, EditStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStaffMutation, EditStaffMutationVariables>(EditStaffDocument, options);
      }
export type EditStaffMutationHookResult = ReturnType<typeof useEditStaffMutation>;
export type EditStaffMutationResult = Apollo.MutationResult<EditStaffMutation>;
export type EditStaffMutationOptions = Apollo.BaseMutationOptions<EditStaffMutation, EditStaffMutationVariables>;
export const ResendInvitationEmailDocument = gql`
    mutation resendInvitationEmail($contactId: String!) {
  resendInvitationEmail(contactID: $contactId)
}
    `;
export type ResendInvitationEmailMutationFn = Apollo.MutationFunction<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;

/**
 * __useResendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationEmailMutation, { data, loading, error }] = useResendInvitationEmailMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useResendInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>(ResendInvitationEmailDocument, options);
      }
export type ResendInvitationEmailMutationHookResult = ReturnType<typeof useResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationResult = Apollo.MutationResult<ResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;